{
  "brand": {
    "entity": "Heraion",
    "product": "Metria"
  },
  "createHub": {
    "title": "Créer",
    "open": "Créer",
    "close": "Fermer",
    "actionsHeader": "Démarrer",
    "todayHeader": "Aujourd'hui",
    "newWorkout": {
      "title": "Nouvel entraînement",
      "sub": "Commencer un entraînement vierge maintenant"
    },
    "repeatWorkout": {
      "title": "Répéter un entraînement",
      "sub": "Enregistrer depuis un entraînement passé"
    },
    "buildToday": {
      "title": "Construire la séance du jour",
      "sub": "Des exercices pour les muscles sous le volume minimum",
      "subInstead": "À la place du plan du jour : les muscles sous le volume minimum"
    },
    "planProgram": {
      "title": "Planifier un programme",
      "sub": "Créer un programme sur plusieurs semaines"
    },
    "planWorkout": {
      "title": "Planifier un entraînement",
      "sub": "Préparer une seule séance pour plus tard"
    }
  },
  "library": {
    "header": "Parcourir",
    "tabPrograms": "Programmes",
    "tabWorkouts": "Entraînements",
    "tabPersonal": "À moi",
    "tabCoach": "Coach",
    "tabFavorites": "Favoris",
    "favoriteA11y": "Favori",
    "errFavorite": "Impossible de mettre à jour les favoris.",
    "emptyFavoritesTitle": "Pas encore de favoris",
    "emptyFavoritesSub": "Ajoute une étoile à un programme ou un entraînement pour le retrouver ici.",
    "sectionOfficial": "Par $t(brand.product)",
    "sectionPersonal": "À moi",
    "clone": "Cloner",
    "copySuffix": "(copie)",
    "following": "Suivi en cours…",
    "alreadyYours": "Déjà à vous",
    "cloneFollowed": "En faire le vôtre",
    "followed": "« {{name}} » suivi.",
    "searchPlaceholder": "Rechercher par nom…",
    "filters": "Filtres",
    "clearFilters": "Effacer",
    "axisLevel": "Niveau",
    "axisPerWeek": "Séances / semaine",
    "noResultsTitle": "Aucun résultat",
    "noResultsSub": "Modifie la recherche ou les filtres.",
    "loading": "Chargement de la bibliothèque…",
    "errLoad": "Impossible de charger la bibliothèque.",
    "errClone": "Le clonage a échoué. Réessaie.",
    "errDelete": "La suppression a échoué. Réessaie.",
    "leaveTitle": "Retirer de ta bibliothèque ?",
    "leaveBody_one": "{{name}} est aussi assigné à {{count}} autre personne. Elle le garde : ceci ne fait que le retirer de ta bibliothèque.",
    "leaveBody_other": "{{name}} est aussi assigné à {{count}} autres personnes. Elles le gardent : ceci ne fait que le retirer de ta bibliothèque.",
    "leaveConfirm": "Retirer",
    "errLeave": "Impossible de le retirer de ta bibliothèque. Réessaie.",
    "unfollow": "Ne plus suivre",
    "unfollowHint": "Le retirer de ta bibliothèque. Son auteur le garde.",
    "unfollowTitle": "Ne plus suivre ?",
    "unfollowBody": "{{name}} reste chez son auteur. Ceci ne fait que le retirer de ta bibliothèque.",
    "errUnfollow": "Impossible d'arrêter de suivre. Réessaie.",
    "errFollow": "Impossible de suivre le programme.",
    "errStatus": "Impossible de mettre à jour le programme.",
    "errAssign": "Impossible de mettre à jour les destinataires.",
    "assignSent": "Envoyé — toute personne nouvelle sur la liste reçoit une demande qu'elle peut accepter ou refuser.",
    "assignSentSelf": "Envoyé — comme c'est rédigé par un coach, vérifiez aussi votre boîte de réception d'athlète pour l'accepter ou le refuser.",
    "emptyTitle": "Rien ici pour l'instant",
    "emptySub": "Les programmes et les entraînements que tu crées ou clones apparaîtront ici.",
    "emptyCoachTitle": "Rien d'assigné pour l'instant",
    "emptyCoachSub": "Personne ne t'a encore assigné de programme ou d'entraînement.",
    "assignedBy": "Assigné par {{name}}",
    "followingVersion": "Tu suis la version de {{name}}",
    "followingVersionUnknown": "Tu suis la version de quelqu'un d'autre"
  },
  "common": {
    "weightUnit_kg": "kg",
    "weightUnit_lb": "lb",
    "lastDataAt": "Dernière donnée {{at}}",
    "noData": "Aucune donnée",
    "lastDataOn": "Dernière donnée : {{date}}",
    "languageA11y": "Langue",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Abandonner les modifications ?",
      "body": "Les modifications non enregistrées seront perdues.",
      "keepEditing": "Continuer la modification",
      "discard": "Abandonner",
      "exitTitle": "Modifications non enregistrées",
      "exitBody": "Ces modifications ne sont pas enregistrées. Enregistre-les, garde-les comme brouillon sur cet appareil ou abandonne-les.",
      "exitBodyNoDraft": "Ces modifications ne sont pas enregistrées. Enregistre-les ou abandonne-les.",
      "save": "Enregistrer",
      "keepDraft": "Garder le brouillon"
    },
    "relativeAge": {
      "today": "aujourd'hui",
      "days": "il y a {{count}}j",
      "weeks": "il y a {{count}} sem.",
      "months": "il y a {{count}} mois"
    },
    "loadMore": "Charger plus",
    "loadingMore": "Chargement…",
    "pageOf": "{{current}} sur {{total}}",
    "weekInProgress": "Semaine en cours",
    "weekDaysToGo_one": "encore {{count}} jour",
    "weekDaysToGo_other": "encore {{count}} jours",
    "weekLastDay": "dernier jour",
    "noFullWeekYet": "Pas encore de semaine complète"
  },
  "bodymap": {
    "viewBack": "Dos",
    "viewFront": "Face",
    "workedTitle": "Muscles sollicités",
    "workedPrimary": "primaires",
    "workedSecondary": "secondaires",
    "heatmapTitle": "Muscles les plus travaillés",
    "heatmapLow": "peu",
    "heatmapHigh": "beaucoup",
    "window7d": "7 jours",
    "window30d": "30 jours",
    "painTitle": "Carte de douleur",
    "painHelp": "Tape un muscle pour le marquer, chaque côté séparément : rouge (éviter les charges lourdes), jaune (prudence). Sauvegardé automatiquement.",
    "painRed": "éviter",
    "painYellow": "prudence",
    "painClearAll": "Tout effacer",
    "painSaving": "Sauvegarde…",
    "painSaveError": "Échec de la sauvegarde. Vérifie la connexion.",
    "painRiskA11y": "Risque de douleur : {{severity}}",
    "painRiskSideA11y": "Risque de douleur : {{severity}}, {{side}}",
    "painBannerMuscleSide": "{{muscle}} (<side>{{side}}</side>)",
    "painSideOnly": {
      "left": "côté gauche seulement",
      "right": "côté droit seulement"
    },
    "painSeverity": {
      "red": "élevé",
      "yellow": "modéré",
      "green": "faible"
    },
    "painPart": {
      "chest": "ta poitrine",
      "chest_left": "le côté gauche de ta poitrine",
      "chest_right": "le côté droit de ta poitrine",
      "biceps": "tes biceps",
      "biceps_left": "ton biceps gauche",
      "biceps_right": "ton biceps droit",
      "triceps": "tes triceps",
      "triceps_left": "ton triceps gauche",
      "triceps_right": "ton triceps droit",
      "forearm": "tes avant-bras",
      "forearm_left": "ton avant-bras gauche",
      "forearm_right": "ton avant-bras droit",
      "front-deltoids": "tes épaules",
      "front-deltoids_left": "ton épaule gauche",
      "front-deltoids_right": "ton épaule droite",
      "back-deltoids": "tes épaules",
      "back-deltoids_left": "ton épaule gauche",
      "back-deltoids_right": "ton épaule droite",
      "trapezius": "tes trapèzes",
      "trapezius_left": "ton trapèze gauche",
      "trapezius_right": "ton trapèze droit",
      "upper-back": "le haut de ton dos",
      "upper-back_left": "le côté gauche du haut de ton dos",
      "upper-back_right": "le côté droit du haut de ton dos",
      "lower-back": "le bas de ton dos",
      "lower-back_left": "le côté gauche du bas de ton dos",
      "lower-back_right": "le côté droit du bas de ton dos",
      "abs": "tes abdos",
      "abs_left": "le côté gauche de tes abdos",
      "abs_right": "le côté droit de tes abdos",
      "obliques": "tes obliques",
      "obliques_left": "ton oblique gauche",
      "obliques_right": "ton oblique droit",
      "quadriceps": "tes quadriceps",
      "quadriceps_left": "ton quadriceps gauche",
      "quadriceps_right": "ton quadriceps droit",
      "hamstring": "tes ischio-jambiers",
      "hamstring_left": "tes ischio-jambiers gauches",
      "hamstring_right": "tes ischio-jambiers droits",
      "gluteal": "tes fessiers",
      "gluteal_left": "ton fessier gauche",
      "gluteal_right": "ton fessier droit",
      "adductors": "tes adducteurs",
      "adductors_left": "tes adducteurs gauches",
      "adductors_right": "tes adducteurs droits",
      "abductors": "tes abducteurs",
      "abductors_left": "tes abducteurs gauches",
      "abductors_right": "tes abducteurs droits",
      "calves": "tes mollets",
      "calves_left": "ton mollet gauche",
      "calves_right": "ton mollet droit",
      "tibialis": "tes tibias",
      "tibialis_left": "ton tibia gauche",
      "tibialis_right": "ton tibia droit",
      "neck": "ton cou",
      "neck_left": "le côté gauche de ton cou",
      "neck_right": "le côté droit de ton cou",
      "head": "ta tête",
      "head_left": "le côté gauche de ta tête",
      "head_right": "le côté droit de ta tête"
    },
    "painSummaryAvoid": "À éviter : {{parts}}",
    "painSummaryCaution": "Prudence : {{parts}}",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "zoomReset": "Réinitialiser le zoom",
    "zoomPinchHint": "Pince ou utilise les boutons.",
    "painListToggle": "Muscles en liste",
    "painListLeft": "{{muscle}} (gauche)",
    "painListRight": "{{muscle}} (droite)",
    "painStateRed": "Éviter les charges lourdes",
    "painStateYellow": "Prudence",
    "painStateNone": "Non marqué",
    "painListRowA11y": "{{muscle}}, {{state}}"
  },
  "plates": {
    "title": "Répartition des disques",
    "openHint": "Afficher la répartition",
    "close": "Fermer",
    "targetLabel": "Cible",
    "barLabel": "Barre",
    "barAria": "Poids de la barre",
    "barNone": "Sans barre",
    "perSide": "Par côté",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Juste la barre — aucun disque nécessaire.",
    "belowBar": "La cible est plus légère que la barre.",
    "invalidInput": "Saisis d'abord un poids valide.",
    "remainder": "+{{weight}} sous la cible avec l'inventaire actuel.",
    "fallbackPill": "maximum possible",
    "inventoryLegend": "Paires disponibles",
    "inventoryHint": "Paires de chaque disque disponibles maintenant. Mets 0 si la salle ne l'a pas ou que le rack est vide. Sauvegardé entre les sessions.",
    "pairsAria": "Paires de {{plate}} disponibles",
    "loadedSide": "Côté chargé",
    "singleSideHint": "Un seul côté : les disques se chargent d'un seul côté. Landmine, t-bar, traîneaux et leviers par bras fonctionnent ainsi."
  },
  "app": {
    "title": "$t(brand.product)",
    "tagline": "Musculation, consignée sans détour.",
    "signedInAs": "Connecté en tant que <bold>{{email}}</bold>.",
    "signOut": "Se déconnecter",
    "loading": "Chargement…",
    "checking": "vérification…"
  },
  "auth": {
    "signIn": "Se connecter",
    "signInFailed": "Échec de la connexion. Vérifie ton e-mail et ton mot de passe.",
    "email": "E-mail",
    "emailPlaceholder": "email@exemple.com",
    "password": "Mot de passe",
    "passwordRules": {
      "length": "Au moins 10 caractères",
      "uppercase": "Une majuscule",
      "lowercase": "Une minuscule",
      "number": "Un chiffre",
      "met": "fait",
      "unmet": "encore à faire"
    },
    "revealPassword_one": "Afficher le mot de passe",
    "revealPassword_other": "Afficher les mots de passe",
    "hidePassword_one": "Masquer le mot de passe",
    "hidePassword_other": "Masquer les mots de passe",
    "passwordHint": "Au moins 10 caractères avec majuscule, minuscule et un chiffre.",
    "invitedOnly": "Les comptes sont créés sur invitation. Si tu as reçu une invitation, connecte-toi avec l'adresse et le mot de passe temporaire reçus par e-mail.",
    "submitting": "En cours…",
    "confirmTitle": "Confirmez votre e-mail",
    "confirmHelp": "Un code a été envoyé à <bold>{{email}}</bold>. Collez-le ci-dessous pour finaliser la création du compte.",
    "confirmCode": "Code de confirmation",
    "confirmSubmit": "Confirmer",
    "confirming": "Confirmation…",
    "resendCode": "Renvoyer le code",
    "resentInfo": "Code renvoyé. Vérifiez votre boîte de réception.",
    "confirmedNowSignIn": "Compte confirmé. Connectez-vous pour continuer.",
    "forgotEmailRequired": "Écris l'email avec lequel tu te connectes.",
    "forgotCodeRequired": "Écris le code que nous t'avons envoyé.",
    "forgotLink": "Mot de passe oublié ?",
    "forgotTitle": "Réinitialiser le mot de passe",
    "forgotIntro": "Indique ton email, on t'envoie un code pour réinitialiser le mot de passe.",
    "forgotSendCode": "Envoyer le code",
    "forgotCodeSent": "Code envoyé. Vérifie ta boîte mail.",
    "forgotConfirmHelp": "Code envoyé à <bold>{{email}}</bold>. Saisis-le ci-dessous.",
    "forgotResetSubmit": "Réinitialiser",
    "forgotResetDone": "Mot de passe mis à jour. Connecte-toi avec le nouveau.",
    "newPassword": "Nouveau mot de passe",
    "backToSignIn": "Retour à la connexion",
    "welcome": {
      "title": "Bienvenue dans $t(brand.product)",
      "help": "Tu as été invité. Choisis le mot de passe que tu utiliseras désormais, et dis-nous comment t'appeler.",
      "name": "Comment on t'appelle ?",
      "namePlaceholder": "Ton prénom",
      "nameRequired": "Indique un nom — c'est ainsi que l'application te saluera.",
      "submit": "Entrer"
    },
    "confirmPassword": "Confirme le mot de passe",
    "passwordsMatch": "Les deux correspondent.",
    "passwordMismatch": "Les deux mots de passe ne correspondent pas.",
    "forgotCodeSubmit": "Continuer",
    "forgotCodeIncomplete": "Saisis les six chiffres du code.",
    "forgotPasswordHelp": "Choisis le mot de passe que tu utiliseras désormais.",
    "backStep": "Retour",
    "forgotStep": "Étape {{n}} sur 3",
    "forgotCodeWrong": "Ce code n'est pas le bon. Vérifie-le et réessaie.",
    "forgotCodeExpired": "Ce code a expiré. Demandes-en un nouveau.",
    "forgotTooManyAttempts": "Trop de tentatives. Attends quelques minutes et réessaie.",
    "forgotTooManyRequests": "Trop de codes demandés. Attends quelques minutes.",
    "resendCodeIn": "Renvoyer le code ({{seconds}} s)"
  },
  "dashboard": {
    "meTitle": "Aller-retour authentifié — /api/me",
    "healthTitle": "État de l'API",
    "exportData": "Exporter mes données",
    "deleteAccount": "Supprimer mon compte",
    "exporting": "Préparation de l'export…",
    "deleting": "Suppression…",
    "deleteConfirm": "Cette action supprimera définitivement votre compte et toutes vos données. Tapez SUPPRIMER pour confirmer.",
    "deleteCancel": "Annuler",
    "deletePlaceholder": "SUPPRIMER",
    "deleteSuccess": "Compte supprimé.",
    "exportFilename": "metria-export-{{date}}.json",
    "privacyTitle": "Confidentialité",
    "privacyHelp": "Exportez tout en JSON ou supprimez le compte définitivement. Les suppressions sont irréversibles."
  },
  "privacy": {
    "linkLabel": "Confidentialité",
    "title": "Politique de confidentialité",
    "lastUpdated": "Dernière mise à jour : 9 septembre 2026 (responsable du traitement, conservation, Health Connect, coachs)",
    "intro": "Metria est une app d'entraînement publiée sous le nom Heraion par Antenore Gatta, en Suisse. Heraion n'est pas une société enregistrée : le responsable du traitement de vos données est une personne physique, et c'est avec elle que vous traitez. Cette politique explique ce que nous collectons, pourquoi, où les données résident, combien de temps elles restent et ce que vous pouvez nous demander.",
    "section1Title": "Ce que nous collectons",
    "section1Body": "Uniquement ce dont l'app a besoin pour fonctionner, plus ce que vous choisissez d'y mettre. Pour avoir un compte : votre adresse e-mail, qui sert aussi d'identifiant du compte, et un mot de passe, qu'Amazon Cognito ne conserve que sous forme d'empreinte cryptographique — le clair ne nous parvient jamais. Dans le profil : un nom affiché, obligatoire, qui peut très bien être un pseudonyme plutôt que votre nom d'état civil, et, si vous les renseignez, une tranche d'âge et le sexe biologique, que l'app utilise pour les formules de masse grasse et pour la silhouette qu'elle dessine. Puis tout ce que vous saisissez en vous entraînant : entraînements, séries, charges, programmes, notes, records personnels et, si vous utilisez ces parties de l'app, mesures corporelles, poids, signalements de douleur et valeurs de santé. Nous ne demandons ni adresse postale, ni numéro de téléphone, ni date de naissance, ni données de paiement, et nous n'utilisons ni analytics, ni publicité, ni pistage : il n'existe nulle part de profil comportemental vous concernant. Le poids, les mesures corporelles, les signalements de douleur et tout ce qui est lu depuis Health Connect sont des données de santé — catégorie particulière au sens de l'art. 9 RGPD et données sensibles au sens de l'art. 5 let. c LPD — donc jamais agrégés, jamais journalisés, et ils s'en vont avec votre compte.",
    "section2Title": "Où vivent les données, et qui d'autre y touche",
    "section2Body": "Toutes les données sont stockées dans la région AWS eu-central-2 (Zurich, Suisse). Amazon Web Services est le seul sous-traitant auquel nous recourons : l'authentification fonctionne sur Amazon Cognito, les données structurées sur Amazon DynamoDB, le code serveur sur AWS Lambda, et les fichiers statiques de l'app sont servis par Amazon CloudFront. Nous n'utilisons aucun service d'analytics, de publicité ou de pistage, nous ne vendons ni ne louons vos données, et nous ne les remettons à personne d'autre. Les deux seules voies par lesquelles vos données vont plus loin sont celles que vous activez vous-même : Health Connect sur votre téléphone, et un coach que vous invitez. Chacune a sa section ci-dessous.",
    "section3Title": "Vos droits",
    "section3Body": "Depuis l'app, vous pouvez exporter l'intégralité de vos données en JSON et supprimer définitivement votre compte ; la suppression efface l'enregistrement d'authentification et tout ce qui est stocké sous votre compte, sans soft-delete derrière. Au-delà de ces deux boutons, vous avez les droits que la loi vous reconnaît : savoir ce que nous détenons sur vous, le faire rectifier, le faire effacer, en recevoir une copie dans un format portable, vous opposer à un traitement ou en demander la limitation, et retirer un consentement donné — le retrait nous arrête pour la suite et ne rend pas illicite ce qui a été fait tant qu'il valait. Écrivez à {{email}} : c'est une personne qui répond. Si vous estimez que nous avons mal traité vos données, vous pouvez aussi saisir une autorité de contrôle : en Suisse le Préposé fédéral à la protection des données et à la transparence, dans l'Union européenne l'autorité du pays où vous vivez.",
    "section4Title": "Qui est responsable, et comment nous joindre",
    "section4Body": "Le responsable du traitement de vos données est Antenore Gatta, qui publie Metria sous le nom Heraion depuis la Suisse. Heraion est un nom de projet, pas une société enregistrée : la responsabilité est donc personnelle et non celle d'une entreprise. Questions, demandes et réclamations : {{email}}.",
    "section5Title": "Base légale",
    "section5Body": "Votre compte et vos données d'entraînement sont traités pour vous fournir le service que vous avez demandé — l'exécution de l'accord entre nous, art. 6 par. 1 let. b RGPD, et la même finalité au sens de la loi suisse sur la protection des données. Les données de santé — poids, mesures corporelles, signalements de douleur et tout ce qui est lu depuis Health Connect — ne sont traitées que sur votre consentement explicite, art. 9 par. 2 let. a RGPD, que vous donnez en activant cette partie de l'app et que vous retirez en la désactivant ou en supprimant les données. Nous n'étirons pas l'intérêt légitime pour couvrir quelque chose auquel vous ne vous attendriez pas, et nous mettrons cette politique à jour avant l'ajout de toute nouvelle finalité.",
    "section6Title": "Qui peut utiliser Metria",
    "section6Body": "Metria n'est pas destinée aux enfants. Pour avoir un compte, vous devez avoir au moins 13 ans, ou l'âge supérieur exigé par la loi de votre pays. En dessous de cet âge, un parent ou représentant légal doit consentir pour vous et encadrer l'utilisation. Les comptes ne s'ouvrent pas par une inscription publique : quelqu'un déjà présent dans Metria vous invite et le compte est créé pour vous, de sorte qu'une invitation adressée à un mineur doit être acceptée par son parent ou représentant légal.",
    "section7Title": "Combien de temps nous conservons, et ce que la suppression efface",
    "section7Body": "Tant que votre compte existe, ce que vous avez saisi reste : nous ne faisons pas expirer votre historique et nous ne le déplaçons pas ailleurs quand vous arrêtez de vous entraîner. Certaines choses durent moins, et c'est voulu. Quand vous supprimez un entraînement, un marqueur prend sa place pendant 30 jours, afin qu'un appareil resté hors ligne apprenne que la séance a disparu ; ensuite le marqueur s'en va aussi. Un cache qui empêche qu'une requête soit appliquée deux fois garde son entrée 24 heures. Notre base de données est sauvegardée en continu et peut être restaurée à n'importe quel instant des 35 jours précédents : une donnée que vous avez supprimée peut donc encore exister dans une sauvegarde pendant ce délai avant d'être irrécupérable — nous ne restaurons une sauvegarde que pour réparer une panne, jamais pour faire revenir un compte que quelqu'un a supprimé. La suppression du compte efface l'enregistrement d'authentification et tout enregistrement stocké sous ce compte, y compris ce qui avait été importé depuis Health Connect et le lien avec le coach des deux côtés ; une fois la fenêtre de sauvegarde passée, il n'en reste rien. Une seule chose est conservée et détachée plutôt que supprimée : un retour que vous nous avez envoyé depuis l'app demeure, parce qu'il parle de l'app et non de vous, mais son auteur en est retiré.",
    "section8Title": "Health Connect",
    "section8Body": "Sur Android, Metria peut se connecter à Health Connect. C'est désactivé tant que vous ne l'activez pas dans les réglages, Health Connect vous demande d'accorder chaque type de donnée séparément, et l'app fonctionne sans. Une fois activé, Metria lit vos entraînements avec leur fréquence cardiaque, leurs calories actives et leur distance, pour qu'une séance enregistrée par votre montre apparaisse dans votre timeline avec son effort ; votre poids, votre masse grasse et votre masse maigre, pour que la section corps affiche un seul historique au lieu de deux ; et vos glycémies et vos entrées de nutrition, pour que la carte métabolique puisse mettre les glucides du jour et vos relevés de glycémie à côté de votre entraînement. Metria réécrit dans Health Connect deux choses seulement, et uniquement celles que vous avez saisies ici : une pesée et un relevé de glycémie, pour qu'une valeur tapée dans Metria ne reste pas prisonnière de Metria. Ce que nous lisons quitte votre téléphone : c'est stocké sur nos serveurs à Zurich avec le reste de vos données et sous les mêmes règles — jamais utilisé à des fins publicitaires, jamais vendu, jamais transmis à un tiers, jamais utilisé pour entraîner un modèle. Cela reste jusqu'à ce que vous supprimiez ces données ou votre compte, comme décrit à la section précédente. Vous pouvez vous déconnecter depuis les réglages de Metria ou révoquer les autorisations dans Health Connect à tout moment : l'un comme l'autre arrête toute lecture ultérieure, et les valeurs déjà importées restent les vôtres, à supprimer dans Metria.",
    "section9Title": "Si vous avez un coach",
    "section9Body": "Metria peut relier un athlète et un coach. Le lien commence par une invitation adressée à une adresse e-mail, que nous conservons sur l'invitation pour que seule la personne détenant cette adresse puisse l'accepter, et qui est effacée dès que le lien devient actif. Tant que le lien est actif, le coach peut lire le côté entraînement de l'athlète — séances et leurs résultats, programmes et objectifs, maximums et records, et le profil — et ne peut rien modifier, sauf si l'athlète lui a accordé le droit de fixer les objectifs ; un coach ne peut pas se l'accorder lui-même. Chacune des deux parties peut mettre fin au lien depuis l'app à tout moment, et y mettre fin arrête l'accès. Inviter un athlète plus jeune que l'âge indiqué à la section ci-dessus requiert l'accord d'un parent ou représentant légal : cet accord relève de la personne qui envoie l'invitation, et Metria ne le demande ni ne le vérifie.",
    "back": "Retour"
  },
  "terms": {
    "linkLabel": "Conditions",
    "title": "Conditions d'utilisation",
    "lastUpdated": "Dernière mise à jour : 9 septembre 2026 (qui nous sommes, comment vous acceptez, langues)",
    "intro": "Ces conditions constituent l'accord entre vous et nous pour l'utilisation de Metria. En utilisant l'app, vous les acceptez. Si vous ne les acceptez pas, n'utilisez pas Metria.",
    "section1Title": "Qui nous sommes",
    "section1Body": "Metria est publiée sous le nom Heraion par Antenore Gatta, en Suisse. Heraion est le nom du projet, pas une société enregistrée : la personne avec qui vous contractez est une personne physique. Vous pouvez nous écrire à {{email}}.",
    "section2Title": "Ces conditions",
    "section2Body": "Les comptes ne s'ouvrent pas par une inscription publique : quelqu'un déjà présent dans Metria vous invite, et le compte est créé pour vous. En utilisant Metria une fois le compte créé — en vous connectant, en saisissant un entraînement — vous acceptez ces conditions, qui deviennent l'accord entre vous et nous. Si vous ne les acceptez pas, n'utilisez pas Metria et demandez-nous de supprimer le compte. Si vous êtes un consommateur, rien de ce qui est écrit ici ne vous retire un droit que la loi de votre pays vous reconnaît et auquel vous ne pouvez pas renoncer.",
    "section3Title": "Qui peut utiliser Metria",
    "section3Body": "Pour avoir un compte, vous devez avoir au moins 13 ans, ou l'âge supérieur exigé par la loi de votre pays. En dessous de cet âge, un parent ou représentant légal doit accepter ces conditions pour vous et encadrer l'utilisation. Le compte est personnel : gardez votre mot de passe pour vous et prévenez-nous si vous pensez qu'une autre personne le connaît.",
    "section4Title": "Metria ne donne pas de conseils médicaux",
    "section4Body": "Metria est un outil d'entraînement. Ce n'est pas un dispositif médical et elle ne donne aucun conseil médical. Les charges, répétitions et temps de récupération affichés sont des propositions calculées à partir des chiffres que vous avez saisis, pas une prescription : c'est vous qui décidez ce que vous soulevez, et vous vous entraînez à vos risques. La musculation peut causer des blessures. Si vous avez une pathologie ou une blessure, si vous êtes enceinte ou si vous reprenez après une longue interruption, parlez-en à un médecin avant de commencer — et arrêtez dès que quelque chose fait mal. Tout signalement de douleur, mesure corporelle ou valeur de santé affichée, y compris ce qui provient de Health Connect, est l'enregistrement de ce que vous ou votre appareil avez saisi, jamais un diagnostic : Metria ne détecte ni ne surveille aucune pathologie.",
    "section5Title": "Ce que vous saisissez reste à vous",
    "section5Body": "Les entraînements, programmes, mesures et notes que vous saisissez vous appartiennent. Pour faire fonctionner le service, il nous faut une licence limitée pour les conserver, les sauvegarder, les traiter et les afficher — à vous et aux personnes avec qui vous avez choisi de les partager. Rien de plus, et cela prend fin lorsque vous supprimez les données ou le compte. Ce que nous collectons et pourquoi figure dans la politique de confidentialité.",
    "section6Title": "Coachs et athlètes",
    "section6Body": "Si vous invitez quelqu'un en tant que coach, vous devez avoir son accord au préalable, et son accord sur ce que vous pourrez voir. Ses données restent les siennes : votre accès dépend du rôle qu'il détient dans l'app et il peut le retirer. Si l'athlète est plus jeune que l'âge indiqué à la section précédente, vous devez obtenir l'accord d'un parent ou représentant légal avant de l'inviter.",
    "section7Title": "Usage correct",
    "section7Body": "Utilisez Metria dans le respect de la loi. N'essayez pas d'accéder à des comptes, données ou parties du service qui ne sont pas les vôtres, n'en extrayez pas le contenu et ne le revendez pas, ne téléversez pas de contenu illicite et ne saisissez pas les données d'une autre personne sans son accord.",
    "section8Title": "Prix",
    "section8Body": "Metria est gratuite aujourd'hui. Si nous introduisons des fonctions payantes, nous le dirons clairement et à l'avance, et le paiement passera par la boutique d'Apple ou de Google, dont les règles régissent le débit, le renouvellement et les remboursements. Un contenu numérique qui démarre immédiatement à votre demande peut ne pas ouvrir de droit de rétractation ; là où la loi vous en accorde un, il vous reste acquis.",
    "section9Title": "Disponibilité et modifications",
    "section9Body": "Nous fournissons Metria telle quelle et selon sa disponibilité : nous ne promettons pas qu'elle sera ininterrompue ni exempte d'erreurs. Nous pouvons ajouter, modifier ou retirer des fonctions, et avant une modification qui réduit sensiblement quelque chose sur quoi vous comptiez, nous vous le dirons dans l'app.",
    "section10Title": "Comment cela prend fin",
    "section10Body": "Vous pouvez arrêter quand vous voulez : supprimez vos données ou votre compte depuis l'app. Nous pouvons suspendre ou fermer un compte qui enfreint ces conditions ou que la loi nous oblige à fermer, et sauf si cela est illicite ou déraisonnable nous vous en dirons d'abord la raison. La suppression du compte efface vos données comme décrit dans la politique de confidentialité.",
    "section11Title": "Responsabilité",
    "section11Body": "Nous répondons des dommages causés par notre intention ou notre négligence grave, des atteintes à la vie, à l'intégrité physique ou à la santé, et de tout ce que la loi ne nous permet pas d'exclure — vos droits impératifs de consommateur compris. Au-delà, nous ne répondons pas des dommages indirects ou imprévisibles, des blessures issues d'un entraînement que vous avez choisi de faire, ni des données perdues faute d'avoir été exportées.",
    "section12Title": "Apps d'Apple et de Google",
    "section12Body": "Si vous utilisez l'app iOS, cet accord est conclu entre vous et nous, pas avec Apple. Apple n'est pas responsable de l'app ni d'une quelconque réclamation la concernant et n'en assure pas le support ; Apple et ses filiales peuvent faire valoir cet accord en tant que tiers bénéficiaires. Si vous utilisez l'app Android, les règles de la boutique d'où vous l'avez installée s'appliquent également.",
    "section13Title": "Modifications de ces conditions",
    "section13Body": "Nous pouvons modifier ces conditions. La nouvelle version est publiée ici avec sa date et, pour les changements qui vous concernent vraiment, nous vous le dirons dans l'app avant qu'ils ne prennent effet. Si vous continuez à utiliser Metria ensuite, la nouvelle version s'applique.",
    "section14Title": "Droit et litiges",
    "section14Body": "Le droit suisse s'applique. Si vous êtes un consommateur, vous conservez aussi la protection des règles impératives du pays où vous vivez et vous pouvez saisir les tribunaux de ce pays. Les consommateurs de l'Union européenne peuvent également utiliser la plateforme européenne de règlement en ligne des litiges sur ec.europa.eu/consumers/odr.",
    "section15Title": "Langues",
    "section15Body": "Ces conditions sont publiées en anglais, italien, français, allemand et russe. L'anglais est la langue dans laquelle elles ont été rédigées et la version qui prévaut si une traduction dit autre chose — sauf là où la loi de votre pays donne la priorité à la version dans votre propre langue, auquel cas c'est celle-là qui s'applique à vous. La politique de confidentialité est publiée dans les mêmes cinq langues, au même titre.",
    "back": "Retour"
  },
  "errors": {
    "generic": "Une erreur s'est produite."
  },
  "feedback": {
    "title": "Envoyer un retour",
    "help": "Bug trouvé, fonctionnalité souhaitée ou autre ? Écris-le ici. Les messages arrivent dans la boîte admin.",
    "kindLabel": "Type",
    "kind_bug": "Bug",
    "kind_feature": "Demande de fonctionnalité",
    "kind_other": "Autre",
    "kind_crash": "Rapport de plantage",
    "bodyLabel": "Que s'est-il passé ?",
    "bodyPlaceholder": "Décris ce que tu as vu, ce que tu attendais et comment le reproduire.",
    "send": "Envoyer",
    "sending": "Envoi…",
    "sentFlash": "Merci — envoyé.",
    "sentHint": "On le traitera à la prochaine session. Tu peux fermer.",
    "close": "Fermer",
    "errEmpty": "Écris quelque chose avant d'envoyer.",
    "errSubmit": "Échec de l'envoi. Réessaie dans un instant.",
    "errRateLimit": "Trop d'envois dans la dernière heure. Réessaie plus tard.",
    "inboxTitle": "Boîte de retours",
    "loading": "Chargement des retours…",
    "empty": "Aucun retour à afficher.",
    "filterAll": "Tous",
    "loadMore": "Charger plus",
    "status_open": "Ouvert",
    "status_in_progress": "En cours",
    "status_shipped": "Livré",
    "status_wontfix": "Non corrigé",
    "priorityLabel": "Priorité",
    "priorityNone": "Aucune",
    "statusLabel": "Statut",
    "head_open": "{{count}} ouverts",
    "head_in_progress": "{{count}} en cours",
    "head_shipped": "{{count}} livrés",
    "head_wontfix": "{{count}} non corrigés",
    "headTotal": "{{count}} au total"
  },
  "profile": {
    "title": "Profil",
    "loading": "Chargement du profil…",
    "name": "Nom affiché",
    "namePlaceholder": "Comment souhaitez-vous être appelé(e) ?",
    "role": "Rôle",
    "roleCoach": "Coach",
    "roleAthlete": "Athlète",
    "roleBoth": "Les deux",
    "ageBucket": "Tranche d'âge (facultatif)",
    "ageBucketHelp": "Utilisée uniquement pour les statistiques de groupe anonymes opt-in. Reste vide si vous ne la remplissez pas.",
    "ageBucketNone": "Préfère ne pas répondre",
    "unitsPreference": "Unité préférée",
    "unitsPreferenceHelp": "Les poids sont toujours stockés en kilogrammes. Vous pourrez changer l'unité de saisie pour chaque série.",
    "preferredFigure": "Figure du corps sur la bodymap",
    "preferredFigureHelp": "Choisis la silhouette des cartes musculaires.",
    "figure_masculine": "Masculine",
    "figure_feminine": "Féminine",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Profil enregistré.",
    "agePrefix_under_18": "Moins de 18 ans",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Poids corporel (optionnel)",
    "bodyweightPlaceholder": "p. ex. 78",
    "bodyweightHelp": "Sert uniquement à calculer la charge effective sur les exercices au poids du corps. Jamais agrégé, jamais journalisé, supprimé avec le compte.",
    "errBodyweight": "Saisis un poids entre 20 et 300 kg (ou l'équivalent en lb).",
    "apk": {
      "title": "APK Android (build de test)",
      "hint": "Build de test réservé à la famille. Sur Android, active « Installer depuis des sources inconnues » dans le navigateur, puis ouvre le fichier.",
      "download": "Télécharger l'APK"
    },
    "email": "E-mail",
    "metaTitle": "Session"
  },
  "workout": {
    "title": "Entraînements",
    "loading": "Chargement des entraînements…",
    "empty": "Aucun entraînement enregistré.",
    "logNew": "Enregistrer un entraînement",
    "startedAt": "Quand",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisir un exercice",
    "errPickExercise": "Choisis un exercice dans le catalogue.",
    "catalogEmptyCoach": "Le catalogue est vide. Ajoute au moins un exercice avant d'enregistrer un entraînement.",
    "catalogEmptyAthlete": "Le catalogue est vide. L'un de tes coachs doit ajouter les exercices avant que tu puisses enregistrer un entraînement.",
    "setsLegend": "Séries",
    "set": "Série",
    "reps": "Répétitions",
    "amrapHint": "AMRAP — dépasse le seuil prescrit",
    "weight": "Poids",
    "extra": "Extra (+/−)",
    "unit": "Unité",
    "rpe": "RPE",
    "addSet": "Ajouter une série",
    "removeSet": "Supprimer la série",
    "notes": "Notes (facultatif)",
    "setNoteToggle": "Ajouter une note à cette série",
    "setNotePlaceholder": "Ce qui était différent sur cette série",
    "prefillFromDate": "Pré-remplir depuis {{date}} ?",
    "prefillAccept": "Utiliser",
    "savePromptTitle": "Vérifie avant d'enregistrer",
    "savePromptContinue": "Retour à la séance",
    "savePromptAnyway": "Enregistrer quand même",
    "unmarkedPromptBody": "{{count}} séries avec des valeurs mais sans marque de fin.",
    "unmarkedPromptFail": "Marquer échouées et enregistrer",
    "unmarkedPromptComplete": "Marquer faites et enregistrer",
    "outlierPromptBody": "{{count}} entrées semblent inhabituelles :",
    "outlierItem": "{{exercise}} : {{weight}} (max historique {{expected}})",
    "outlierE1rmItem": "{{exercise}} : 1RM estimé {{e1rm}} (max historique {{expected}})",
    "outlierPerImplementItem": "{{exercise}} : {{weight}} fait environ le double de ton habituel {{expected}} — tu as saisi le poids d'UN seul haltère ou le total des deux ?",
    "outlierRepsItem": "{{exercise}} : {{reps}} répétitions — semble trop élevé",
    "outlierZeroWeightItem": "{{exercise}} : {{reps}} répétitions sans charge",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Entraînement enregistré.",
    "savedEdit": "Entraînement mis à jour.",
    "deleted": "Entraînement supprimé.",
    "cancel": "Annuler",
    "errNoSets": "Ajoutez au moins une série valide.",
    "creatingTitle": "Nouvel entraînement",
    "editingTitle": "Modifier l'entraînement",
    "exerciseN": "Exercice {{n}}",
    "addExercise": "Ajouter un autre exercice",
    "removeExercise": "Retirer l'exercice",
    "removeExerciseConfirm": "Retirer {{name}} de cet entraînement ? Les séries déjà enregistrées seront perdues.",
    "groupAlignTitle": "Nombre de séries différent",
    "groupAlignBody": "Les membres de ce groupe ont entre {{shortest}} et {{longest}} séries. Les aligner pour que les tours coïncident ?",
    "groupAlignPad": "+ Aligner sur {{n}}",
    "groupAlignTrim": "− Réduire à {{n}}",
    "groupAlignTrimWarning": "Réduire supprime des séries déjà enregistrées, sans retour possible.",
    "groupAlignTrimHint": "Supprime les séries en trop de chaque membre du groupe. Sans retour possible.",
    "groupAlignKeep": "Laisser ainsi",
    "splitGroup": "Séparer",
    "splitGroupTitle": "Séparer ce groupe ?",
    "splitGroupBody": "Les exercices conservent leurs séries et restent dans la séance, simplement dissociés. Vous pouvez les regrouper à nouveau quand vous voulez.",
    "splitGroupConfirm": "Séparer",
    "removeRoundConfirmTitle": "Supprimer ce tour ?",
    "removeRoundConfirmBody": "Le tour {{n}} de {{names}} sera supprimé en bloc.",
    "bilateral": "Bilatéral",
    "unilateral": "Unilatéral",
    "edit": "Modifier",
    "repeat": "Répéter",
    "delete": "Supprimer",
    "deleting": "Suppression…",
    "deleteConfirm": "Supprimer cet entraînement ?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Durée",
    "cardioDistance": "Distance",
    "cardioWeight": "Charge",
    "cardioHr": "FC moy",
    "cardioCalories": "Calories",
    "cardioOptionalsShow": "Autres champs",
    "cardioOptionalsHide": "Autres champs",
    "dateEditor": "Date et durée",
    "dateLabel": "Date",
    "startTimeLabel": "Début",
    "endTimeLabel": "Fin",
    "durationLabel": "Durée",
    "side": "Côté",
    "sideLeft": "Gauche",
    "sideRight": "Droit",
    "sideBoth": "Les deux",
    "showRpe": "Suivre la RPE",
    "showDuration": "Suivre la durée",
    "rir": "RIR {{n}}",
    "swap": "Remplacer",
    "swapHint": "Banc occupé ? Choisissez un exercice similaire.",
    "descriptionToggle": "Afficher / masquer la description",
    "failShort": "F",
    "failToggle": "Marquer la série comme ratée",
    "failHint": "Dernière rep manquée. Comptée dans le volume, exclue des PR.",
    "startRest": "Démarrer le minuteur de repos",
    "restStartDefault": "Démarrer le repos ({{n}}s)",
    "restStartCustom": "Démarrer le repos ({{n}}s, défaut de l'exercice)",
    "setComplete": "Marquer la série comme finie",
    "setCompleteHint": "Tamponne la série et lance un repos de {{n}}s.",
    "setCompleteHintCustom": "Tamponne la série et lance un repos de {{n}}s (défaut de l'exercice).",
    "setUndo": "Annuler la validation",
    "setUndoHint": "Touche encore pour annuler et remettre le minuteur à zéro.",
    "restLeft": "Repos",
    "restDone": "Temps écoulé",
    "restStop": "Stop",
    "restPause": "Pause",
    "restResume": "Reprendre",
    "restSound": "Bip à la fin du repos",
    "instructions": "Consignes du coach (optionnel)",
    "instructionsPlaceholder": "Focus de la séance, à sauter en cas de temps court, intention.",
    "lastTime": "Précéd.",
    "lastToday": "aujourd'hui",
    "lastDaysAgo": "il y a {{n}}j",
    "dropsetShort": "Drop",
    "dropsetToggle": "Ajouter une chaîne dropset",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Classique (charge réduite)",
    "dropsetMyorep": "Myo-rep (même charge)",
    "dropsetHintClassical": "Baisse la charge de 10 à 30 % et continue jusqu'à l'échec. Pas de repos.",
    "dropsetHintMyorep": "Même charge, moins de reps, 10–20 s de respiration, on répète.",
    "dropsetSameLoad": "= dessus",
    "dropsetAddStep": "Ajouter un drop",
    "dropsetRemove": "Retirer",
    "dropsetRemoveConfirm": "Tu as {{n}} drop steps. Reconvertir en série classique et les supprimer ?",
    "dropsetRemoveStep": "Retirer le drop",
    "groupLabel": "Groupe",
    "groupNone": "(aucun)",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupJoinExisting": "Rejoindre un groupe existant",
    "groupLeave": "Dégrouper",
    "groupSharedHint": "Partagé. Ouvre un autre exercice et sélectionne le même groupe dans la liste pour les apparier.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Détecté à partir de l'alternance des sets dans cette séance",
    "playActiveTitle": "Exercice actif — set complété le plus récent",
    "errGroupKindMixed": "Un même groupe ne peut pas mélanger superset et circuit. Choisis un seul type.",
    "exerciseNew": "Nouvel exercice",
    "cardMenu": "Options de l'exercice",
    "menuReplace": "Remplacer l'exercice",
    "menuGroup": "Groupe / superset",
    "menuMoveUp": "Déplacer vers le haut",
    "menuMoveDown": "Déplacer vers le bas",
    "menuShowNotes": "Afficher les notes",
    "menuHideNotes": "Masquer les notes",
    "menuShowDescription": "Afficher la description",
    "menuHideDescription": "Masquer la description",
    "tipAlternatives": "Exercices alternatifs",
    "tipCoachNote": "Note du coach",
    "perImplementHint": "Tu en utilises deux, ou un côté à la fois ? Saisis le poids d'un seul. L'app compte les deux (×2).",
    "tipProgramNote": "Dans ce programme",
    "tipNoAlternatives": "Aucun exercice similaire au catalogue",
    "tipClose": "Fermer",
    "painBanner": {
      "red": "Sollicite un muscle douloureux",
      "yellow": "Attention : charge un muscle signalé",
      "green": "Aucun risque signalé"
    },
    "setCycleHint": "Tape : fait · encore : raté · encore : annuler",
    "setStatePending": "Série ouverte",
    "setStateDone": "Série terminée",
    "setStatePr": "Série terminée, record personnel",
    "setStateFailed": "Série marquée comme ratée",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Verrouiller",
    "groupAutoConfirmAria": "Verrouille le groupe : arrête le détecteur et garde ces exercices liés",
    "groupAutoDismissAria": "Ignore la détection : ces exercices redeviennent individuels",
    "groupAddSetAll": "Ajouter une série à tous",
    "nameLabel": "Nom (facultatif)",
    "namePlaceholder": "Ex. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "ajustement de durée",
    "rirLabel": "RIR",
    "showRir": "Suivre la RIR",
    "maxDownA11y": "Le MAX a peut-être baissé",
    "animationOf": "Animation de {{name}}",
    "animationZoomHint": "Ouvre l'animation en plein écran",
    "closeAnimation": "Fermer l'animation",
    "showAnimation": "Afficher l'animation",
    "showBodyMap": "Afficher les muscles sollicités",
    "pagerDot": "{{target}}, {{current}} sur {{total}}",
    "pagePrev": "Page précédente",
    "pageNext": "Page suivante",
    "editUnsupportedTitle": "Modification non encore disponible",
    "editUnsupportedBody": "Cet entraînement contient des types d'exercices (P1RM, loaded carry) que le logger ne sait pas encore modifier."
  },
  "program": {
    "title": "Programmes",
    "help": "Cycles d'entraînement multi-semaines. La phase 5.1 livre la coque : nom, semaines, séances par semaine. Le builder de slots et de progression arrive ensuite.",
    "new": "Nouveau programme",
    "newTitle": "Nouveau programme",
    "name": "Nom",
    "namePlaceholder": "ex. Powerbuilding 6 semaines",
    "cycleWeeks": "Semaines du cycle",
    "sessionsPerWeek": "Séances par semaine",
    "description": "Description",
    "descriptionPlaceholder": "À quoi sert le cycle, à qui il s'adresse, notes pour les athlètes.",
    "create": "Créer",
    "creating": "Nouveau programme : {{name}}",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "deleteConfirm": "Confirmer ?",
    "deleteConfirmYes": "Oui, supprimer",
    "loading": "Chargement des programmes…",
    "empty": "Aucun programme. Crée-en un pour planifier un cycle multi-semaines.",
    "statusDraft": "Brouillon",
    "statusActive": "Actif",
    "statusArchived": "Archivé",
    "cycleWeeksLabel": "Cycle de {{n}} semaines",
    "sessionsPerWeekLabel": "{{n}}× / semaine",
    "slotCount": "{{n}} slot(s)",
    "skeletonHint": "Coque seulement. Les slots se remplissent dans la phase suivante.",
    "sessionDefaultName": "Séance {{n}}",
    "edit": "Modifier",
    "editing": "Modification : {{name}}",
    "assign": "Assigner",
    "backToList": "Retour aux programmes",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "errSave": "Impossible d'enregistrer le programme.",
    "metaLegend": "Programme",
    "status": "Statut",
    "metaCyclesLive": "Les modifications de structure (jours, semaines) s'appliquent immédiatement",
    "ordinalSession": "{{n}}ᵉ séance",
    "sessionName": "Nom de la séance",
    "slotN": "Slot {{n}}",
    "addSlot": "Ajouter un slot",
    "removeSlot": "Supprimer",
    "moveUp": "Déplacer vers le haut",
    "moveDown": "Déplacer vers le bas",
    "exercise": "Exercice",
    "exercisePick": "Choisis un exercice",
    "setsLegend": "Séries",
    "addSet": "Ajouter une série",
    "removeSet": "Supprimer la série",
    "reps": "Reps",
    "setNotesPlaceholder": "Note pour la série (optionnel)",
    "set": "Série",
    "intensityKind": "Intensité",
    "intensityNone": "Libre",
    "intensityPercent": "% du MAX",
    "intensityAbs": "kg (absolu)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Pourcentage",
    "intensity_absolute": "Poids (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "S{{n}}",
    "previewShow": "Aperçu",
    "previewHide": "Cacher l'aperçu",
    "previewMuscles": "Muscles sollicités",
    "previewSets": "{{n}} séries",
    "previewEmptySession": "Aucun slot dans cette séance.",
    "previewEmptyProgram": "Aucun slot pour l'instant. Ouvre Modifier pour en ajouter.",
    "start": "Lancer une séance",
    "startCancel": "Annuler",
    "startGo": "Lancer",
    "starting": "Lancement…",
    "startWeek": "Semaine",
    "startSession": "Séance",
    "progressNext": "Suivante : S{{w}} · Séance {{s}}",
    "instructions": "Instructions",
    "instructionsPlaceholder": "Tempo, durée de pause, focus technique, RPE cible.",
    "amrapLastSet": "AMRAP sur la dernière série",
    "maxAttempt": "Tentative 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Appliqué sur les {{n}} semaines du cycle.",
    "catalogLoading": "Chargement du catalogue d'exercices…",
    "builderComingSoon": "Le builder de slots et de progression arrive en Phase 5.2. Pour l'instant cela crée une coque vide, supprimable ou à remplir plus tard.",
    "errCycleWeeks": "Les semaines doivent être entre 1 et 12.",
    "errSessionsPerWeek": "Les séances par semaine doivent être entre 1 et 7.",
    "errName": "Le nom du programme est requis.",
    "errSchema": "Données de programme invalides.",
    "errCreate": "Impossible de créer le programme.",
    "errCode": {
      "sessionNameEmpty": "Chaque jour d'entraînement doit avoir un nom.",
      "slotNoExercise": "Choisis un exercice pour chaque emplacement.",
      "slotNoSets": "Chaque exercice doit avoir au moins une série.",
      "slotAllWeeksInactive": "Un exercice est désactivé sur toutes les semaines. Active une semaine ou retire-le.",
      "rowWidthMismatch": "Une ligne de séries ne correspond pas au nombre de semaines. Rouvre l'exercice et réessaie.",
      "invalidReps": "Vérifie les répétitions : utilise un nombre comme 8, ou 8+ pour l'AMRAP.",
      "groupKindMixed": "Un superset mélange des types de séries. Donne le même type à ses exercices.",
      "schemaInvalid": "Données de programme invalides.",
      "noSession": "Il n'y a aucune séance à enregistrer.",
      "planNameEmpty": "Le nom du plan est requis.",
      "planNoExercises": "Ajoute au moins un exercice au plan.",
      "invalidIntensityValue": "Vérifie la valeur d'intensité : ce doit être un nombre.",
      "weightOutOfRange": "Ce poids est hors plage.",
      "pctOutOfRange": "Le pourcentage doit être entre 0 et 200.",
      "rpeOutOfRange": "Le RPE doit être entre 1 et 10.",
      "rirOutOfRange": "Le RIR doit être entre 0 et 10.",
      "unknownIntensityKind": "Type d'intensité inconnu.",
      "invalidSeconds": "Vérifiez les secondes : une série chronométrée demande une durée, en secondes entières jusqu'à 3600.",
      "invalid_email": "Cette adresse email semble invalide.",
      "email_not_found": "Aucun compte trouvé avec cet email.",
      "too_many_assignees": "20 personnes maximum par programme.",
      "programNameEmpty": "Le nom du programme est requis.",
      "sessionEmpty": "Chaque jour d'entraînement doit avoir au moins un exercice.",
      "sessionTooManyExercises": "Un jour d'entraînement peut contenir au plus 20 exercices.",
      "amrapWithTime": "Une série chronométrée ne peut pas être aussi AMRAP. Retire l'un des deux.",
      "client_outdated": "Mettez à jour l'app pour enregistrer ce programme.",
      "invalidRepsRange": "Vérifie la fourchette : un minimum et un maximum autour de l'objectif, comme 8-12 autour de 10."
    },
    "cardMenu": "Menu du slot",
    "menuGroup": "Groupe",
    "groupNone": "Aucun groupe",
    "groupJoinExisting": "Rejoindre un groupe",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "assignTo": "Assigner aux athlètes",
    "assignToHelp": "L'assigner est une proposition : il entre dans sa bibliothèque seulement s'il accepte, et ce qu'il a accepté lui reste si tu le retires. Une relation coach active est requise.",
    "assignSelf": "Toi (auteur)",
    "addAssignee": "Ajouter",
    "removeAssignee": "Retirer",
    "removeAssigneeConfirm": "Retirer l'accès ?",
    "removeAssigneeHint": "L'athlète le perdra de sa bibliothèque. Appuie encore pour retirer.",
    "pendingAssigneeCaption": "En attente",
    "rosterSectionLabel": "Depuis ton roster",
    "rosterEmpty": "Aucun athlète dans ton roster pour l'instant.",
    "rosterAllAssigned": "Tous les athlètes de ton roster sont déjà assignés.",
    "shareTo": "Partager avec",
    "shareToHelp": "Partager est une proposition : cela n'arrive dans leur bibliothèque que s'ils acceptent, et ce qu'ils ont accepté leur reste même si tu les retires.",
    "shareSectionLabel": "Personnes avec qui partager",
    "shareEmpty": "Tu n'as encore personne avec qui partager.",
    "shareAllShared": "Tout le monde avec qui tu peux partager l'a déjà.",
    "emailSectionLabel": "Par email",
    "assigneePlaceholder": "athlete@exemple.com",
    "invalidEmailFormat": "Ça ne ressemble pas à une adresse email valide.",
    "follow": "Suivre",
    "unfollow": "Ne plus suivre",
    "followHint": "Suivre ce programme (il apparaît dans En cours)",
    "publish": "Publier",
    "unpublish": "Repasser en brouillon",
    "publishAndFollow": "Publier et suivre",
    "publishHint": "Rendre ce programme disponible pour le suivre",
    "chipDraft": "Brouillon",
    "chipPublished": "Publié",
    "chipFollowed": "Suivi",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "HIST",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Langue",
    "languageA11y": "Langue d'écriture",
    "languageSwitchQuestion": "Dans quelle langue écris-tu ?",
    "languageDeclareQuestion": "Dans quelle langue ce programme est-il écrit ?",
    "languageFootnote": "Les traductions sont facultatives : un programme dans une seule langue est complet.",
    "languageDeclareFootnote": "Rien n'est traduit : cela indique seulement la langue.",
    "languageAuto": "Traduction automatique",
    "languageNotYetWritten": "Pas encore de version en {{lang}}. Le texte en {{original}} reste en place.",
    "setBound": "Limite",
    "boundReps": "Reps",
    "boundTime": "Temps",
    "boundOpen": "Libre",
    "workSeconds": "Effort (s)",
    "restSeconds": "Repos (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Temps",
    "prescribeTimeA11y": "Prescrire l'effort et le repos en secondes",
    "seconds": "Secondes",
    "amrapNotWithTime": "Une série de {{secs}}s ne peut pas être un AMRAP : un plan ne peut pas te demander combien tu en feras. Enlève le + ou le temps.",
    "workSecondsRequired": "Quelle durée ?",
    "descriptionAdd": "Ajouter une description",
    "descriptionExpand": "Ouvre la description pour la modifier",
    "descriptionCollapse": "Replier la description",
    "undo": "Annuler",
    "redo": "Rétablir",
    "saveStatus": {
      "saving": "Enregistrement…",
      "unsaved": "Non enregistré",
      "queued": "Hors ligne",
      "saved": "Enregistré"
    },
    "draftConflict": {
      "title": "Le programme a changé",
      "body": "Il a été modifié ailleurs après le début de ton brouillon. Garder ton brouillon, ou utiliser la version à jour ? Rien ne change tant que tu n'appuies pas sur Enregistrer.",
      "keepDraft": "Garder mon brouillon",
      "useUpdated": "Utiliser la version à jour"
    },
    "savedElsewhere": {
      "body": "Il a été modifié ailleurs depuis que tu l'as ouvert. Rien n'a été enregistré. Si tu gardes ton brouillon, il remplace cette version.",
      "statusNotApplied": "Ton changement de statut n'a pas été appliqué."
    },
    "savedStaysOpen": "Enregistré. L'éditeur reste ouvert.",
    "savedQueuedStaysOpen": "En file d'attente : envoi au retour du réseau.",
    "newDraft": {
      "title": "Un brouillon en cours",
      "body": "Un brouillon commencé sur cet appareil le {{when}} n'a jamais été enregistré. Le reprendre, ou recommencer et le jeter ?",
      "bodyNoTime": "Un brouillon commencé sur cet appareil n'a jamais été enregistré. Le reprendre, ou recommencer et le jeter ?",
      "resume": "Reprendre",
      "startOver": "Recommencer"
    },
    "repsRange": "Fourchette",
    "repsRangeMin": "Répétitions minimum",
    "repsRangeMax": "Répétitions maximum",
    "prescribeRangeA11y": "Prescrire une fourchette de répétitions sur les séries"
  },
  "me": {
    "targets": {
      "title": "Objectifs",
      "historyByCoach": "Votre coach",
      "errNotFound": "Impossible de trouver vos objectifs. Revenez en arrière et réessayez."
    }
  },
  "coach": {
    "title": "Coach et athlètes",
    "subtitle": "Athlètes que tu entraînes et coachs qui t'entraînent. L'invitation exige le consentement des deux parties avant que les assignations puissent circuler.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Inviter un athlète par email",
    "invitePlaceholder": "athlete@exemple.com",
    "inviteNotePlaceholder": "Note (facultatif)",
    "inviteSend": "Envoyer l'invitation",
    "inviteSending": "Envoi…",
    "inviteSent": "Invitation envoyée. L'athlète la verra à sa prochaine connexion.",
    "athletesHeading": "Athlètes que j'entraîne",
    "coachesHeading": "Coachs qui m'entraînent",
    "athletesEmpty": "Aucun athlète. Invites-en un ci-dessus.",
    "pendingInLabel": "En attente de ta réponse",
    "pendingOutLabel": "En attente de leur réponse",
    "activeLabel": "Actifs",
    "accept": "Accepter",
    "decline": "Refuser",
    "cancel": "Annuler l'invitation",
    "revoke": "Révoquer",
    "leave": "Quitter le coach",
    "busy": "En cours…",
    "loading": "Chargement…",
    "loadFailed": "Échec du chargement. Recharge pour réessayer.",
    "errCode": {
      "invalid_email": "Email mal formée.",
      "email_not_found": "Aucun compte vérifié avec cet email.",
      "peer_required": "Indique une email ou un sub.",
      "edge_exists": "Une relation existe déjà avec ce pair.",
      "userpool_not_configured": "Serveur mal configuré : pool d'utilisateurs indisponible.",
      "io_error": "Erreur réseau ou serveur. Réessaie.",
      "not_pending": "Cette invitation n'est plus en attente.",
      "wrong_party": "Seule l'autre partie peut accepter cette invitation.",
      "missing_claims": "Ta session a expiré. Reconnecte-toi.",
      "table_not_configured": "Serveur mal configuré : table indisponible.",
      "not_found": "Cette invitation n'existe plus."
    },
    "dashboard": {
      "title": "Vue d'ensemble de l'équipe",
      "unnamedAthlete": "Athlète",
      "empty": "Aucun athlète pour l'instant",
      "emptySub": "Invitez des athlètes depuis Coach et athlètes pour les voir ici.",
      "loading": "Chargement de votre équipe…",
      "loadFailed": "Impossible de charger l'équipe. Actualisez pour réessayer.",
      "noProgram": "Aucun programme",
      "kpiAssigned": "Athlètes",
      "kpiActive": "Actifs cette semaine",
      "kpiAttention": "À surveiller",
      "kpiAdherence": "Adhérence moyenne",
      "kpiSessions": "Séances cette semaine",
      "kpiNotLoaded": "Non chargés : {{count}}. Comptés seulement dans Athlètes.",
      "adherence": "adhérence",
      "lastNever": "jamais entraîné",
      "flagStale": "Ne s'entraîne pas",
      "flagUnderTarget": "Sous l'objectif",
      "flagOnTrack": "Dans les temps",
      "flagNoProgram": "Aucun programme"
    },
    "detail": {
      "back": "Retour à l'équipe",
      "maxesTitle": "MAX actuels",
      "maxesEmpty": "Aucun MAX enregistré",
      "rhythmSummary": "moyenne {{avg}}/semaine sur {{weeks}} semaines · semaine dernière : {{last}}",
      "effortTitle": "Couverture de l'effort",
      "effortLabel": "séries avec RIR enregistré",
      "effortSummary": "{{tagged}} séries sur {{counted}} comptées, échauffements inclus",
      "effortEra": "Les données d'effort commencent le {{date}} · {{count}} séries antérieures ne sont pas comptées",
      "effortNone": "Aucune série ne porte encore de valeur d'effort : les chiffres des séries difficiles et des cibles n'ont rien sur quoi s'appuyer.",
      "effortError": "Impossible de charger les données d'effort.",
      "maxesSeeAll": "Tout afficher (+{{count}})",
      "maxesShowFewer": "Réduire",
      "assignProgram": "Assigner un programme"
    },
    "targets": {
      "eyebrow": "Objectifs hebdomadaires",
      "edit": "Modifier les objectifs",
      "degradedHint": "Cet athlète n'a pas encore d'objectifs hebdomadaires. Définissez-en pour évaluer sa semaine par rapport à un but.",
      "noGrant": "Lecture seule — l'athlète ne vous a pas accordé la modification des objectifs.",
      "historyTitle": "Historique des modifications",
      "historyEmpty": "Aucune modification pour l'instant.",
      "historyByYou": "Vous",
      "historyTruncated": "Affichage des 1000 modifications les plus récentes.",
      "histGeneric": "Objectifs mis à jour",
      "histSet": "défini à {{value}}",
      "histRemoved": "supprimé",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}} : {{body}}",
      "historyLoading": "Chargement…",
      "errLoad": "Impossible de charger ces objectifs. Revenez en arrière et réessayez.",
      "errStale": "Ces objectifs ont changé pendant votre modification. Rechargez et réappliquez.",
      "errNoGrant": "L'athlète ne vous a pas accordé la modification des objectifs.",
      "errNotCoach": "Vous n'êtes pas le coach de cet athlète.",
      "errMultiAssignee": "Ce programme est partagé par plusieurs athlètes.",
      "errRetry": "Chargement en cours, réessayez dans un instant.",
      "errNotFound": "Ce programme n'existe plus.",
      "errOffline": "Échec de l'enregistrement. Vérifiez votre connexion et réessayez."
    },
    "assignPicker": {
      "title": "Assigner à {{name}}",
      "cancel": "Annuler",
      "rowA11y": "Assigner {{name}}",
      "assignedTitle": "Envoyé",
      "assignedBody": "Envoyé à {{name}} — en attente d'acceptation.",
      "alreadyTitle": "Déjà assigné",
      "alreadyBody": "{{name}} l'a déjà.",
      "errAssign": "Impossible d'assigner. Réessayez."
    },
    "sessions": {
      "title": "Séances",
      "setsTitle": "Séries",
      "noSets": "Aucune série enregistrée dans cette séance.",
      "setA11y": "Série {{n}} : {{summary}}",
      "loadFailed": "Impossible de charger les séances.",
      "unavailable": "Impossible d'ouvrir cette séance. Reviens en arrière et réessaie."
    }
  },
  "plans": {
    "assign": "Assigner",
    "title": "Plans",
    "help": "Prépare une séance pour toi. Les cibles peuvent être en kg absolus ou en pourcentage du MAX, converties en kg au démarrage du plan.",
    "loading": "Chargement des plans…",
    "empty": "Aucun plan pour l'instant. Ajoutes-en un pour préparer ta séance.",
    "todayPill": "Aujourd'hui",
    "add": "Ajouter un plan",
    "edit": "Modifier",
    "start": "Démarrer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Plan enregistré.",
    "savedEdit": "Plan mis à jour.",
    "deleted": "Plan supprimé.",
    "delete": "Supprimer",
    "deleting": "Suppression…",
    "deleteConfirm": "Supprimer ce plan ?",
    "creatingTitle": "Nouveau plan",
    "editingTitle": "Modifier le plan",
    "name": "Nom",
    "namePlaceholder": "p. ex. Jour squat",
    "scheduledFor": "Date prévue (optionnel)",
    "pickDate": "Choisis une date",
    "pickDateHint": "Ouvre le sélecteur de date",
    "clearDate": "Effacer la date",
    "noDate": "Non définie",
    "notes": "Notes (optionnel)",
    "rpeEnabledLabel": "Afficher la colonne RPE dans le Logger",
    "rpeEnabledHelp": "Quand activé, les sessions démarrées depuis ce plan s'ouvrent avec la colonne RPE visible. L'athlète peut quand même la basculer par session.",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisis un exercice",
    "exerciseN": "Exercice {{n}}",
    "removeExercise": "Retirer l'exercice",
    "addExercise": "Ajouter un autre exercice",
    "setsLegend": "Séries",
    "targetReps": "Reps",
    "targetWeight": "Poids",
    "targetKind": "Unité",
    "targetRpe": "RPE",
    "noMaxYet": "pas de MAX",
    "addSet": "Ajouter une série",
    "removeSet": "Retirer la série",
    "statusDraft": "Brouillon",
    "statusScheduled": "Planifié",
    "statusCompleted": "Terminé",
    "statusSkipped": "Sauté",
    "errNotSignedIn": "Connexion requise.",
    "errNameRequired": "Donne un nom au plan.",
    "errPickExercise": "Choisis un exercice du catalogue.",
    "errNoSets": "Ajoute au moins une série valide.",
    "errGroupKindMixed": "Deux exercices partagent un group id mais l'un est un superset et l'autre un circuit. Choisis-en un et resauvegarde.",
    "errCode": {
      "invalid_email": "Cette adresse email semble invalide.",
      "email_not_found": "Aucun compte trouvé avec cet email.",
      "too_many_assignees": "20 personnes maximum par programme."
    },
    "assignTo": "Assigner aux athlètes",
    "assignToHelp": "L'assigner est une proposition : il entre dans sa bibliothèque seulement s'il accepte, et ce qu'il a accepté lui reste si tu le retires. Une relation coach active est requise.",
    "assignSelf": "Toi (auteur)",
    "addAssignee": "Ajouter",
    "removeAssignee": "Retirer",
    "removeAssigneeConfirm": "Retirer l'accès ?",
    "removeAssigneeHint": "L'athlète le perdra de sa bibliothèque. Appuie encore pour retirer.",
    "pendingAssigneeCaption": "En attente",
    "rosterSectionLabel": "Depuis ton roster",
    "rosterEmpty": "Aucun athlète dans ton roster pour l'instant.",
    "rosterAllAssigned": "Tous les athlètes de ton roster sont déjà assignés.",
    "shareTo": "Partager avec",
    "shareToHelp": "Partager est une proposition : cela n'arrive dans leur bibliothèque que s'ils acceptent, et ce qu'ils ont accepté leur reste même si tu les retires.",
    "shareSectionLabel": "Personnes avec qui partager",
    "shareEmpty": "Tu n'as encore personne avec qui partager.",
    "shareAllShared": "Tout le monde avec qui tu peux partager l'a déjà.",
    "emailSectionLabel": "Par email",
    "assigneePlaceholder": "nom@exemple.com",
    "invalidEmailFormat": "Ça ne ressemble pas à une adresse email valide.",
    "exerciseNew": "Choisir un exercice",
    "setIndex": "Série {{n}}",
    "cardMenu": "Menu de la carte",
    "menuGroup": "Groupe",
    "menuMoveUp": "Monter",
    "menuMoveDown": "Descendre",
    "groupNone": "Aucun groupe",
    "groupJoinExisting": "Rejoindre un groupe",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "details": "Détails",
    "exercisesLabel": "Exercices",
    "editorEmpty": "Aucun exercice pour l’instant. Ajoutez-en un pour composer ce plan.",
    "selectExercisePrompt": "Sélectionnez un exercice pour modifier ses séries.",
    "addExerciseCta": "Ajouter un exercice",
    "removeExerciseConfirm": "Supprimer cet exercice ?",
    "removeExerciseHint": "Touchez une fois pour confirmer, puis touchez à nouveau pour supprimer.",
    "collapseExercise": "Réduire l’exercice",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Note d’exercice (optionnel)"
  },
  "templates": {
    "show": "Parcourir les modèles de base",
    "hide": "Masquer les modèles",
    "help": "Plans et programmes prêts à l'emploi. Clone-en un dans ton compte — la copie t'appartient, modifie-la ou supprime-la sans toucher au modèle.",
    "loading": "Chargement des modèles…",
    "empty": "Aucun modèle disponible pour le moment.",
    "errLoad": "Impossible de charger les modèles.",
    "clone": "Cloner chez moi",
    "cloning": "Clonage…",
    "cloned": "« {{name}} » cloné.",
    "alreadyCloned": "Déjà cloné",
    "difficultyBeginner": "Débutant",
    "difficultyIntermediate": "Intermédiaire",
    "difficultyAdvanced": "Avancé",
    "planMeta": "{{n}} exercice(s)",
    "programMeta": "Cycle de {{weeks}} semaines · {{sessions}}× / semaine"
  },
  "maxes": {
    "title": "Maxes",
    "countLabel_one": "{{count}} défini",
    "countLabel_other": "{{count}} définis",
    "help": "Le MAX, c'est ce que tu peux soulever aujourd'hui, fixé par toi. Les programmes l'utilisent comme base de pourcentage. Le 1RM estimé dans Progression est purement informatif.",
    "loading": "Chargement des maxes…",
    "empty": "Aucun max défini. Ajoutes-en un pour piloter la programmation en pourcentage.",
    "add": "Ajouter un max",
    "edit": "Modifier",
    "delete": "Supprimer",
    "deleteAction": "Supprimer le MAX",
    "deleting": "Suppression…",
    "deleted": "MAX supprimé.",
    "deleteConfirm": "Supprimer le MAX de {{name}} ? L'historique est aussi supprimé. Le prochain seed depuis l'historique pourra le repopuler depuis tes séances.",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisir un exercice",
    "value": "Valeur",
    "source": "Origine",
    "sourceManual": "Saisie manuelle",
    "sourceTested": "Testé en salle",
    "sourceDerived": "Dérivé d'une série loguée",
    "sourceCalculated": "Estimé depuis l'historique",
    "sourceImported": "Importé",
    "notes": "Notes (facultatif)",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Max enregistré.",
    "cancel": "Annuler",
    "errPickExercise": "Choisis un exercice.",
    "errInvalidValue": "Entre une valeur entre 0 et 2000.",
    "seed": {
      "start": "Suggérer depuis l'historique",
      "loading": "Lecture de l'historique…",
      "reviewIntro": "{{count}} exercices ont une série top crédible dans ton historique. Choisis ceux à utiliser comme MAX. Les exercices déjà dotés d'un MAX sont ignorés.",
      "selectAll": "Tout sélectionner",
      "selectNone": "Tout désélectionner",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "cancel": "Annuler",
      "apply": "Définir {{count}} MAX",
      "applying": "Enregistrement : {{done}} / {{total}}",
      "applied": "{{count}} MAX définis depuis l'historique.",
      "noneApplicable": "Rien à définir. Soit chaque exercice a déjà un MAX, soit aucun historique avec charge n'a été trouvé.",
      "close": "Fermer"
    }
  },
  "progress": {
    "coverageTitle": "Couverture musculaire",
    "coverageSeeAll": "Voir tous les muscles (+{{count}})",
    "coverageShowFewer": "Afficher moins",
    "coverageCompact": {
      "doneOfExpected": "{{done}} / {{expected}} à ce jour",
      "doneOfExpectedA11y_one": "{{done}} sur {{expected}} série à ce jour",
      "doneOfExpectedA11y_other": "{{done}} sur {{expected}} séries à ce jour",
      "behind": "{{n}} de retard",
      "onPace": "dans le rythme",
      "titleBehind_one": "{{count}} série de retard sur le rythme",
      "titleBehind_other": "{{count}} séries de retard sur le rythme",
      "titleOnPace": "Dans le rythme",
      "subtitle": "séries difficiles à ce jour par rapport au rythme de la bande"
    },
    "period": {
      "days": "{{days}} j",
      "painDays": "7 / {{days}} j"
    },
    "title": "Progression",
    "show": "Afficher",
    "hide": "Masquer",
    "help": "Le MAX est la valeur que tu fixes toi-même ; le 1RM estimé suit Epley comme référence. Le volume est la somme de poids fois répétitions sur la séance.",
    "e1rm": "1RM estimé",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "1RM estimé en pointillé",
    "volume": "Volume",
    "sessions": "{{n}} séances",
    "prFound": "Record personnel à {{weight}}.",
    "prUpdating": "Mise à jour…",
    "viewByExercise": "Par exercice",
    "viewByTag": "Par tag",
    "noTags": "Aucune séance taggée pour l'instant. Tagge les exercices dans le catalogue pour voir le volume agrégé ici.",
    "totalVolume": "Total {{weight}}",
    "recordsScope": "Records",
    "recordsAllTime": "Tout",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filtrer les exercices",
    "filterCount": "{{visible}} sur {{total}}",
    "filterNoMatch": "Aucun exercice ne correspond au filtre.",
    "coverageNoData": "Rien à évaluer pour l'instant : enregistre une séance, ou fixe un objectif hebdomadaire.",
    "volumeLandmark": {
      "source": {
        "rp": "Renaissance Periodization"
      },
      "citation": {
        "rp": "Repères de pratique publiés. La variabilité individuelle est grande — tes données resserrent cette plage."
      },
      "zone": {
        "belowMev": "sous MEV",
        "mevMav": "MEV–MAV",
        "mavMrv": "MAV–MRV",
        "aboveMrv": "au-dessus de MRV",
        "noBand": "aucune bande publiée"
      },
      "yourTarget": "ton objectif {{v}}",
      "athleteTarget": "objectif {{v}}",
      "sets_one": "{{n}} série",
      "sets_other": "{{n}} séries"
    },
    "chartGapShort": "+{{count}}j",
    "chartGapLong_one": "{{count}} jour depuis le point précédent",
    "chartGapLong_other": "{{count}} jours depuis le point précédent",
    "chartMorePoints_one": "+{{count}} autre point",
    "chartMorePoints_other": "+{{count}} autres points",
    "chartWindowA11y": "du {{from}} au {{to}}",
    "chartSummaryA11y": "{{range}}, dernier {{last}}, {{window}}",
    "chartTapHint": "Touchez un point pour lire sa valeur",
    "chartCapped": "Seules les données les plus récentes sont affichées. Les plus anciennes ne figurent pas dans ce graphique.",
    "muscleState": {
      "thin": "Historique trop court pour un rythme : {{n}} séances sur {{needed}}",
      "none": "Aucune série difficile enregistrée",
      "a11yOver": "charge récente {{pct}} % au-dessus du rythme sur 28 jours",
      "a11yUnder": "charge récente {{pct}} % en dessous du rythme sur 28 jours",
      "a11yLevel": "charge récente au niveau du rythme sur 28 jours"
    },
    "gapProposal": {
      "toggle": "Combler l'écart",
      "toMev_one": "<num>{{n}}</num> série/sem jusqu'au MEV",
      "toMev_other": "<num>{{n}}</num> séries/sem jusqu'au MEV",
      "basis": "MEV {{mev}} − moy {{avg}}/sem = {{gap}}/sem",
      "eachAlone": "Chacun de ces exercices le comble à lui seul :",
      "alsoWorks": "travaille aussi {{muscles}}",
      "atPlace": "À {{place}}, sans ce que tu y as marqué comme absent.",
      "noPlace": "Catalogue entier : aucun lieu par défaut.",
      "wholeCatalog": "Catalogue entier : le lieu d'entraînement de l'athlète n'est pas partagé avec les coachs.",
      "noneAtPlace": "Plus rien à {{place}} : chaque exercice pour ce muscle y est marqué absent.",
      "noneInCatalog": "Aucun exercice du catalogue ne travaille ce muscle.",
      "shortHistory_one": "Mesurer l'écart demande 4 semaines complètes d'historique : {{n}} pour l'instant.",
      "shortHistory_other": "Mesurer l'écart demande 4 semaines complètes d'historique : {{n}} pour l'instant.",
      "a11yToggle": "{{muscle}} : combler l'écart, {{gap}} séries par semaine jusqu'au MEV",
      "buildToday": "Construire la séance du jour à partir de ces écarts"
    }
  },
  "cohort": {
    "compare": "Comparer au groupe (anonyme)",
    "hide": "Masquer la comparaison",
    "loading": "Chargement du groupe…",
    "empty": "Pas encore assez de contributions pour afficher une comparaison. Le seuil est de dix personnes dans la même tranche d'âge.",
    "contributors": "Basé sur {{n}} contributions anonymes ayant renseigné leur tranche d'âge.",
    "yourGroup": "ton groupe"
  },
  "catalog": {
    "title": "Catalogue d'exercices",
    "empty": "Aucun exercice pour l'instant.",
    "region": "Zone",
    "region_lower": "Bas du corps",
    "region_posterior": "Chaîne postérieure",
    "region_chest": "Pectoraux",
    "region_back": "Dos",
    "region_shoulders": "Épaules",
    "region_arms": "Bras",
    "region_core": "Tronc",
    "region_cardio": "Cardio",
    "region_other": "Autre",
    "pattern": "Schéma",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Poussée horizontale",
    "pattern_vertical-push": "Poussée verticale",
    "pattern_horizontal-pull": "Tirage horizontal",
    "pattern_vertical-pull": "Tirage vertical",
    "pattern_lunge": "Fente",
    "pattern_carry": "Portage",
    "pattern_core": "Tronc",
    "pattern_isolation": "Isolation",
    "pattern_mobility": "Mobilité",
    "pattern_cardio": "Cardio",
    "pattern_other": "Autre",
    "equipment": "Matériel",
    "equipment_barbell": "Barre",
    "equipment_dumbbell": "Haltères",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Poulie",
    "equipment_machine": "Machine",
    "equipment_bodyweight": "Poids du corps",
    "equipment_band": "Élastique",
    "equipment_other": "Autre",
    "tags": "Tags",
    "equipment_treadmill": "Tapis de course",
    "equipment_exercise-bike": "Vélo d'appartement",
    "equipment_elliptical": "Vélo elliptique",
    "equipment_rower": "Rameur",
    "equipment_stair-climber": "Escalier mécanique",
    "equipment_jump-rope": "Corde à sauter",
    "equipment_battle-ropes": "Cordes ondulatoires",
    "equipment_sled": "Traîneau",
    "deletedExercise": "Exercice supprimé"
  },
  "swap": {
    "title": "Remplacer l'exercice",
    "currentLabel": "Actuel",
    "searchPlaceholder": "Rechercher dans le catalogue…",
    "showAll": "Afficher tous les exercices",
    "noMatches": "Aucun exercice ne correspond à votre recherche.",
    "noSuggestions": "Aucun similaire trouvé via les tags. Cochez « Afficher tous » pour parcourir le catalogue.",
    "close": "Fermer",
    "reasonTags": "Tags communs ×{{count}}",
    "reasonPrimary": "Muscles communs ×{{count}}",
    "reasonDifferentEquipment": "Matériel différent",
    "suggestedSection": "Suggérés",
    "allSection": "Tous les exercices",
    "whichMachine": "Quelle machine ?",
    "defaultMachine": "Machine par défaut",
    "machineLabel": "Machine {{letter}}",
    "setMachine": "Définir la machine",
    "machineChoices": "Machines connues : {{count}}",
    "newMachine": "Nouvelle machine",
    "bandSession": "Séance",
    "bandCurrentExercise": "Cet exercice",
    "bandOtherExercises": "Passer à un autre exercice",
    "equipmentKey": "Matériel",
    "currentConsequence": "Les séries déjà enregistrées restent : seul le matériel sur lequel elles sont notées change.",
    "unavailableTitle": "Pas ici ?",
    "unavailableBody": "Coche le matériel de {{exercise}} qui n'est pas à {{place}}. Seul ce que tu coches est enregistré.",
    "unavailableConfirm": "Enregistrer",
    "unavailableOpen": "Matériel non disponible ici",
    "unavailableOpenHint": "Demande quel matériel de cet exercice manque.",
    "unavailableBadge": "Pas ici",
    "unavailableRestore": "À nouveau disponible ici",
    "unavailableErrorTitle": "Échec de l'enregistrement",
    "unavailableErrorBody": "Le matériel est toujours indiqué comme disponible ici.",
    "unavailableConfirmHint": "Coche au moins un élément pour enregistrer.",
    "pinDefaultMachine": "Toujours utiliser la machine par défaut ici",
    "pinMachine": "Toujours utiliser {{machine}} ici",
    "pinHint": "Fin des questions sur la machine, dans cette salle, pour cet exercice.",
    "pinErrorTitle": "Échec de l'enregistrement",
    "pinErrorBody": "La machine par défaut ici n'a pas changé.",
    "unpinDefaultMachine": "Ne plus toujours utiliser la machine par défaut ici",
    "unpinMachine": "Ne plus toujours utiliser {{machine}} ici",
    "pinnedFootnoteDefault": "Ici, la machine par défaut est toujours utilisée.",
    "pinnedFootnoteMachine": "Ici, {{machine}} est toujours utilisée.",
    "unpinHint": "Retour aux questions sur la machine, dans cette salle, pour cet exercice."
  },
  "tabs": {
    "workout": "Séance",
    "plan": "Programme",
    "progress": "Progrès",
    "profile": "Profil",
    "catalog": "Catalogue",
    "admin": "Admin",
    "workoutEyebrow": "Séance du jour",
    "planEyebrow": "Programmation",
    "progressEyebrow": "Graphiques et rapports",
    "profileEyebrow": "Compte et maxis",
    "catalogEyebrow": "Catalogue des exercices",
    "adminEyebrow": "Console admin",
    "progressEmpty": "Enregistrez d'abord une séance — les graphiques apparaissent quand il y a des données."
  },
  "shell": {
    "navAria": "Navigation principale"
  },
  "theme": {
    "aria": "Thème",
    "light": "Clair",
    "dark": "Sombre",
    "auto": "Auto"
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Pectoraux",
        "biceps": "Biceps",
        "triceps": "Triceps",
        "forearm": "Avant-bras",
        "front-deltoids": "Épaules",
        "back-deltoids": "Deltoïdes arrière",
        "trapezius": "Trapèzes",
        "upper-back": "Dos",
        "lower-back": "Bas du dos",
        "abs": "Tronc",
        "obliques": "Tronc",
        "quadriceps": "Quadriceps",
        "hamstring": "Ischio-jambiers",
        "gluteal": "Fessiers",
        "adductors": "Adducteurs",
        "abductors": "Abducteurs",
        "calves": "Mollets",
        "tibialis": "Tibial",
        "neck": "Cou",
        "head": "Tête"
      }
    },
    "tabs": {
      "workouts": "Entraînements",
      "plan": "Accueil",
      "progress": "Progression",
      "catalog": "Catalogue",
      "profile": "Profil",
      "settings": "Réglages",
      "inbox": "Boîte",
      "athletes": "Athlètes",
      "library": "Bibliothèque",
      "me": "Moi"
    },
    "me": {
      "sectionTraining": "Entraînement",
      "navTargets": "Objectifs",
      "navTargetsSub": "Vos objectifs hebdomadaires"
    },
    "settings": {
      "title": "Réglages",
      "exercisesSection": "Exercices",
      "navExercisesSub": "MAX, catalogue, échelle d'effort",
      "navCatalog": "Catalogue d'exercices",
      "selectPrompt": "Sélectionne un réglage pour l'ouvrir.",
      "navCatalogSub": "Parcourez la bibliothèque d'exercices",
      "navEffort": "Réglages d'effort",
      "navEffortSub": "Échelle RIR / RPE + légende",
      "navLicenses": "Licences open source",
      "navLicensesSub": "Les bibliothèques qui font tourner l'app",
      "sectionAccount": "Compte",
      "sectionTraining": "Entraînement",
      "sectionBody": "Corps",
      "sectionPrefs": "Préférences",
      "sectionCoach": "Coach",
      "sectionAbout": "À propos",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Synchronisez entraînements et données de santé depuis votre appareil"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "$t(brand.product)",
      "pillLabel": "Sources des calories",
      "projectionNote": "Inclut la série que tu vas faire : une projection de toute la séance, pas le travail déjà enregistré.",
      "selected": "sélectionnée"
    },
    "hc": {
      "preferences": "Préférences",
      "caloriesWins": "Health Connect prime sur les calories",
      "caloriesWinsHelp": "Quand les deux existent, affiche les calories mesurées via Health Connect plutôt que l'estimation de $t(brand.product). Désactivé = préférer l'estimation. Sans valeur Health Connect, l'estimation est toujours utilisée.",
      "title": "Health Connect",
      "intro": "Importez l'activité de votre montre et de votre téléphone dans $t(brand.product). Marches, randonnées et sorties à vélo deviennent des séances ; fréquence cardiaque et calories enrichissent les séances que vous enregistrez. Désactivé tant que vous ne connectez pas.",
      "checking": "Vérification…",
      "unavailable": "Health Connect n'est pas disponible sur cet appareil.",
      "updateRequired": "Mettez à jour l'application Health Connect pour continuer.",
      "notConnected": "Non connecté.",
      "connect": "Connecter Health Connect",
      "connectHelp": "Vous choisissez les données que $t(brand.product) peut lire. Modifiable à tout moment dans Health Connect.",
      "connected": "Connecté",
      "reads": "Lit les séances, la fréquence cardiaque et les calories.",
      "syncNow": "Synchroniser",
      "neverSynced": "Pas encore synchronisé.",
      "lastSyncedAt": "Dernière synchro : {{when}}",
      "syncDelayNote": "Une nouvelle activité peut mettre quelques minutes à arriver dans Health Connect depuis votre appareil : une marche ou une sortie vélo récente peut n'apparaître qu'à une synchro ultérieure. Ce délai est normal.",
      "syncFullHistory": "Synchroniser tout l'historique",
      "syncingFullHistory": "Synchronisation de l'historique en cours",
      "syncFullHistoryHelp": "Revérifie tout ton historique et comble les manques dans Health Connect. À utiliser si une correction passée y manque. Peut se relancer sans risque.",
      "resultSummary": "{{imported}} importées · {{enriched}} enrichies · {{skipped}} ignorées",
      "error": "Une erreur s'est produite. Veuillez réessayer.",
      "grantRefused": "Votre compte n'a pas enregistré ce consentement, donc $t(brand.product) ne lira pas Health Connect. Réessayez de vous connecter plus tard.",
      "revokeRefused": "Health Connect est déconnecté sur ce téléphone, mais votre compte n'a pas enregistré le retrait et affiche encore votre consentement. Réessayez plus tard.",
      "revokedElsewhere": "Vous avez retiré votre consentement sur un autre appareil, donc Health Connect est déconnecté sur ce téléphone.",
      "manageInHc": "Gérer dans Health Connect",
      "disconnect": "Déconnecter",
      "disconnectTitle": "Déconnecter Health Connect ?",
      "disconnectBody": "$t(brand.product) cessera de lire vos données Health Connect. Les séances déjà importées restent dans votre historique.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Vos données",
      "privacyBody": "$t(brand.product) ne lit que ce que vous autorisez dans Health Connect, et uniquement sur ce téléphone après connexion. Elles sont stockées dans votre compte $t(brand.product) privé, jamais partagées ni vendues. Déconnectez-vous à tout moment pour arrêter.",
      "explainerTitle": "Ce que $t(brand.product) lit, et pourquoi",
      "explainerIntro": "Android vous le demande ensuite. Vous pouvez tout autoriser, une partie ou rien, et changer d'avis à tout moment dans Health Connect.",
      "explainerContinue": "Continuer vers Android",
      "explainerCancel": "Pas maintenant",
      "consentGiven": "Consentement donné le {{when}}.",
      "consentWithdrawn": "Consentement donné le {{given}}, retiré le {{withdrawn}}.",
      "consentWithdrawnOnly": "Consentement retiré le {{withdrawn}}.",
      "consentBeforeRecord": "Consentement donné avant que $t(brand.product) n'en enregistre la date.",
      "consentCategories": "Ce que vous avez autorisé",
      "consentRecordNote": "Ce registre appartient à votre compte et garde chaque consentement et chaque retrait avec sa date. Android donne l'autorisation sur chaque téléphone séparément.",
      "explainerMore": "La suite est plus bas, faites défiler pour tout lire.",
      "deviceAllowed": "Sur ce téléphone : autorisé par Android.",
      "deviceNotAllowed": "Sur ce téléphone : non autorisé par Android.",
      "driftDeviceOff": "Votre compte détient votre consentement, mais Android ne l'autorise plus sur ce téléphone. Autorisez-le à nouveau pour synchroniser ici.",
      "driftNoRecord": "Android l'autorise sur ce téléphone, mais votre compte ne détient aucun consentement en cours. Revoyez ce que $t(brand.product) lit, puis confirmez dans la demande d'Android. Votre compte l'enregistre avec la date du jour.",
      "driftUndated": "Votre consentement n'a pas encore de date. Revoyez ce que $t(brand.product) lit, puis confirmez dans la demande d'Android : votre compte l'enregistre avec la date du jour.",
      "allowOnPhone": "Autoriser sur ce téléphone",
      "confirmConsent": "Revoir et confirmer",
      "permOther": "Autre autorisation",
      "perm": {
        "readExerciseSession": {
          "name": "Séances d'exercice",
          "use": "Une marche, une course ou une sortie à vélo enregistrée par votre montre ou votre téléphone apparaît dans votre fil comme une séance."
        },
        "readHeartRate": {
          "name": "Fréquence cardiaque",
          "use": "La fréquence moyenne et maximale s'affichent sur chaque séance, et servent à l'estimation des calories."
        },
        "readActiveCaloriesBurned": {
          "name": "Calories actives",
          "use": "Les calories mesurées s'affichent sur chaque séance, à côté de l'estimation."
        },
        "readDistance": {
          "name": "Distance",
          "use": "Complète la distance des séries cardio d'une séance venue de votre montre ou de votre téléphone."
        },
        "readWeight": {
          "name": "Poids",
          "use": "Rejoint l'historique et la courbe de votre poids dans Corps."
        },
        "readBodyFat": {
          "name": "Masse grasse",
          "use": "S'affiche sur la courbe de composition corporelle dans Corps."
        },
        "readLeanBodyMass": {
          "name": "Masse maigre",
          "use": "S'affiche sur la courbe de composition corporelle dans Corps."
        },
        "readNutrition": {
          "name": "Nutrition",
          "use": "Les glucides du jour s'affichent sur la carte Métabolique, à côté de votre glycémie."
        },
        "readBloodGlucose": {
          "name": "Glycémie",
          "use": "Vos mesures s'affichent sur la carte Métabolique, en courbe et en dernière valeur."
        },
        "writeBloodGlucose": {
          "name": "Écriture de la glycémie",
          "use": "Une glycémie saisie dans $t(brand.product) est aussi enregistrée dans Health Connect."
        },
        "writeWeight": {
          "name": "Écriture du poids",
          "use": "Une pesée saisie dans $t(brand.product) est aussi enregistrée dans Health Connect."
        }
      },
      "bodyResult": "{{imported}} corporelles importées · {{skipped}} ignorées",
      "bodyNotGranted": "Données corporelles pas encore autorisées. Touchez Autoriser les données corporelles.",
      "readsFull": "Lit les séances, la fréquence cardiaque et les calories, le poids et la composition corporelle, la glycémie et la nutrition. Écrit la glycémie et le poids dans Health Connect.",
      "backfillTitle": "Importer l'historique depuis mai ?",
      "backfillBody": "Parcourt ton historique Health Connect jusqu'à mai et importe ce qui manque. Tu peux le relancer sans risque: les éléments déjà importés sont ignorés.",
      "backfillNow": "Importer l'historique",
      "grantExtra": "Autoriser les données santé",
      "extraGrantBody": "Importe aussi le poids, la composition corporelle, la glycémie et la nutrition.",
      "metabolicResult": "{{glucose}} glycémie · {{nutrition}} nutrition importées",
      "metabolicNotGranted": "Glycémie et nutrition pas encore autorisées.",
      "writeGlucoseGrantBody": "Autoriser $t(brand.product) à écrire la glycémie dans Health Connect.",
      "grantWrite": "Autoriser l'écriture",
      "syncGlucoseToHc": "Écrire la glycémie dans Health Connect"
    },
    "metabolic": {
      "title": "Métabolique",
      "loading": "Chargement…",
      "empty": "Connecte Health Connect et synchronise pour voir ici la glycémie et la nutrition.",
      "glucoseEmpty": "Aucune valeur de glycémie",
      "mgdl": "mg/dL",
      "targetBand": "Plage cible typique {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Glucides aujourd'hui",
      "grams": "g",
      "glucoseTitle": "Glycémie",
      "glucoseCurrent": "Dernière : {{value}} {{unit}}",
      "glucoseNone": "Enregistre une valeur pour suivre ta glycémie.",
      "help": "Ta glycémie depuis Health Connect, avec les glucides récents en dessous. Touche un point du graphique pour lire sa valeur et son heure."
    },
    "exercisesScreen": {
      "back": "Retour"
    },
    "body": {
      "back": "Retour",
      "title": "Corps",
      "navTitle": "Corps",
      "navSub": "Sexe, âge, silhouette",
      "navPainMapSub": "Marque où tu as mal",
      "trendsWebHint": "Les graphiques de composition corporelle sont dans l'app mobile.",
      "sexLabel": "Sexe",
      "sexHelp": "Utilisé uniquement pour l'estimation du taux de masse grasse. La silhouette de la carte musculaire est un choix distinct ci-dessous.",
      "sex_male": "Homme",
      "sex_female": "Femme",
      "measurementsTitle": "Mensurations",
      "measurementsSub": "Poids, circonférences, estimation de masse grasse",
      "measureTitle": "NOUVELLE MESURE",
      "weight": "Poids",
      "field_heightCm": "Taille",
      "field_neckCm": "Cou",
      "field_chestCm": "Poitrine",
      "field_waistCm": "Tour de taille",
      "field_hipsCm": "Hanches",
      "field_bicepsLCm": "Biceps (G)",
      "field_bicepsRCm": "Biceps (D)",
      "field_forearmsLCm": "Avant-bras (G)",
      "field_forearmsRCm": "Avant-bras (D)",
      "field_thighsLCm": "Cuisse (G)",
      "field_thighsRCm": "Cuisse (D)",
      "field_calvesLCm": "Mollet (G)",
      "field_calvesRCm": "Mollet (D)",
      "measureSave": "Enregistrer les valeurs saisies",
      "measureHelpC": "Remplis seulement ce que tu as mesuré. Les champs vides ne sont pas enregistrés.",
      "useLastA11y": "Utiliser la dernière valeur {{value}}",
      "saveFailedTitle": "Échec de l'enregistrement",
      "saveFailedBody": "Ta mesure n'a pas été enregistrée. Tes valeurs sont conservées — touche Enregistrer pour réessayer.",
      "editTitle": "MODIFIER — {{date}}",
      "saveChanges": "Enregistrer les modifications",
      "editCancelA11y": "Annuler la modification",
      "editRowA11y": "Modifier la mesure {{date}}",
      "editHelp": "Modifie une valeur, ou efface-la pour la retirer de l'historique.",
      "trendsLabel": "TENDANCES",
      "trendsHint": "choisir les mesures",
      "trendsExpandA11y": "Afficher toutes les mesures",
      "trendsCollapseA11y": "Réduire les mesures",
      "trendsPick": "Choisis une mesure ci-dessus pour voir sa tendance.",
      "metricComposition": "Composition",
      "metricBodyFat": "Masse grasse",
      "metricLeanMass": "Masse maigre",
      "loadError": "Impossible de charger les mesures — vérifie ta connexion.",
      "navyTitle": "COMPOSITION CORPORELLE (NAVY)",
      "navyNeedsEntry": "Enregistrez une mesure ci-dessous pour estimer la masse grasse.",
      "navyNeedsSex": "Définissez votre sexe ci-dessus pour estimer la masse grasse.",
      "navyNeedsInputs": "Ajoutez taille, cou et tour de taille (et hanches, pour la formule féminine) pour estimer la masse grasse.",
      "navyBodyFat": "Masse grasse ≈ {{pct}} %",
      "navyLeanMass": "Masse maigre ≈ {{mass}}",
      "navyDisclaimer": "Estimation US Navy (~±3,5 %). Observez la tendance, pas le chiffre isolé.",
      "historyEmpty": "Aucune mesure pour l'instant. Enregistrez-en une ci-dessus pour commencer le suivi.",
      "historyTitle": "HISTORIQUE",
      "trendWeight": "TENDANCE DU POIDS",
      "trendBodyFat": "TENDANCE MASSE GRASSE",
      "deleteTitle": "Supprimer la mesure ?",
      "deleteEmptyTitle": "Retirer cette mesure ?",
      "deleteEmptyBody": "Toutes ses valeurs sont effacées, l'entrée sera donc supprimée.",
      "deleteCancel": "Annuler",
      "deleteConfirm": "Supprimer",
      "ageLabel": "Âge",
      "ageHelp": "Facultatif. Touche à nouveau pour effacer.",
      "dualCurveLegend": "Plein : estimation · Tirets : Health Connect",
      "estimateSeriesName": "Estimation",
      "bodyFatProvenance": "La masse grasse se calcule à partir de la taille et du cou.",
      "bodyFatProvenanceWithHips": "La masse grasse se calcule à partir de la taille, du cou et des hanches.",
      "trendsHelp": "Un graphique par mesure choisie ci-dessus. Touche un point d'un graphique pour lire sa valeur et sa date."
    },
    "effortSettings": {
      "back": "Retour",
      "title": "Effort",
      "scaleLabel": "Échelle d'effort",
      "scaleHelp": "L'échelle utilisée par le Logger. RIR = répétitions encore en réserve ; RPE = effort perçu. RPE = 10 − RIR, c'est donc le même effort sur deux échelles."
    },
    "plan": {
      "currentBlockError": "Impossible de définir le bloc actuel. Réessaie.",
      "currentBlockOn": "Bloc actuel — appuie pour retirer",
      "currentBlockOff": "Définir comme bloc actuel",
      "currentBlockHint": "Épingle les objectifs hebdomadaires de ce programme au compteur de l'accueil",
      "title": "Plan",
      "start": "Démarrer",
      "starting": "Ouverture…",
      "programWeekSession": "Semaine {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Dernière : S{{week}} · {{session}}",
      "programNextHeader": "À suivre",
      "programStartCta": "▶ Démarrer {{session}}",
      "programChangeLink": "Changer semaine ou séance ›",
      "carouselPosition": "Programme {{n}} sur {{total}}",
      "carouselPrev": "Programme précédent",
      "carouselNext": "Programme suivant",
      "programWeekLabel": "Semaine",
      "singleCycle": "Cycle unique, identique chaque semaine",
      "programSessionLabel": "Séance",
      "programWeekShort": "S{{n}}",
      "programDayShort": "J{{n}}",
      "sessionN": "Séance {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Démarrer S{{week}} · {{session}}",
      "cancel": "Annuler",
      "newWorkout": "Nouvel entraînement",
      "programsHint": "Cycles multi-semaines qui avancent automatiquement quand tu enregistres les séances.",
      "planDeleteTitle": "Supprimer le plan ?",
      "programDeleteTitle": "Supprimer le programme ?",
      "programStatusError": "Impossible de mettre à jour le programme. Réessayez.",
      "view": "Voir",
      "hide": "Masquer",
      "programUnfollowHint": "Ne plus suivre ce programme (il reste dans Mes programmes)",
      "programNextInline": "Suivant : W{{week}} · {{session}}",
      "programStartA11y": "Démarrer {{session}}",
      "startPlanA11y": "Démarrer {{name}}"
    },
    "preview": {
      "muscles": "Muscles",
      "noSets": "Aucune série prévue",
      "alternates": "Alternatives : {{names}}",
      "gridTitle": "Intensité · jour × semaine",
      "gridHint": "Touchez un jour pour voir ses mouvements.",
      "matrixTitle": "Intensité · par série",
      "matrixHint": "Touchez un exercice pour voir ses séries.",
      "restDay": "Repos / léger",
      "intensity": {
        "work": "travail",
        "moderate": "modéré",
        "heavy": "lourd",
        "max": "Max",
        "free": "libre"
      }
    },
    "catalog": {
      "title": "Catalogue",
      "search": "Rechercher des exercices",
      "empty": "Aucun exercice ne correspond.",
      "back": "Retour",
      "notFound": "Exercice introuvable.",
      "metaPrimaryMuscle": "Muscle principal",
      "metaPattern": "Pattern",
      "metaEquipment": "Équipement",
      "metaP1RM": "Programmable",
      "metaP1RMYes": "Oui",
      "metaP1RMNo": "Non",
      "metaDefaultBar": "Barre par défaut",
      "metaBarLoading": "Chargement",
      "metaBarLoadingSingleSide": "Un seul côté",
      "aliasesLabel": "Aussi appelé",
      "tagsLabel": "Tags",
      "historyLabel": "Séances récentes",
      "historyEmpty": "Aucune séance passée pour cet exercice.",
      "historyError": "Impossible de charger l'historique.",
      "historyBodyweight": "{{reps}} reps au poids du corps",
      "recordsLabel": "Records",
      "recordsEmpty": "Pas encore de record.",
      "selectPrompt": "Sélectionnez un exercice pour voir ses détails.",
      "recordsError": "Impossible de charger les records.",
      "refreshing": "Mise à jour…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Retour",
      "search": "Rechercher des exercices",
      "empty": "Aucun exercice ne correspond.",
      "editCancel": "Annuler",
      "editSave": "Enregistrer",
      "errInvalid": "Saisis un poids valide.",
      "clearAction": "Retirer le MAX",
      "clearTitle": "Retirer ce MAX ?",
      "clearBody": "La valeur et l'historique restent sur le serveur, mais le MAX sera marqué comme non défini.",
      "clearCancel": "Annuler",
      "clearConfirm": "Retirer",
      "selectPrompt": "Sélectionne un exercice pour définir son MAX.",
      "unitChipLabel": "Unité de poids : {{unit}}",
      "unitKg": "kilogrammes",
      "unitLb": "livres",
      "unitChipHint": "Change l'unité et convertit la valeur",
      "notSet": "Non défini",
      "loadFailed": "Chargement impossible"
    },
    "login": {
      "title": "$t(brand.product)",
      "subtitle": "Connexion à ton compte",
      "submit": "Se connecter"
    },
    "workouts": {
      "title": "Entraînements",
      "empty": "Aucun entraînement enregistré.",
      "fallbackName": "Entraînement",
      "endOfList_one": "{{count}} séance, fin de la liste.",
      "endOfList_other": "{{count}} séances, fin de la liste.",
      "newButton": "Nouveau",
      "queueDismissCancel": "Annuler",
      "editUnsupportedTitle": "Modification non encore disponible sur mobile",
      "editUnsupportedBody": "Cet entraînement contient des types d'exercices (P1RM, loaded carry) que le logger mobile ne sait pas encore modifier. Ouvre-le dans l'app web.",
      "editUnsupportedAck": "OK",
      "repeat": "Répéter l'entraînement",
      "resumePillAction": "Reprendre",
      "resumePillFallback": "Entraînement en cours",
      "cancel": "Annuler",
      "loadOlder": "Charger les mois précédents",
      "selectPrompt": "Sélectionne un entraînement pour voir son résumé.",
      "loadError": "Impossible de charger cette séance.",
      "importedBadge": "Importé"
    },
    "outboxDetail": {
      "errCorrectionTooBig": "Trop de séries modifiées d'un coup pour le serveur.",
      "errCorrectionBusy": "Le serveur était occupé avec cette séance.",
      "errCorrectionConflict": "Cette séance a changé sur un autre appareil.",
      "errCorrectionStale": "Cette séance a été enregistrée à nouveau après le début de la correction.",
      "errCorrectionTimes": "La séance se termine avant de commencer.",
      "errCorrectionGone": "Cette séance a été supprimée sur un autre appareil.",
      "errSetsUnknownExercise": "Le serveur n'a pas reconnu un exercice de cette séance.",
      "errSetsInvalidTag": "Le serveur n'a pas accepté un tag sur une série de cette séance.",
      "errSetsInvalid": "Le serveur a jugé invalides certaines séries de cette séance.",
      "errSetsNotSaved": "Toutes les séries ne sont pas arrivées au serveur.",
      "close": "Fermer",
      "empty": "Plus rien à envoyer.",
      "statusQueued": "En file",
      "statusSending": "Envoi en cours",
      "statusFailed4xx": "Le serveur a refusé",
      "statusPermanentFail": "J'ai renoncé",
      "attempts_one": "{{count}} tentative",
      "attempts_other": "{{count}} tentatives",
      "dismissOne": "Abandonner",
      "dismissOneTitle": "Abandonner cet entraînement ?",
      "dismissOneBody": "L'entraînement du {{date}} sera supprimé sans être enregistré.",
      "dismissCancel": "Annuler",
      "dismissConfirm": "Abandonner",
      "retryAll": "Tout réessayer",
      "queueWorkout": "Séance",
      "queueWorkoutNote": "Note de séance",
      "queueMeasurement": "Mesure",
      "queueMax": "Maximum",
      "queueProfile": "Profil",
      "queueHealth": "Données santé",
      "queueMetabolic": "Données métaboliques",
      "queueRequest": "Modification",
      "stuckTitle": "Enregistrements non passés"
    },
    "progress": {
      "title": "Progression",
      "windowAll": "Séances récentes",
      "window30d": "30 derniers jours",
      "window7d": "7 derniers jours",
      "lastSession": "Dernière séance",
      "frequencyTitle": "Fréquence hebdomadaire",
      "frequencyHelp": "Séances par semaine, la semaine en cours à droite.",
      "rhythmThisWeek": "Cette semaine jusqu'ici : {{n}}",
      "rhythmAverageWeeks_one": "Moyenne sur {{count}} semaine complète : {{avg}}",
      "rhythmAverageWeeks_other": "Moyenne sur {{count}} semaines complètes : {{avg}}",
      "weekBars": {
        "thisWeek": "cette semaine jusqu'ici",
        "weekOf": "semaine du {{date}}",
        "sessions": "Séances"
      },
      "weekStreakCurrent": "Série actuelle",
      "weekStreakBest": "Meilleure série",
      "weekStreakWeeks_one": "semaine",
      "weekStreakWeeks_other": "semaines",
      "weekStreakStatA11y_one": "{{label}} : {{count}} semaine",
      "weekStreakStatA11y_other": "{{label}} : {{count}} semaines",
      "weekStreakWithThisWeek_one": "{{count}} semaine d'affilée avec au moins une séance, cette semaine comprise.",
      "weekStreakWithThisWeek_other": "{{count}} semaines d'affilée avec au moins une séance, cette semaine comprise.",
      "weekStreakUpToLastWeek_one": "{{count}} semaine d'affilée avec au moins une séance, jusqu'à la semaine dernière. Cette semaine est encore ouverte.",
      "weekStreakUpToLastWeek_other": "{{count}} semaines d'affilée avec au moins une séance, jusqu'à la semaine dernière. Cette semaine est encore ouverte.",
      "weekStreakNone": "Aucune séance la semaine dernière et aucune encore cette semaine. Cette semaine est encore ouverte.",
      "weekStreakEmpty": "Aucune séance pour l'instant.",
      "weekStreakSessionsHelp": "Séances de chaque semaine. La colonne en contour est la semaine en cours : elle compte déjà.",
      "recordsTitle": "Records",
      "recordsHelp": "Meilleurs records par répétition par exercice. Plus récents en premier.",
      "recordsAllTime": "Tout temps",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filtrer par exercice",
      "recordsNoMatch": "Aucun exercice ne correspond au filtre.",
      "tagVolumeTitle": "Volume par tag",
      "tagVolumeWeeksHelp": "Le volume d'entraînement d'un muscle par semaine. Choisis le muscle.",
      "recordsEmpty": "Aucun record — enregistre quelques séries pour démarrer.",
      "chartE1rm": "1RM estimé",
      "chartVolume": "Volume",
      "chartLoadFailed": "Impossible de charger le graphique.",
      "chartEmpty": "Aucune série avec poids sur la fenêtre récente.",
      "viewByExercise": "Par exercice",
      "viewByTag": "Par tag",
      "noTags": "Aucun volume sur un muscle ces dernières semaines.",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "avec aperçu e1RM",
      "prFound": "Record trouvé : {{weight}}",
      "prUpdating": "Mise à jour…",
      "painSeverity": {
        "red": "rouge",
        "yellow": "jaune",
        "green": "vert"
      },
      "balance": {
        "title": "Équilibre des mouvements",
        "help": "Séries et volume par schéma de mouvement sur {{days}} jours, triés par séries. Le petit chiffre « X/7 j » compte les 7 derniers de ces jours, utile pour repérer une poussée récente isolée (ou une baisse délibérée) que la fenêtre plus longue masque."
      },
      "empty": "Aucune activité récente à comparer",
      "pain": {
        "title": "Douleur × volume",
        "help": "Pour chaque muscle signalé dans votre carte de douleur, affiche la charge d’entraînement récente. Point rouge = douleur signalée rouge (évitez les charges lourdes), jaune = prudence, vert = à surveiller. Les deux chiffres de volume correspondent à la charge sur 7 jours et sur toute la fenêtre de {{days}} jours pour ce muscle. Une charge lourde soutenue sur un muscle rouge est le signal le plus à risque de cette page.",
        "noPain": "Aucun muscle signalé dans votre carte de douleur",
        "sevRed": "Éviter",
        "sevYellow": "Prudence",
        "sevGreen": "Surveiller"
      },
      "trends": {
        "a11yUp": "progression",
        "a11yFlat": "plateau",
        "a11yDown": "régression",
        "title": "Tendances E1RM",
        "help": "Pour chaque schéma de mouvement (squat, hinge, push, pull, …), affiche l’exercice au meilleur e1RM le plus élevé, en ne comptant que les exercices dont la tendance est lisible : au moins {{points}} points répartis sur au moins {{spanDays}} jours. Graphique = points e1RM sur {{days}} jours (touchez un point pour lire sa valeur et sa date). Flèche = tendance sur ces jours : ↗ progression, → plateau, ↘ régression. Un schéma travaillé où aucun exercice n’atteint ce seuil le dit, au lieu d’afficher un nombre. Un exercice délaissé depuis plus de {{freshDays}} jours cède son schéma à celui travaillé maintenant, et reste derrière lui sur le graphique.",
        "fewData": "Trop peu de données sur {{days}} j",
        "noEligible": "Aucun exercice avec au moins {{points}} points sur {{spanDays}} jours.",
        "notMeasurable": "Pas encore mesurable : aucune série de {{name}} n'est allée près de la limite. Une série menée proche de l'échec (un AMRAP) montrerait la force ici.",
        "machineNotMeasurable": "{{value}}, pas encore mesurable",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Afficher l'autre machine.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Afficher les {{count}} autres machines.",
        "machineSessions_one": "{{count}} séance",
        "machineSessions_other": "{{count}} séances",
        "compareCtaA11y": "Changez l'exercice à comparer avec {{pattern}}",
        "compareSeparator": "vs",
        "compareClearA11y": "Retirez votre comparaison pour {{pattern}} et revenez à celle suggérée",
        "comparedManualA11y": "{{current}} comparé à {{name}}, votre choix",
        "comparedWithA11y": "{{current}} comparé à {{name}}, qui occupait ce mouvement avant"
      },
      "repsAtLoad": {
        "a11yUp": "en hausse",
        "a11yFlat": "stable",
        "a11yDown": "en baisse",
        "title": "Répétitions à charge fixe",
        "help": "Pour les exercices où vous répétez la même charge, ceci suit les répétitions à ce poids fixe sur {{days}} jours : le gain de force que le graphique e1RM ne voit pas sur le haut-répétitions et les machines. Barres = répétitions à la charge, une par séance (touchez une barre pour sa date). Flèche = tendance : ↗ en hausse, → stable, ↘ en baisse. Seules les séries avec l'effort renseigné comptent, ainsi plus de répétitions ne peut pas vouloir dire juste un jour plus facile.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Trop peu de données sur {{days}} j",
        "notMeasurable": "Pas encore mesurable : vos séries de {{name}} à {{load}} n'ont pas l'effort renseigné, donc plus de répétitions pourraient vouloir dire juste un jour plus facile. Une série menée près de l'échec — ou l'effort renseigné — montrerait votre force ici."
      },
      "period": {
        "all": "tout"
      },
      "loadFailed": "Impossible de charger",
      "density": {
        "title": "Densité",
        "help": "Volume divisé par la durée de la séance, kg/min. Se lit comme « à quel point cette séance était dense » : quand ça monte, c’est la même charge en moins de temps (meilleur conditionnement) ou plus de charge dans le même temps (meilleure force). Une chute soudaine sans changement du programme indique souvent de la fatigue : les pauses se sont allongées même sans intention.",
        "empty": "Au moins 3 séances chronométrées pour tracer la densité"
      },
      "frequency": {
        "title": "Exercices les plus négligés",
        "help": "Top 8 des exercices triés par jours depuis la dernière séance, les plus négligés en premier. Le suffixe X/{{days}} j compte les séries des {{days}} derniers jours. Une longue pause signifie qu’il a été retiré intentionnellement ou que le programme a dérivé. Utile pour repérer un travail accessoire qui a discrètement disparu."
      },
      "intensityHeatmap": {
        "title": "Carte d'intensité",
        "help": "Grille par exercice des séries effectuées, classées par plage de répétitions et par intensité (% du 1RM). Plage de force (85%+) en bas à droite, hypertrophie au centre, endurance en haut à gauche. Choisis un exercice pour voir où se concentrent ses séries.",
        "exerciseLabel": "Exercice",
        "choosePrompt": "Choisis un exercice",
        "noEligible": "Enregistre un 1RM sur au moins un exercice pour calculer l'intensité.",
        "noMax": "Aucun 1RM enregistré pour cet exercice.",
        "totalSets": "{{n}} séries · 1RM {{max}}",
        "clear": "Aucun"
      },
      "prTimeline": {
        "title": "Chronologie des PR",
        "help": "Les maxes dans le temps, du plus récent. Testé signifie un PR à une répétition confirmé ; toute autre étiquette est une estimation de départ, pas un max testé.",
        "empty": "Aucun max enregistré.",
        "rowA11y": "{{name}}, {{value}}, {{date}}, {{source}}",
        "truncated_one": "{{cap}} derniers sur {{count}} MAX",
        "truncated_other": "{{cap}} derniers sur {{count}} MAX",
        "source": {
          "manual": "Manuel",
          "tested": "Testé",
          "derived": "Dérivé",
          "calculated_seed": "Valeur de départ",
          "imported": "Importé",
          "unknown": "Inconnu"
        },
        "helpPeriod": "Les maxes établis sur cette période, du plus récent. Testé signifie un PR à une répétition confirmé ; toute autre étiquette est une estimation de départ, pas un max testé.",
        "emptyPeriod": "Aucun max établi sur cette période."
      },
      "a11y": {
        "severityAlarm": "Alarme",
        "severityWarn": "Avertissement",
        "severityInfo": "Info"
      },
      "config": {
        "title": "Personnaliser la progression",
        "open": "Personnaliser la progression",
        "saveError": "Impossible d'enregistrer la disposition de la progression. Réessayez.",
        "widget": {
          "rhythm": "Rythme d'entraînement",
          "prTimeline": "Chronologie des PR",
          "weekStreak": "Série de régularité"
        }
      },
      "coverageRefreshing": "Mise à jour…",
      "report": {
        "open": "Créer un rapport",
        "title": "Rapport d’entraînement",
        "titleOf": "Rapport d’entraînement : {{name}}",
        "period": "du {{from}} au {{to}}",
        "from": "Du",
        "to": "Au",
        "pickA11y": "{{label}} : {{value}}. Changer la date",
        "periodHint": "Toute période jusqu’à {{days}} jours, passé compris.",
        "chooseSections": "Choisir les sections",
        "shareImage": "Partager en image",
        "advanced": "Rapport avancé",
        "pdfExport": "Exporter en PDF",
        "comparePeriods": "Comparer deux périodes",
        "sectionsTitle": "Sections du rapport",
        "advancedSections": "Sections avancées",
        "noSections": "Aucune section choisie. Choisissez les sections pour voir le rapport.",
        "sessions": "Séances sur la période",
        "frequencyHelp": "Séances par semaine sur la période.",
        "premiumHint": "Les options Premium ne font pas partie du rapport de base.",
        "shareNeedsSection": "Choisissez au moins une section pour partager le rapport.",
        "pagesTruncated": "Le rapport partagé s'arrête à {{max}} images. Choisissez moins de sections pour partager le reste.",
        "preparing": "Préparation de l'image {{page}}…",
        "pagesReady": "Les images sont prêtes à partager.",
        "adjustedToday": "Un rapport se termine au plus tard aujourd’hui : la date a été ramenée à aujourd’hui.",
        "adjustedOther": "L’autre date a bougé pour garder la période dans l’ordre.",
        "adjustedCapped": "Un rapport couvre au plus {{days}} jours : l’autre date a bougé.",
        "emptyPeriod": "Aucun entraînement sur cette période."
      },
      "coverageNotConfirmed": "Actualisation impossible — voici les derniers chiffres dont nous disposons"
    },
    "profile": {
      "title": "Profil",
      "navMaxes": "MAX",
      "navMaxesSub": "Définis, modifie et révise tes MAX par exercice.",
      "navCatalogSub": "Parcourez les exercices, records et historique.",
      "navRestTimer": "Minuteurs",
      "navRestTimerSub": "Réglages repos + maintien, son, par exercice",
      "labelEmail": "E-MAIL",
      "labelApp": "VERSION APP",
      "labelBackend": "VERSION BACKEND",
      "labelPrivacy": "CONFIDENTIALITÉ",
      "privacyHelp": "Exporte tout en JSON ou supprime le compte définitivement.",
      "legalLinkHint": "S'ouvre dans le navigateur",
      "exportButton": "Exporter mes données",
      "deleteButton": "Supprimer mon compte",
      "deleteAlertTitle": "Supprimer le compte",
      "deleteAlertBody": "Ton compte, tes séances, tes plans, tes programmes et tes MAX seront supprimés définitivement. Les suppressions ne se récupèrent pas.",
      "deleteAlertCancel": "Annuler",
      "deleteAlertConfirm": "Supprimer",
      "signOut": "Se déconnecter",
      "exportShareTitle": "Export $t(brand.product) {{date}}",
      "labelLanguage": "Langue",
      "languageHelp": "Choisis la langue utilisée dans l'app. Enregistrée sur cet appareil.",
      "languageCancel": "Fermer"
    },
    "summary": {
      "prBadge": "record personnel"
    },
    "logger": {
      "title": "Nouvel entraînement",
      "cancel": "Annuler",
      "swapKindTitle": "Changer de type d'exercice ?",
      "swapKindBody": "Cet exercice se journalise différemment ; les séries déjà enregistrées ici seront effacées.",
      "swapKindConfirm": "Changer et effacer",
      "failConfirmTitle": "Reps valides",
      "failConfirmBody_one": "J'enregistre {{count}} rep propre. Celle ratée ne compte pas.",
      "failConfirmBody_other": "J'enregistre {{count}} reps propres. Celle ratée ne compte pas.",
      "failConfirmHint": "Corrige si tu en as fait plus ou moins.",
      "failConfirmStepDown": "Une rep propre de moins",
      "failConfirmStepUp": "Une rep propre de plus",
      "failConfirmSave": "Enregistrer",
      "amrapConfirmTitle": "Jusqu'à l'échec ?",
      "amrapConfirmBody": "Réponds oui seulement si la répétition suivante ne serait pas passée.",
      "amrapNeedsReps": "Écris les répétitions que tu as faites pour enregistrer la série.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP : au moins {{reps}} répétitions, puis autant que possible",
      "amrapConfirmAtFloor": "Tu as noté {{reps}}, et le programme en demandait au moins {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Oui, jusqu'à l'échec",
      "amrapConfirmNo": "Non, il m'en restait",
      "failBadge": "Ratée",
      "failBadgeA11y": "série ratée",
      "save": "Enregistrer",
      "remove": "Retirer",
      "replace": "Remplacer",
      "addExercise": "Ajouter un exercice",
      "addSet": "Ajouter une série",
      "addRound": "Ajouter un tour",
      "pickerTitle": "Choisir l'exercice",
      "pickerSearch": "Rechercher un exercice",
      "pickerResultsN_one": "{{count}} résultat",
      "pickerResultsN_other": "{{count}} résultats",
      "pickerEmpty": "Aucun exercice trouvé.",
      "pickerClearFilters": "Effacer les filtres",
      "pickerFilters": "Filtres",
      "pickerFiltersN": "Filtres ({{n}})",
      "empty": "Aucun exercice. Ajoutes-en un pour commencer.",
      "setReps": "REPS",
      "amrapPrescribedA11y": "AMRAP : au moins les répétitions prévues, puis autant que possible",
      "setPercentOfMax": "%",
      "prescribedLoadTip": "La charge que tu prescris, dans l'unité du programme. Kilos ou % du maximum, ça se choisit juste en dessous.",
      "setPercentOfMaxA11y": "Pourcentage du maximum",
      "stepAdd": "Augmenter",
      "stepSubtract": "Diminuer",
      "amrapChipPrescribe": "Prescrire le maximum de répétitions",
      "tipAmrapPrescribe": "Demande à l'athlète le maximum de répétitions sur cette série. Le nombre de répétitions reste le minimum à atteindre.",
      "entryNoteEdit": "Modifier la note de l'exercice",
      "entryNoteAdd": "＋ Note d'exercice",
      "setWeightBothSidesA11y": "Poids d'un côté, les deux côtés comptés ({{unit}})",
      "setTypeWorking": "Normal",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Commentaire de la série",
      "unitLabel": "Unité",
      "discardTitle": "Abandonner l'entraînement ?",
      "discardBody": "Tu vas perdre les séries déjà saisies.",
      "discardCancel": "Continuer",
      "discardConfirm": "Abandonner",
      "discardEditTitle": "Abandonner les modifications ?",
      "discardEditBody": "La séance enregistrée reste telle quelle.",
      "discardEditCancel": "Continuer à modifier",
      "errNoEntries": "Ajoute au moins un exercice.",
      "errNoSets": "Chaque exercice doit avoir au moins une série avec reps et poids.",
      "errInvalid": "L'entraînement ne peut pas être enregistré tel quel.",
      "errSaveFailed": "Enregistrement échoué. L'entraînement est toujours là : touche à nouveau Enregistrer.",
      "errNotSignedIn": "Connexion requise. L'entraînement reste ici : enregistre-le quand tu te reconnectes.",
      "errSetsUnknownExercise": "Un exercice de cette séance n'est pas reconnu. Change-le et enregistre à nouveau.",
      "errSetsInvalidTag": "Un tag sur une série n'est pas accepté. Retire-le et enregistre à nouveau.",
      "errSetsInvalid": "Certaines séries ne sont pas valides. Vérifie poids et répétitions, puis enregistre à nouveau.",
      "errSetsNotSaved": "Certaines séries ne sont pas arrivées au serveur. Essaie d'enregistrer à nouveau.",
      "errCorrectionTooBig": "Trop de séries modifiées d'un coup. Enregistre moins de changements, puis le reste.",
      "errCorrectionBusy": "La séance était occupée. Attends un instant et enregistre à nouveau.",
      "errCorrectionConflict": "La séance a changé sur un autre appareil. Ferme-la, rouvre-la et corrige-la à nouveau.",
      "errCorrectionStale": "La séance a été enregistrée à nouveau après son ouverture. Ferme-la, rouvre-la et corrige-la à nouveau.",
      "errCorrectionTimes": "La séance finit avant de commencer. Vérifie début et fin, puis enregistre.",
      "errCorrectionImport": "Cette séance vient de Health Connect et ne se corrige pas ici. Corrige-la dans Health Connect.",
      "errCorrectionGone": "Cette séance a été supprimée sur un autre appareil. La correction n'est pas perdue : retrouve-la en haut d'Entraînements et touche Enregistrer comme nouveau.",
      "errCorrectionGoneHere": "Cette séance a été supprimée sur un autre appareil. La correction n'est pas perdue : touche Enregistrer comme nouveau pour la garder comme nouvelle séance.",
      "correctionToBell": "La correction précédente de cette séance a été refusée, et celle-ci l'a rejointe. Elle n'est pas perdue : retrouve-la en haut d'Entraînements et touche Enregistrer comme nouveau.",
      "setNumberHeader": "SÉRIE",
      "removeSetA11y": "Supprimer cette série",
      "serverErrorTitle": "LE SERVEUR A REJETÉ L'ENREGISTREMENT",
      "serverErrorHint": "Corrige l'entraînement et réessaie. Si le message n'est pas clair, partage-le avec ton coach.",
      "setExtra": "EXTRA",
      "setWeightTip": "Poids soulevé par série. Change kg/lb avec la puce d'unité sur chaque ligne.",
      "setExtraTip": "Assistance ou charge ajoutée au poids du corps. Tape un moins (−) pour l'assistance élastique/machine (le champ devient ambre) ; ceinture/disque ajouté est positif.",
      "setWeightMixedTip": "Groupe mixte : charge barre/stack sur les lignes avec poids, ± extra sur les lignes au poids du corps (moins = assistance).",
      "editTitle": "Modifier l'entraînement",
      "planTitle": "Planifie",
      "programTitle": "Programme",
      "repeatTitle": "Répéter l'entraînement",
      "minimize": "Réduire l'entraînement",
      "closeWorkout": "Fermer l'entraînement",
      "saveWorkout": "Enregistrer l'entraînement",
      "bilateral": "Bilatéral",
      "unilateral": "Unilatéral",
      "plates": "Disques",
      "numInvalid": "Nombre invalide",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Effort 1–10",
      "setNoteLabel": "Note",
      "setNotePlaceholder": "Repère, technique, ressenti…",
      "totalsSets_one": "{{count}} série",
      "totalsSets_other": "{{count}} séries",
      "totalsReps_one": "{{count}} rép",
      "totalsReps_other": "{{count}} réps",
      "totalsTitle": "Totaux de l'entraînement",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Séries",
      "totalsRepsShort": "Réps",
      "totalsByMuscle": "Travail par muscle",
      "restRest": "Repos",
      "startRestManual": "Démarrer le repos",
      "restSkip": "Passer",
      "restWord": "Repos",
      "restAddStep": "+{{n}} secondes",
      "restSubtractStep": "−{{n}} secondes",
      "restStartedA11y": "Repos commencé, {{time}}.",
      "restEndedA11y": "Repos terminé.",
      "restInviteLabel": "Un peu plus de repos ?",
      "restInviteAdd": "+{{time}}",
      "restInviteAddA11y": "Ajouter {{time}} au repos",
      "restInviteA11y": "Un peu plus de repos ? Tu peux ajouter {{time}}.",
      "setsCarriedOverA11y": "Séries reprises de la dernière fois.",
      "restInviteTipTitle": "Pourquoi se reposer plus longtemps ?",
      "restInviteTipBody": "Cette série s'est terminée à l'échec ou presque. Dans les études, un repos plus long après ce genre de série a conservé plus de force pour la suivante. Environ 3 min, jusqu'à 5 sur les charges lourdes. La durée du repos, c'est toi qui décides.",
      "loadBarA11y": "Commandes du poids",
      "restBarA11y": "Minuteur de repos",
      "restRemainingA11y": "{{time}} de repos",
      "restEditA11y": "Définir le repos par défaut pour cet exercice",
      "restEditTitle": "Repos par défaut",
      "restEditBody": "Enregistrer ce repos comme défaut pour {{name}}",
      "restEditSave": "Enregistrer",
      "restEditSaving": "Enregistrement…",
      "restEditError": "Impossible d'enregistrer le repos par défaut. Réessaie.",
      "restEditCancel": "Annuler",
      "restEditSaveAsGlobal": "Définir comme défaut global",
      "restStepMinus": "Diminuer de {{step}} secondes",
      "restStepPlus": "Augmenter de {{step}} secondes",
      "restPause": "Pause",
      "restResume": "Reprendre",
      "restExpiredTitle": "Repos terminé",
      "holdExpiredTitle": "Temps écoulé",
      "restExpiredBody": "On reprend.",
      "holdExpiredBody": "Touche la barre d'effort pour enregistrer la série.",
      "boutExpiredTitle": "Intervalle terminé",
      "boutExpiredBody": "Série enregistrée toute seule.",
      "workStartedTitle": "C'est parti",
      "cueLeadInWork": "Effort — {{n}} s",
      "cueLeadInRest": "Récup — {{n}} s",
      "cueChannel": {
        "tick": "Bips du décompte",
        "work": "Début de l'effort"
      },
      "boutAutoLoggedA11y": "Intervalle terminé, {{time}} enregistrées.",
      "workoutFgsTitle": "Entraînement en cours",
      "workoutFgsBodyNamed": "{{name}} · touchez pour reprendre",
      "workoutFgsBody": "Touchez pour reprendre la séance",
      "descriptionToggle": "Afficher / masquer la description",
      "notesToggle": "Notes pour cette séance",
      "infoButton": "Infos",
      "notesEmpty": "Aucune note pour cette séance",
      "notesProgramLabel": "Programme",
      "notesWorkoutLabel": "Cette séance",
      "note": "Note",
      "rpeChip": "RPE",
      "historyChip": "Historique",
      "more": "Autres actions",
      "addGroup": "Créer un superset avec un autre exercice",
      "cardioDuration": "Durée",
      "cardioDurationPlaceholder": "Secondes",
      "cardioDistance": "Distance",
      "cardioWeight": "Charge",
      "cardioHr": "FC moy",
      "cardioCalories": "Calories",
      "cardioOptionalsShow": "Afficher les autres champs",
      "cardioOptionalsHide": "Masquer les autres champs",
      "dateEditor": "Date et durée",
      "dateLabel": "Date",
      "startTimeLabel": "Début",
      "endTimeLabel": "Fin",
      "durationLabel": "Durée",
      "historyToggle": "Historique",
      "historyBest": "Meilleure",
      "historyCopy": "Copier",
      "historyBodyweight": "{{reps}} reps PdC",
      "historyEstimateHeader": "Estimation à partir d'un exercice similaire",
      "historyEstimatedFrom": "De {{name}}",
      "historyNoEstimate": "Pas encore d'historique, ni d'exercice similaire pour estimer.",
      "copyDialogTitle": "Copier la séance",
      "copyDialogBody": "Remplacer les séries en attente ou les ajouter aux existantes ?",
      "copyOverwrite": "Remplacer",
      "copyAppend": "Ajouter",
      "resumeDiscard": "Abandonner",
      "conflictTitle": "Entraînement en cours",
      "conflictBody": "Tu enregistres déjà un entraînement. Continue ou affiche-le pour l'enregistrer ou l'abandonner.",
      "nameLabel": "Nom du workout",
      "namePlaceholder": "Nom : ex. Push…",
      "editNameA11y": "Modifier le nom de la séance",
      "setStateA11y": "série {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unité {{unit}}",
      "stepperPositive": "ajouter",
      "stepperNegative": "soustraire",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Facile",
      "effortMeterHard": "Difficile",
      "effortWord": "Effort",
      "holdSlotDone": "FAIT",
      "holdSlotHeld": "TENU",
      "holdSlotDoneA11y": "{{time}} fait",
      "holdSlotFailedA11y": "{{time}}, échoué",
      "holdSlotHeldA11y": "{{time}} tenu",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "objectif",
      "effortQuestionRir": "Reps en réserve ?",
      "effortQuestionRpe": "C'était dur ?",
      "effortQuestionHint": "Ouvre l'échelle d'effort — son fonctionnement et comment la changer",
      "effortMeterHintLog": "Enregistre aussi la série comme terminée",
      "effortMeterHintRunning": "Arrête le minuteur et enregistre la série",
      "effortMeterHintEdit": "Met à jour l'effort de cette série enregistrée",
      "effortMeterFailHintLog": "Enregistre la série comme échouée",
      "effortMeterFailHintEdit": "Bascule la série entre terminée et échouée",
      "effortMeterTapCta": "Touche pour enregistrer la série",
      "effortMeterStopCta": "Touche pour arrêter et enregistrer",
      "effortNudgeOptOut": "Désactiver le rappel",
      "effortNudgeOptOutHint": "Une confirmation vous est demandée. Réactivation possible dans les Réglages.",
      "effortNudgeOptOutConfirmTitle": "Désactiver ce rappel ?",
      "effortNudgeOptOutConfirmBody": "Réactivation possible à tout moment dans les réglages.",
      "effortNudgeOptOutConfirmButton": "Désactiver",
      "effortMeterAmrapDone": "Fait",
      "effortMeterAmrapHint": "Enregistre la série à l’échec — aucune répétition en réserve",
      "amrapChip": "Autant de répétitions que possible",
      "burnPlus": "Burn+",
      "burnPlusChip": "Technique d'intensité Burn+ (dropset / myo-rep)",
      "loadAxisTitle": "Ce qui détermine la charge",
      "timedChip": "Chronométré",
      "noteChip": "Note",
      "noteClose": "Terminé",
      "effortLegendA11y": "Aide sur l'échelle d'effort",
      "rirLegendTitle": "RIR : répétitions en réserve",
      "rirLegendBody": "0 = aucune répétition en réserve\n1 = 1 répétition en réserve\n2 = 2 répétitions\n3 = bonne marge — série de travail malgré tout\n4–5 = travail léger, non compté\n6+ = échauffement",
      "rpeLegendTitle": "RPE : effort perçu",
      "rpeLegendBody": "10 = aucune répétition en réserve\n9 = 1 répétition en réserve\n8 = 2 répétitions\n7 = bonne marge — série de travail malgré tout\n5–6 = travail léger, non compté\n4 ou moins = échauffement",
      "timerStartCountdown": "Démarrer le compte à rebours",
      "timerStartCountup": "Démarrer le chronomètre",
      "timerSettings": "Réglages du minuteur pour cet exercice",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Heures",
      "holdMinutes": "Minutes",
      "holdSeconds": "Secondes",
      "holdSubTen": "-10 s",
      "holdAddTen": "+10 s",
      "holdCancel": "Annuler",
      "holdClockElapsedA11y": "{{time}} écoulées",
      "holdClockOvertimeA11y": "{{time}} au-delà de l'objectif",
      "pausedReadoutA11y": "{{label}}, en pause",
      "holdClockRemainingA11y": "{{time}} restantes",
      "holdFlip": "Changer de sens",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · enregistre un côté ; le volume compte les deux (×2).",
      "lateralityTipBi": "BI · charge bilatérale ; le volume compte une fois (×1).",
      "tabExercises": "Exercices",
      "tabSuperset": "Superset",
      "pickerAddN": "Ajouter {{n}}",
      "pickerAlreadyInWorkout": "Déjà dans cette séance",
      "pickerAlreadyInBlock": "Déjà dans ce bloc",
      "pickerPin": "Ajouter aux favoris",
      "pickerUnpin": "Retirer des favoris",
      "noteReadA11y": "Note de l'exercice — touche pour la lire en entier",
      "prescriptionReadA11y": "Consigne de la série — touche pour la lire en entier",
      "tipAmrap": "Autant de répétitions que possible — menez cette série jusqu’à l’échec technique.",
      "tipBurnPlus": "Techniques d’intensité — révélez Dropset ou Myo-rep pour pousser la série au-delà de l’échec.",
      "targetEyebrow": "Cible",
      "historySetCount": "{{n}} dernières séries",
      "historyBlinkToggle": "Clignoter quand un exercice n'a pas été fait depuis longtemps",
      "historyCopyLast": "Copier la dernière séance",
      "historyLooking": "Recherche de cet exercice…",
      "historyUnavailable": "Impossible d'accéder à ton historique pour l'instant — cela ne veut pas dire qu'il n'y en a pas.",
      "historyBlinkOn": "Clignotement activé",
      "historyBlinkOff": "Clignotement désactivé",
      "historyToggleAged": "Historique, dernière fois {{age}}",
      "maxEditNoneA11y": "Définir ton maximum pour cet exercice",
      "maxEditA11y": "Modifier ton maximum",
      "maxEditStaleA11y": "Modifier ton maximum, dernière fois {{age}}",
      "maxHeaderNone": "Pas encore de MAX",
      "maxHeaderValue": "MAX {{weight}}",
      "maxHeaderStale": "MAX {{weight}} · {{age}}",
      "proposedWeightTipTestedMax": "Proposé pour que cette série atteigne {{effort}}, calculé depuis le 1RM que tu as testé. Un point de départ, pas une prescription : change-le.",
      "proposedWeightTipMax": "Proposé pour que cette série atteigne {{effort}}, calculé depuis ton maximum enregistré. Un point de départ, pas une prescription : change-le.",
      "proposedWeightTipHistory": "Proposé pour que cette série atteigne {{effort}}, calculé depuis ta dernière série sur cet exercice. Un point de départ, pas une prescription : change-le.",
      "historySectionComputed": "D'où vient ce poids",
      "historyProposalSource_one": "De ta dernière séance de {{name}}",
      "historyProposalSource_other": "De tes {{count}} dernières séances de {{name}}",
      "historyProposalAxisReps": "Plus de répétitions, même charge",
      "historyProposalAxisLoad": "Plus de charge, mêmes répétitions",
      "historyProposalAxisTrade": "Échange : plus de charge, moins de répétitions",
      "historyInUse": "utilisé",
      "historyCopyWeightA11y": "Utiliser ce poids sur la série en cours",
      "historyCopySetA11y": "Copier cette série sur celle en cours",
      "historyNone": "Tu n'as pas encore enregistré cet exercice.",
      "historySourceTestedMax": "Pour atteindre {{effort}} — depuis le 1RM que tu as testé",
      "historySourceMax": "Pour atteindre {{effort}} — depuis ton maximum enregistré",
      "historySourceLastSet": "Pour atteindre {{effort}} — depuis ta dernière série ici",
      "historySourcePercent": "Un pourcentage de ton maximum, fixé par le programme",
      "historySourcePrescribed": "Le poids écrit dans le programme",
      "historySourceLastWeight": "Le dernier poids que tu as vraiment utilisé ici",
      "historySourceManual": "Celui-ci, tu l'as saisi toi-même",
      "historySourcePercentOf": "{{pct}} % de ton maximum, fixé par le programme",
      "draftToday": {
        "status": "Brouillon · non enregistré",
        "title": "Séance du jour",
        "exercises_one": "{{count}} exercice",
        "exercises_other": "{{count}} exercices",
        "scope": "Pour les muscles sous le volume minimum que tu n'as pas entraînés depuis {{hours}} heures.",
        "scopeMav": "Pour les muscles sous le volume minimum, puis ceux sous le MAV, que tu n'as pas entraînés depuis {{hours}} heures.",
        "scopeAnyway": "Repos ignoré : d'abord les muscles entraînés il y a le plus longtemps.",
        "reason_one": "<b>{{muscle}}</b> : {{n}} série pour le minimum cette semaine",
        "reason_other": "<b>{{muscle}}</b> : {{n}} séries pour le minimum cette semaine",
        "reasonMav_one": "<b>{{muscle}}</b> : {{n}} série sous le MAV cette semaine",
        "reasonMav_other": "<b>{{muscle}}</b> : {{n}} séries sous le MAV cette semaine",
        "lastTrained": "dernière fois {{age}}",
        "noHistory": "Jamais fait · pas encore de reps ni de kg",
        "reps": "reps",
        "painVeto": "Exclus pour ménager {{parts}} (carte de douleur) : {{muscles}}.",
        "source": "Reps : ta meilleure série des 8 dernières semaines. Kg : calculés pour garder 3 reps en réserve. Rien n'est enregistré avant que tu démarres.",
        "discard": "Jeter le brouillon",
        "timeA11y": "Temps disponible",
        "minutes": "{{n}} min",
        "estimate": "~{{n}} min",
        "shuffleRowA11y": "Un autre exercice pour {{muscle}}",
        "shuffleAllA11y": "D'autres exercices pour chaque muscle",
        "shuffleAll": "Tout remélanger",
        "allSets_one": "vaut pour les {{n}} séries",
        "allSets_other": "vaut pour les {{n}} séries",
        "intensityChoice": "{{n}} %",
        "intensityA11y": "Intensité : part du volume hebdomadaire",
        "intensityChipA11y": "{{n}} % du volume hebdomadaire",
        "intensityToday": "aujourd'hui à {{n}} %",
        "surprise": "Surprends-moi",
        "surpriseHint": "Des exercices au hasard plutôt que ceux que tu fais le plus",
        "anchorOwn": "Depuis ta meilleure série, {{date}} · {{age}}",
        "anchorSimilar": "Reps de {{name}} · pas encore de kg pour celui-ci",
        "timeTitle": "Temps (min)",
        "intensityTitle": "Intensité",
        "restTitle": "Repos",
        "restChoice": "{{n}} h",
        "restA11y": "Repos : un muscle entraîné dans ce délai reste de côté",
        "restChipA11y_one": "{{count}} heure",
        "restChipA11y_other": "{{count}} heures",
        "restingUntil": "{{muscles}} : au repos jusqu'au {{day}}",
        "atMinimum": "Chaque muscle est à son minimum hebdomadaire.",
        "buildAnyway": "Construire quand même",
        "newWorkout": "Nouvel entraînement"
      },
      "pin": "Épingler",
      "pinned": "épinglé",
      "hintTitle": "Touche pour remplacer cet exercice.",
      "hintHowTo": "Comment faire cet exercice.",
      "hintTarget": "Séries de la semaine par muscle.",
      "hintTrash": "Retire cet exercice de la séance.",
      "hintClock": "Les séries passées de cet exercice.",
      "hintSuperset": "Superset : associe à un autre exercice et alterne les séries.",
      "hintSupersetCue": "Superset : touche pour passer à l'exercice suivant.",
      "hintSupersetMenu": "Options du superset : ajouter, réordonner, retirer ou dissoudre.",
      "hintWeek": "Touche pour la semaine suivante. Fais glisser la grille pour revenir.",
      "hintTimed": "Chronométré : cette série se tient sur une durée, sans compter les répétitions.",
      "hintNote": "Note : écris une consigne pour cette série.",
      "hintDropsetRemove": "Retour à une seule série de travail.",
      "hintPinOn": "Épinglé : reste au premier plan après la récupération. Touche pour détacher.",
      "hintPinOff": "Épingler : garde cet exercice au premier plan à la fin de la récupération.",
      "holdHintIntro": "Maintiens un bouton pour voir ce qu'il fait.",
      "showHint": "Afficher l'aide",
      "pickerInDays": "Quels jours",
      "pickerAddNInDays_one": "Ajouter {{n}} dans {{count}} jour",
      "pickerAddNInDays_other": "Ajouter {{n}} dans {{count}} jours",
      "repsRangeA11y": "Fourchette de répétitions de {{min}} à {{max}}"
    },
    "coachEdges": {
      "empty": "Aucune relation coach. Un coach peut t'inviter depuis l'app web."
    },
    "recovery": {
      "banner": "Entraînement récupéré",
      "orphanedBanner": "Vous avez corrigé cette séance, mais elle a été supprimée sur un autre appareil. Touchez Enregistrer comme nouveau pour garder votre correction comme nouvel entraînement.",
      "tooBigBanner": "Votre correction modifiait trop de séries pour être enregistrée d'un coup : la séance est restée telle quelle. Touchez Enregistrer comme nouveau pour garder votre version comme nouvel entraînement.",
      "conflictBanner": "La séance a changé sur un autre appareil avant votre correction : elle est restée telle quelle. Touchez Enregistrer comme nouveau pour garder votre correction comme nouvel entraînement.",
      "timesBanner": "Votre correction finit avant de commencer : la séance est restée telle quelle. Touchez Enregistrer comme nouveau, corrigez les horaires, puis enregistrez.",
      "staleBanner": "La séance a été enregistrée à nouveau après le début de la correction. Elle est restée telle quelle. Touchez Enregistrer comme nouveau pour garder votre correction.",
      "refusedBanner": "Le serveur a refusé votre correction : la séance est restée telle quelle. Touchez Enregistrer comme nouveau pour garder votre version comme nouvel entraînement.",
      "saveAsNew": "Enregistrer comme nouveau",
      "title": "Entraînement récupéré",
      "openBody": "Cet entraînement a été interrompu puis récupéré. Vérifie les séries et touche Enregistrer pour le sauvegarder comme nouvel entraînement.",
      "open": "Ouvrir",
      "cancel": "Annuler",
      "liveBusy": "Tu as un entraînement en cours. Enregistre-le ou supprime-le avant de récupérer celui-ci.",
      "discardTitle": "Supprimer l'entraînement récupéré ?",
      "discardBody": "L'entraînement récupéré sera définitivement supprimé.",
      "discardConfirm": "Supprimer",
      "error": "Impossible de récupérer l'entraînement. Réessaie.",
      "mergeTitle": "Fusionner l'entraînement",
      "mergePrompt": "Choisis un entraînement du même jour où fusionner :",
      "noSameDay": "Aucun entraînement du même jour où fusionner. Utilise « Enregistrer comme nouveau ».",
      "nothingToMerge": "Aucune série terminée à fusionner. Utilise « Enregistrer comme nouveau ».",
      "supportPrefix": "Entraînement gardé sur ce téléphone après un plantage, envoyé depuis la cloche. JSON du brouillon en pièce jointe."
    },
    "group": {
      "title": "Grouper cet exercice",
      "close": "Fermer",
      "standalone": "Indépendant",
      "supersetSection": "SUPERSETS",
      "circuitSection": "CIRCUITS",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuit {{n}}",
      "newSuperset": "+ Nouveau superset",
      "newCircuit": "+ Nouveau circuit"
    },
    "webview": {
      "close": "Fermer",
      "openExternal": "Ouvrir dans le navigateur",
      "errorTitle": "La page ne s'est pas chargée",
      "errorBody": "Touche ci-dessous pour essayer dans le navigateur système.",
      "fallbackErrorTitle": "Impossible d'ouvrir le navigateur",
      "fallbackErrorBody": "Réessaie depuis une autre connexion."
    },
    "plates": {
      "title": "Calculateur de disques",
      "close": "Fermer",
      "apply": "Appliquer",
      "targetLabel": "Cible",
      "barLabel": "Barre ({{unit}})",
      "barOptionLabel": "Barre — {{weight}}",
      "barCustom": "Autre…",
      "barCustomLabel": "Poids de barre personnalisé",
      "perSide": "Par côté : {{weight}}",
      "barOnly": "Barre seule — aucun disque.",
      "pairs_one": "{{count}} paire",
      "pairs_other": "{{count}} paires",
      "plates_one": "{{count}} disque",
      "plates_other": "{{count}} disques",
      "loadedSide": "Côté chargé : {{weight}}",
      "singleSideHint": "Un seul côté : les disques se chargent d'un seul côté. Landmine, t-bar, traîneaux et leviers par bras fonctionnent ainsi.",
      "remainder": "Écart de {{weight}} — l'inventaire ne correspond pas exactement.",
      "belowBar": "Cible inférieure au poids de la barre.",
      "invalid": "Saisis un poids valide.",
      "inventoryTitle": "Paires disponibles ({{unit}})",
      "pairsIncrement": "Ajouter une paire de {{weight}}",
      "pairsDecrement": "Retirer une paire de {{weight}}",
      "signLabel": "SIGNE EXTRA",
      "signAdd": "+ Lesté",
      "signAssist": "− Assisté",
      "loadShapeLabel": "Comment ça se charge",
      "loadShapeTwoSides": "Deux côtés",
      "loadShapeOneSide": "Un côté",
      "loadShapeTwoSidesHint": "paires",
      "loadShapeOneSideHint": "pile unique",
      "composeTitle": "Disques ({{unit}}) — touche pour ajouter",
      "composeEmpty": "Aucun disque configuré — indique ci-dessous les paires que tu as.",
      "composeAddPair": "Mettre une paire de {{weight}} sur la barre",
      "composeAddPlate": "Mettre un disque de {{weight}} sur la barre",
      "composeRemovePair": "Retirer une paire de {{weight}} de la barre",
      "composeRemovePlate": "Retirer un disque de {{weight}} de la barre",
      "roundToLoadable": "Arrondir à un poids chargeable",
      "calcOpen": "Calculatrice",
      "calcResult": "Résultat : {{value}} {{unit}}",
      "calcClearKey": "C",
      "calcClear": "Effacer",
      "calcDecimal": "Virgule",
      "calcOpPlus": "Plus",
      "calcOpMinus": "Moins",
      "calcOpTimes": "Fois",
      "calcOpDivide": "Divisé par",
      "calcDismiss": "Fermer",
      "calcCopy": "Copier dans le poids",
      "calcCopyBlocked": "Compose d'abord un poids supérieur à zéro."
    },
    "restTimerScreen": {
      "title": "Minuteurs",
      "back": "Retour"
    },
    "licenses": {
      "title": "Licences open source",
      "back": "Retour",
      "headlineIntro": "$t(brand.product) s'appuie sur un petit ensemble de bibliothèques qui façonnent vraiment l'app. Tape sur une ligne pour ouvrir le projet — et pense à soutenir celles que tu utilises le plus.",
      "coreSection": "Bibliothèques essentielles ({{count}})",
      "viewAllTitle": "Voir tous les paquets",
      "viewAllSub": "Attribution complète pour les {{count}} paquets embarqués dans l'APK, regroupés par projet.",
      "allTitle": "Tous les paquets ({{count}})",
      "searchAll": "Chercher nom, groupe, licence ou auteur",
      "groupOther": "Autres paquets",
      "empty": "Aucun paquet ne correspond à la recherche.",
      "footer": "Généré le {{date}}",
      "openErrorTitle": "Impossible d'ouvrir le lien"
    },
    "share": {
      "newPR": "NOUVEAU PR",
      "topLifts": "TOP EXERCICES",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "séries",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Volume Total",
      "timeLabel": "Temps Total",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulsion",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calories",
      "blockEffort": "Effort",
      "blockDistance": "Distance",
      "effortHr": "{{avg}} moy · {{peak}} pic bpm",
      "effortHrMax": "{{pct}}% FCmax",
      "shareTitle": "Séance $t(brand.product)",
      "shareErrorTitle": "Échec du partage",
      "headlineLabelPR": "NOUVEAU E1RM",
      "headlineLabelDelta": "GRAND BOND +{{delta}}",
      "headlineLabelSolid": "SÉANCE SOLIDE",
      "headlineSolidValue": "{{volume}} en {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} séries",
      "blockTopLifts": "Top exercices",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durée",
      "blockDensity": "Densité",
      "blockNotes": "Notes",
      "barsTitle": "Travail par muscle",
      "bodyTitle": "Muscles sollicités",
      "sharing": "Préparation…",
      "shareCta": "Partager la carte de séance",
      "done": "Terminé",
      "summaryTitle": "Séance enregistrée",
      "maxProposed_one": "Nouveau MAX proposé pour {{exercises}} : il est dans tes notifications.",
      "maxProposed_other": "Nouveaux MAX proposés pour {{exercises}} : ils sont dans tes notifications."
    },
    "common": {
      "back": "Retour",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "close": "Fermer"
    },
    "account": {
      "title": "Compte",
      "labelDiagnostics": "DIAGNOSTIC",
      "navSub": "Nom, mot de passe, export, suppression, déconnexion",
      "nameLabel": "NOM",
      "namePlaceholder": "Votre nom",
      "saved": "Enregistré",
      "passwordLabel": "CHANGER LE MOT DE PASSE",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le nouveau mot de passe",
      "passwordChanged": "Mot de passe modifié.",
      "passwordSubmit": "Mettre à jour le mot de passe",
      "deleteNeedsConnection": "La suppression du compte nécessite une connexion. Reconnecte-toi et réessaie : cette demande n'est jamais mise en attente."
    },
    "prefs": {
      "title": "Unités et affichage",
      "navSub": "Unités, langue, infobulles",
      "unitsLabel": "Unités",
      "unitsHelp": "Unité de poids par défaut pour les nouvelles séries. Tu peux toujours la modifier par ligne dans le logger.",
      "weekStartLabel": "La semaine commence le",
      "weekStartHelp": "Le jour où ta semaine d'entraînement repart. Les objectifs hebdomadaires par muscle comptent à partir de ce jour.",
      "unitsKg": "Kilogrammes (kg)",
      "unitsLb": "Livres (lb)",
      "glucoseUnitsLabel": "Unités glycémie",
      "glucoseUnitsHelp": "Comment la glycémie est affichée et saisie. Stockée pareil dans les deux cas.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Palette du thème",
      "themePaletteHelp": "Choisissez la palette de couleurs utilisée dans toute l'application.",
      "themeModeLabel": "Apparence",
      "themeModeHelp": "Suivre le réglage du système, ou forcer clair ou sombre.",
      "themeMode": {
        "system": "Système",
        "light": "Clair",
        "dark": "Sombre"
      }
    },
    "timeline": {
      "setNumber": "Série {{n}}",
      "fail": "Échec",
      "failTip": "Échec enregistre la série comme tentée mais non terminée. Elle compte quand même comme faite (le minuteur de repos démarre), affiche ✕ dans la timeline et est exclue de votre e1RM.",
      "failTipA11y": "Que signifie Échec ?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% du record",
      "e1rmNewBest": "record",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Dégressif",
      "myorepA11y": "Série myo-reps",
      "dropsetA11y": "Série dégressive",
      "setVolumeA11y": "Volume de la série {{value}} {{unit}}",
      "noBodyweight": "Pas encore de poids corporel",
      "approachBadge": "Échauffement",
      "approachBadgeA11y": "série d'échauffement, non comptée comme série de travail",
      "setSummaryBothSidesA11y": "{{reps}} répétitions à {{weight}} {{unit}} par côté, les deux côtés comptés",
      "e1rmLegendA11y": "Qu'est-ce que l'e1RM ?",
      "e1rmTip": "L'e1RM est ton 1RM estimé pour la série (Epley, reps ≤ 12). « % du record » le compare à ton meilleur e1RM récent — plus bas = marge pour pousser ; ↑ record = nouveau record estimé.",
      "durationLabel": "Durée",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Séance démarrée",
      "addSet": "Ajouter une série",
      "insertSetBefore": "Insérer une série avant la série {{n}}",
      "removeSet": "Retirer une série",
      "prevSet": "Série précédente",
      "nextSet": "Série suivante",
      "allLogged": "Toutes les séries enregistrées — touchez + pour en ajouter.",
      "rosterLabel": "Exercices",
      "rosterHint": "touchez pour changer",
      "focusEmptyHasRoster": "Sélectionne un exercice ci-dessus pour commencer, ou ajoutes-en un nouveau.",
      "focusAllLogged": "Toutes les séries enregistrées. Ajoute un exercice ci-dessus, ou enregistre ci-dessous.",
      "cueNextSet": "→ Série {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Déplier la liste des exercices",
      "rosterCollapseA11y": "Replier la liste des exercices",
      "rosterState": {
        "done": "terminé",
        "inProgress": "en cours",
        "notDone": "à commencer"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} sur {{count}})",
      "exerciseNote": "Note d'exercice",
      "notePlaceholder": "Ajouter une note à la timeline…",
      "noteSend": "Envoyer la note",
      "noteExpandA11y": "Note — touchez pour lire en entier",
      "noteDeleteA11y": "Supprimer la note",
      "uncompleteSetA11y": "Retirer la série {{n}} de {{exercise}} — elle redevient à faire",
      "dropsetActive": "Dropset — modifie les séries ci-dessous.",
      "editingLogged": "Modification de la série {{n}} enregistrée — les changements sont sauvés avec la séance.",
      "addSetLocked": "Modification d'une séance passée : impossible d'ajouter des séries. Corrigez les valeurs ou supprimez une série.",
      "createGroupLocked": "Modification d'une séance passée : impossible de créer un superset.",
      "splitGroupLocked": "Modification d'une séance passée : impossible de dissoudre un superset.",
      "setTypeLocked": "Modification d'une séance passée : impossible de changer le type de série (dropset/myorep).",
      "addStepLocked": "Modification d'une séance passée : impossible d'ajouter une étape au dropset.",
      "setState": {
        "pending": "Série {{n}} sur {{total}}, à faire",
        "done": "Série {{n}} sur {{total}}, terminée",
        "pr": "Série {{n}} sur {{total}}, record personnel",
        "failed": "Série {{n}} sur {{total}}, ratée"
      },
      "holdLabel": "Maintien"
    },
    "home": {
      "targetsTopPatterns": "Schémas principaux",
      "targetsSummary": "{{on}} sur {{total}} dans la cible",
      "targetsHint": "Épingle un programme avec des objectifs hebdomadaires pour les évaluer.",
      "targetsZoneOnTarget": "dans la cible",
      "targetsZoneOver": "au-delà",
      "targetsZoneUnder": "en cours",
      "targetsNoCoverage": "hors programme",
      "targetsIncomplete": "incomplet",
      "targetsIncompleteWhy": "Un exercice enregistré cette semaine n'est pas dans le catalogue, donc ses séries ne comptent pour aucun muscle.",
      "targetsIncompleteNoBodyweight": "Une séance de cette semaine a été enregistrée sans ton poids de corps, donc ses séries au poids du corps comptent pour zéro. L'administrateur la recalcule : tu n'as rien à faire.",
      "targetsIncompleteMayBeHigher": "Le chiffre réel peut être plus élevé.",
      "targetsIncompleteA11y": "Pourquoi incomplet",
      "targetsPrescribed": "prévu {{n}}",
      "targetsEmptyTitle": "Pas encore d'objectifs",
      "targetsEmptySub": "Définis combien tu veux entraîner chaque muscle par semaine. Ton programme y travaille ; le compteur de l'accueil te montre où tu en es.",
      "targetsEmptyCta": "Définir mes objectifs",
      "weekEyebrow": "Cette semaine",
      "weeklySessions": "Entraînements",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} entraînements, {{volume}} de volume",
      "viewProgress": "Voir les progrès",
      "badgesTitle": "Badges",
      "prPrev": "Record précédent",
      "prNext": "Record suivant",
      "prPosition": "Record {{n}} sur {{total}}",
      "eyebrow": "AUJOURD'HUI",
      "blankTitle": "Prêt à t'entraîner ?",
      "blankLoading": "Chargement de ton plan…",
      "blankBody": "Aucun programme actif pour l'instant. La bibliothèque de $t(brand.product) propose des programmes prêts à suivre : un seul appui suffit. Ou lance une séance vierge.",
      "blankLibrary": "Parcourir les programmes prêts à suivre",
      "newWorkout": "Nouvelle séance",
      "programMeta": "{{program}} · Semaine {{week}}",
      "morePreview": " +{{count}} de plus",
      "startToday": "▶ Démarrer la séance",
      "blankInstead": "Lancer plutôt une séance vierge",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps PdC",
      "weightTitle": "Poids corporel",
      "weightSaved": "Enregistré ✓",
      "weightCurrent": "Dernier : {{weight}}",
      "weightNone": "Enregistre ton poids pour suivre les tendances.",
      "weightSave": "Enregistrer",
      "repeatWorkout": "Répéter une séance",
      "form": {
        "title": "Forme",
        "ready": "Prêt",
        "caution": "Prudence",
        "rest": "Repos",
        "reasonNoData": "Enregistre une séance pour suivre ta forme.",
        "reasonBalanced": "Ta charge d'entraînement semble équilibrée.",
        "reasonFreshStart": "Tu reprends — vas-y doucement et construis une base.",
        "reasonShortRest": "Séances rapprochées — surveille ta récupération.",
        "reasonHighFrequency": "Semaine à fort volume — envisage une journée plus légère.",
        "reasonLoadSpike": "Ta charge a fortement augmenté par rapport à ta moyenne récente.",
        "reasonLongGap": "Ça fait un moment — reprends léger pour remonter en charge."
      },
      "glucoseSave": "Enregistrer",
      "weightSaveA11y": "Enregistrer le poids corporel",
      "glucoseSaveA11y": "Enregistrer la glycémie",
      "config": {
        "title": "Personnaliser l'accueil",
        "open": "Personnaliser l'accueil",
        "active": "Actives",
        "inactive": "Inactives",
        "dragHint": "Faites glisser une carte par sa poignée pour la déplacer.",
        "inactiveEmpty": "Rien de masqué. Touchez ✕ sur une carte pour la masquer.",
        "pinned": "Toujours affichée",
        "hide": "Masquer {{name}}",
        "show": "Afficher {{name}}",
        "reorder": "Réordonner {{name}}",
        "reorderKeys": "Réordonner {{name}}, utilisez les flèches",
        "reorderHint": "Faites glisser pour déplacer, ou utilisez les actions pour monter ou descendre.",
        "moveUp": "Monter",
        "moveDown": "Descendre",
        "reset": "Rétablir par défaut",
        "saveError": "Impossible d'enregistrer l'accueil. Réessayez.",
        "widget": {
          "hero": "Aujourd'hui",
          "readiness": "Forme",
          "weeklyTargets": "Cette semaine",
          "quickWeight": "Poids corporel",
          "quickGlucose": "Glycémie",
          "badges": "Badges",
          "coverage": "Couverture musculaire",
          "e1rmTrends": "Tendances E1RM",
          "repsAtLoad": "Répétitions à charge fixe",
          "movementBalance": "Équilibre des mouvements",
          "painVolume": "Douleur × volume",
          "intensityHeatmap": "Carte d'intensité",
          "exerciseFrequency": "Exercices les plus négligés",
          "painMap": "Carte de douleur",
          "measurements": "Mensurations"
        },
        "columnMain": "Colonne principale",
        "columnRail": "Colonne latérale",
        "columnEmpty": "Aucune carte dans cette colonne."
      },
      "painMapEmpty": "Aucune douleur indiquée.",
      "painMapOpenHint": "Ouvre votre carte de la douleur pour la modifier."
    },
    "superset": {
      "startingWith": "Démarrer le superset avec",
      "joinExisting": "Rejoindre un existant",
      "pairInWorkout": "Associer (dans cette séance)",
      "templates": "Supersets enregistrés",
      "templateInsertHint": "Insérer ce superset ; appui long pour supprimer",
      "templateDeleteBody": "Supprimer ce superset enregistré ?",
      "createCta": "Créer un superset ({{n}})",
      "cueCycle": "{{group}}, exercice {{pos}} sur {{total}}. Touchez pour passer à {{next}}.",
      "cueStatic": "{{group}}, exercice {{pos}} sur {{total}}",
      "menuOpen": "Options du superset",
      "menuSaveTemplate": "Enregistrer comme modèle",
      "menuAddExercise": "Ajouter un exercice",
      "menuMoveUp": "Monter",
      "menuMoveDown": "Descendre",
      "menuRemoveMember": "Retirer cet exercice",
      "menuSplit": "Dissoudre le superset",
      "namePlaceholder": "Nom du superset (facultatif)"
    },
    "premium": {
      "badge": "Premium",
      "lockedA11y": "{{name}}, Premium, ne fait pas partie du rapport de base"
    },
    "widgetConfig": {
      "stateClosed": "Fermée",
      "stateOpen": "Ouverte",
      "expand": "Déplier {{name}}",
      "collapse": "Replier {{name}}"
    },
    "bell": {
      "channelName": "Alertes"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Défauts du minuteur de repos",
      "globalLabel": "Défaut global",
      "globalUnset": "Non défini — utilise {{n}}s",
      "customLabel": "Exercices avec un défaut personnalisé",
      "customEmpty": "Aucun remplacement par exercice. Ouvrez le bandeau de repos dans le Logger et touchez ⚙ pour en définir un.",
      "customRemoveA11y": "Supprimer le repos personnalisé pour {{name}}",
      "clearGlobal": "Réinitialiser"
    },
    "hints": {
      "title": "Astuces",
      "label": "Afficher les info-bulles",
      "help": "Maintiens un bouton du logger pour voir ce qu'il fait, ou touche l'en-tête d'une colonne. Désactive pour masquer les info-bulles qui apparaissent d'elles-mêmes."
    },
    "exerciseAgePulse": {
      "label": "Signaler un exercice délaissé",
      "help": "Un clignotement sur la pastille d'historique quand un exercice n'a pas été fait depuis longtemps. Désactivez-le pour garder l'ancienneté sans le clignotement."
    },
    "effortNudge": {
      "label": "Rappel d'effort",
      "help": "Une pulsation rare et discrète sur la barre d'effort quand une série attend d'être enregistrée."
    },
    "inWorkoutMeter": {
      "label": "Compteur d'objectifs en séance",
      "help": "Un bandeau en haut de la carte d'exercice avec l'objectif hebdo des muscles que tu travailles."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Son du minuteur",
      "soundHelp": "Joue lorsque le minuteur de repos se termine.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibre lorsque le minuteur de repos se termine.",
      "previewButton": "Écouter",
      "pickerTitle": "Choisir un son",
      "pickerCancel": "Annuler",
      "category": {
        "serious": "Standard",
        "fun": "Amusants"
      },
      "soundOptions": {
        "none": "Aucun",
        "chime_crisp": "Carillon",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Cloche de méditation",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Ouais !"
      }
    },
    "timerDefaults": {
      "range": "Entrez {{min}}–{{max}} s",
      "globalTitle": "Réglages globaux",
      "restGlobal": "Minuteur de repos",
      "holdGlobal": "Minuteur de maintien",
      "saveRow": "Enregistrer {{label}}",
      "customLabel": "Réglages par exercice",
      "customEmpty": "Aucun réglage par exercice. Touchez + Ajouter.",
      "unset": "Non défini — {{n}} s",
      "add": "+ Ajouter",
      "editRestA11y": "Modifier le repos pour {{name}}",
      "editHoldA11y": "Modifier le maintien pour {{name}}",
      "editA11y": "Modifier les minuteurs de {{name}}",
      "isDefault": "défaut",
      "equalsDefaultHint": "Une valeur égale au réglage global n'est pas enregistrée comme réglage propre.",
      "remove": "Supprimer"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Choisis où cette app écrit",
      "pickLabel": "Écrire mes données sur",
      "pickHelp": "Build dev uniquement. Chaque backend garde sa session, ses files d’attente et son brouillon de séance : changer ne touche jamais l’autre.",
      "stageProduction": "PRODUCTION",
      "stageLab": "LABORATOIRE",
      "liveLabel": "TU ÉCRIS SUR",
      "liveChecking": "Vérification…",
      "liveUnknown": "Inconnu — le backend n’a pas répondu",
      "liveNotProduction": "Ce n’est pas là que vit ton vrai entraînement.",
      "confirmTitle": "Changer de backend ?",
      "confirmBody": "L’app se recharge sur {{stage}}. Il faudra peut-être s’y connecter, et les listes en cache sont jetées.",
      "confirmCta": "Changer",
      "blockedByQueue": "Pas changé : des écritures ne sont pas encore parties. Reviens en ligne et laisse les files se vider."
    },
    "animations": {
      "cellularLabel": "Télécharger les animations sans Wi-Fi",
      "cellularHelp": "Désactivé par défaut. Les animations sont là de toute façon : ceci autorise seulement l'app à les récupérer à l'avance en données mobiles, entre 20 et 30 Mo pour un programme."
    },
    "crashReports": {
      "label": "Envoyer les rapports de plantage",
      "help": "Après un plantage, le lancement suivant envoie à notre serveur ce qui a échoué, où dans le code, la mémoire utilisée et la version de l'app et d'Android. Jamais vos séances, notes, charges ou données de santé."
    }
  },
  "web": {
    "preauth": {
      "tagline": "De la musculation qui se planifie selon ton effort, ton état du moment et le matériel que tu as vraiment.",
      "status": "En développement. Inscriptions fermées.",
      "contactLabel": "Accès ou informations"
    },
    "crash": {
      "body": "L'application a rencontré une erreur inattendue. Tes données enregistrées sont en sécurité — recharge pour continuer.",
      "reload": "Recharger",
      "retryBody": "L'application a rencontré une erreur inattendue. Tes données enregistrées sont en sécurité — réessaie, et si cet écran revient, envoie-nous le message ci-dessous.",
      "retry": "Réessayer"
    },
    "postSession": {
      "headlineLabelPR": "NOUVEAU E1RM",
      "headlineLabelDelta": "GRAND BOND +{{delta}}",
      "headlineLabelSolid": "SÉANCE SOLIDE",
      "headlineSolidValue": "{{volume}} en {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} séries",
      "blockE1rm": "E1RM",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durée",
      "blockDensity": "Densité",
      "barsTitle": "Travail par muscle",
      "bodyTitle": "Muscles sollicités",
      "sharing": "Préparation…",
      "shareCta": "Partager la carte de séance"
    }
  },
  "muscle": {
    "quadriceps": "Quadriceps",
    "hamstrings": "Ischio-jambiers",
    "glutes": "Fessiers",
    "adductors": "Adducteurs",
    "abductors": "Abducteurs",
    "calves": "Mollets",
    "core": "Sangle abdominale",
    "obliques": "Obliques",
    "erectors": "Lombaires",
    "pectoralis": "Pectoraux",
    "anterior-delts": "Deltoïdes antérieurs",
    "lateral-delts": "Deltoïdes latéraux",
    "triceps": "Triceps",
    "lats": "Dorsaux",
    "rhomboids": "Rhomboïdes",
    "rear-delts": "Deltoïdes postérieurs",
    "traps": "Trapèzes",
    "biceps": "Biceps",
    "forearms": "Avant-bras"
  },
  "experience": {
    "menuLabel": "Profil actif",
    "athlete": "Athlète",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Exercice",
    "targetKeyExercise": "Exercice",
    "targetRefAvg": "~{{n}}/sem moy.",
    "targetRefNone": "Aucune donnée sur les 4 dernières semaines",
    "targetRefProgram": "le programme prescrit ~{{n}}/sem",
    "targetUseAvg": "Utiliser la moyenne",
    "targetUseProgram": "Utiliser le programme",
    "projectionTitle": "Répartition des objectifs",
    "projectionWeek": "Semaine {{n}}",
    "projectionContext": "Séries / charge prescrites par le programme en semaine {{n}}.",
    "projectionTarget": "Objectif",
    "projectionWeekTotal": "Sem.",
    "projectionRamp": "Cycle",
    "projectionWeekShort": "S{{n}}",
    "projectionEmpty": "Non prévu",
    "targetsTitle": "Objectifs hebdo",
    "targetsEmptyTitle": "Aucun objectif hebdo",
    "targetsEmptySub": "Ajoutez-en un pour activer la jauge de niveau.",
    "targetAdd": "Ajouter un objectif",
    "targetRemove": "Supprimer l'objectif {{name}}",
    "targetCollapse": "Réduire",
    "targetAxis": "Axe",
    "targetAxisMuscle": "Muscle",
    "targetMetric": "Métrique",
    "targetMetricHardSets": "Séries dures",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Reps",
    "targetKeyMuscle": "Muscle",
    "targetValue": "Objectif hebdo",
    "targetUnitHardSets": "séries dures",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "pas encore dans la jauge",
    "targetNotScoredNote": "Ce type d'objectif n'est pas encore pris en compte par la jauge de niveau.",
    "targetBandLabel": "Tolérance",
    "targetBandAsym": "−{{lo}} % / +{{hi}} %",
    "targetBandBelow": "Pourcentage sous l'objectif",
    "targetBandAbove": "Pourcentage au-dessus de l'objectif",
    "targetBandRange": "En dessous 0–99 %, au-dessus 0 % ou plus.",
    "compose": "Composer",
    "preview": "Aperçu",
    "addExercises": "Ajouter des exercices",
    "editingBlockDay": "Modification de J{{d}} — Mettre à jour s'applique à ce jour (cochez d'autres jours pour l'y appliquer aussi)",
    "editingRampDay": "Progression hebdo sur J{{d}} — la mise à jour s'applique aux semaines sélectionnées, ce jour uniquement",
    "segments": "Segments",
    "rampSwitchHint": "Mettez à jour ou annulez avant de changer de segment",
    "setupHint": "Définissez la forme de départ — vous pourrez ajouter ou retirer des jours et changer les semaines plus tard, dans l'éditeur.",
    "repsHint": "Reps « 5+ » = AMRAP : au moins 5, puis autant que possible.",
    "repsHintA11y": "Comment s'écrivent les répétitions",
    "addingWeek": "Nouvelle semaine W{{n}} — Mettre à jour l'ajoute à cet exercice",
    "cloneWeek": "Cloner la semaine…",
    "cloneWeekFrom": "De",
    "cloneWeekApply": "Cloner",
    "cloneWeekConflict": "{{name}} a déjà du contenu en W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Rien à cloner — choisissez une semaine source remplie et au moins une cible",
    "editingWeekDay": "Modification de W{{n}} sur J{{d}} uniquement — Mettre à jour la détache du segment",
    "perWeek": "Par semaine",
    "dupExercise": "{{name}} est déjà présent en D{{day}} dans les semaines sélectionnées",
    "days": "Jours",
    "weeks": "Semaines",
    "setNote": "Note de la série",
    "removeExercise": "Retirer l'exercice",
    "replaceExercise": "Remplacer l'exercice",
    "clone": "Cloner",
    "remove": "Retirer",
    "removeConfirm": "Confirmer ? ({{n}} cellules)",
    "verbatim": "Slot avancé (multi-variante) — conservé tel quel, non modifiable ici",
    "metaWeeks_one": "{{count}} semaine",
    "metaWeeks_other": "{{count}} semaines",
    "tabPlan": "Plan",
    "importPlanHint": "Ses exercices arrivent dans la journée en cours d'édition, sur toutes les semaines du cycle.",
    "importPlanEmpty": "Aucun plan enregistré.",
    "importPlanMeta_one": "{{count}} exercice",
    "importPlanMeta_other": "{{count}} exercices",
    "importPlanAction_one": "Ajouter {{name}} à cette journée ({{meta}}), sur l’unique semaine du cycle",
    "importPlanAction_other": "Ajouter {{name}} à cette journée ({{meta}}), sur les {{count}} semaines du cycle",
    "removeSlotConfirmTitle_one": "Retirer de cette semaine ?",
    "removeSlotConfirmTitle_other": "Retirer des {{count}} semaines ?",
    "removeSlotConfirm_one": "Retirer {{name}} de cette journée ? Sa prescription de cette semaine sera supprimée.",
    "removeSlotConfirm_other": "Retirer {{name}} de cette journée ? Cela supprime sa prescription sur les {{count}} semaines, pas seulement celle affichée.",
    "metaDays_one": "{{count}} jour d'entraînement",
    "metaDays_other": "{{count}} jours d'entraînement",
    "gridToggle": "Grille d'intensité",
    "addDay": "Ajouter un jour",
    "removeDay": "Supprimer le jour D{{n}}",
    "removeDayConfirm": "Confirmer — supprimer le jour D{{n}} ?",
    "dayEmpty": "Aucun exercice ce jour. Ajoutez-en un pour le composer.",
    "prescribeDayEmpty": "Aucun exercice ce jour.",
    "prescribeFocusEmpty": "Touchez un exercice ci-dessus pour en prescrire les séries.",
    "prescribeViewMatrix": "Matrice",
    "prescribeViewEditor": "Éditeur",
    "prescribeViewGroup": "Changer de vue",
    "checkEmptyCell": "W{{w}}·D{{d}} n'a aucun exercice",
    "checkPctNoMax": "{{name}} utilise %MAX sans MAX enregistré",
    "exerciseNote": "Note pour l'exercice",
    "exerciseNotePlaceholder": "Note pour cet exercice (visible pendant le log)",
    "panelHint": "Touchez un exercice pour modifier, cloner ou retirer",
    "warnLine_one": "{{count}} avertissement",
    "warnLine_other": "{{count}} avertissements",
    "adjacencyWarnLine_one": "{{count}} avertissement de récupération musculaire",
    "adjacencyWarnLine_other": "{{count}} avertissements de récupération musculaire",
    "adjacencyWarnItem": "{{muscle}} entraîné sur des jours adjacents ({{count}}×)",
    "publishChecklist": "Avertissements ouverts (publier quand même est possible)",
    "publishClean": "Aucun avertissement.",
    "weekShort": "Semaine",
    "placed": "actif",
    "notPlaced": "inactif",
    "placementHint": "Maintenez une case appuyée pour y placer ou en retirer {{exercise}}.",
    "addWeek": "Ajouter une semaine vide",
    "removeWeek": "Supprimer la semaine",
    "holdDayToRemoveHint": "Maintenez un jour appuyé pour le supprimer",
    "holdWeekToRemoveHint": "Maintenez une semaine appuyée pour la supprimer",
    "holdAddWeekToCloneHint": "Maintenez W ＋ appuyé pour répéter cette semaine",
    "holdCellToPlaceHint": "Maintenez une case appuyée pour y placer l’exercice",
    "cloneWeekAction": "Ajouter une semaine qui répète celle-ci",
    "removeWeekConfirm": "Confirmer — supprimer cette semaine et ses séries",
    "coverageTitle": "Couverture — séries dures/semaine",
    "coverageHint": "Moyenne sur tout le cycle. Un zéro apparaît ici avant même de l'avoir entraîné.",
    "rosterNotThisWeek": "pas dans cette semaine",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} n'est pas prévu sur {{cursor}}.",
    "prescribeLockedNewFields": "{{exercise}} a des séries par tour, une fourchette de répétitions ou des axes de charge mixtes. Lecture seule ici : modifiez-le sur le téléphone.",
    "prescribePlaceHere": "Placer sur {{cursor}}",
    "placementAddHere": "Placer {{exercise}} ici",
    "placementRemoveHere": "Retirer {{exercise}} d'ici",
    "weekCue": "Semaine {{pos}} sur {{total}}. Touchez pour la semaine suivante.",
    "weekCuePrev": "Semaine précédente",
    "targetRefThisWeek": "cette sem. pour l'instant {{n}}",
    "setNoteChip": "Note",
    "setNoteChipA11y": "Écrire une note sur une série de ce cycle",
    "weekMenuHint": "Ouvre le menu du cycle",
    "weekMenuHoldHint": "Touchez pour le menu du cycle. Maintenez pour le retirer.",
    "setNoteChipLocked": "Visible tant qu'une série a une note",
    "importProgramBack": "Retour aux programmes",
    "importProgramDayHint": "Ses exercices s'ajoutent à la fin du jour que tu modifies. Les tours en trop sont laissés de côté, ceux qui manquent restent vides.",
    "importProgramDayAction": "Ajouter {{day}} de {{program}} à ce jour ({{meta}})",
    "importProgramEmpty": "Pas encore d'autre programme.",
    "importProgramOpen": "{{name}} ({{meta}}) : choisis un jour",
    "importProgramDays_one": "{{count}} jour",
    "importProgramDays_other": "{{count}} jours",
    "importProgramRounds_one": "{{count}} tour",
    "importProgramRounds_other": "{{count}} tours"
  },
  "gym": {
    "setPlace": "Où ?",
    "whichPlace": "Où t'entraînes-tu ?",
    "newPlace": "Ajouter un endroit",
    "fallback": "Par défaut",
    "chipA11y": "Lieu d'entraînement",
    "footnote": "Trie ce que tu vois en premier. Jamais transmis à un coach.",
    "namePlaceTitle": "Nomme cet endroit",
    "namePlaceHint": "Nom de l'endroit",
    "namePlaceSave": "Utiliser cet endroit",
    "pinPlace": "Définir {{place}} comme lieu par défaut",
    "unpinPlace": "Retirer {{place}} comme lieu par défaut",
    "pinHint": "Retient ce lieu comme celui où tu t'entraînes d'habitude.",
    "unpinHint": "Oublie ton lieu par défaut.",
    "pinErrorTitle": "Non enregistré",
    "pinErrorBody": "Ton lieu par défaut est inchangé."
  },
  "inbox": {
    "emptyTitle": "Boîte de réception",
    "emptyBody": "Rien n'attend de réponse pour l'instant.",
    "accept": "Accepter",
    "decline": "Refuser",
    "acknowledge": "Compris",
    "feedback": {
      "statusChanged": {
        "title": "Ton signalement",
        "body": "Ton signalement a été marqué comme {{status}}."
      }
    },
    "sessionCorrection": {
      "orphaned": {
        "title": "Correction en attente sur un autre téléphone",
        "body": "Vous avez corrigé une séance, mais elle a été supprimée sur un autre appareil. Votre correction est toujours sur le téléphone où vous l'avez enregistrée : ouvrez-y les Notifications (la cloche) et touchez Enregistrer comme nouveau."
      }
    },
    "maxBump": {
      "raise": {
        "title": "Nouveau MAX",
        "body": "{{exercise}} : ta séance indique un nouveau MAX de {{suggestedKg}}."
      },
      "lower": {
        "title": "Ton MAX a peut-être baissé",
        "body": "{{exercise}} : ta séance indique {{suggestedKg}}. Ton MAX est de {{currentKg}}, fixé {{weeks}}."
      },
      "confirm": "Confirmer",
      "lowerTo": "Baisser à {{suggestedKg}}",
      "skip": "Passer",
      "keep": "Garder {{currentKg}}",
      "badDay": "Mauvais jour",
      "thisWeek": "cette semaine",
      "weeksAgo_one": "il y a {{count}} semaine",
      "weeksAgo_other": "il y a {{count}} semaines",
      "badDayHint": "Garde ton MAX et ne t'en reparle plus pour cet exercice tant que la baisse ne revient pas."
    },
    "bodyweight": {
      "missing": {
        "title": "Il manque ton poids corporel",
        "body": "Les exercices au poids du corps ont besoin de ton poids pour calculer la charge et le volume. Ajoute-le dans Moi → Mensurations.",
        "cta": "Ajouter le poids",
        "dismiss": "Ne plus me le rappeler"
      }
    },
    "coachEdge": {
      "invitedByCoach": {
        "title": "Invitation d'un coach",
        "body": "Un coach t'a invité à devenir son athlète."
      },
      "invitedByAthlete": {
        "title": "Demande de coaching",
        "body": "Un athlète t'a invité à devenir son coach."
      }
    },
    "assignment": {
      "program": {
        "title": "Nouveau programme",
        "body": "{{from}} veut vous assigner {{itemName}}.",
        "bodySelf": "Vous vous êtes envoyé(e) {{itemName}} en tant que coach — vous pouvez l'accepter ou le refuser ci-dessous."
      },
      "plan": {
        "title": "Nouvelle séance",
        "body": "{{from}} veut vous assigner {{itemName}}.",
        "bodySelf": "Vous vous êtes envoyé(e) {{itemName}} en tant que coach — vous pouvez l'accepter ou le refuser ci-dessous."
      },
      "accepted": {
        "title": "Attribution acceptée",
        "body": "{{itemName}} a été accepté."
      },
      "rejected": {
        "title": "Attribution refusée",
        "body": "{{itemName}} a été refusé."
      }
    },
    "followedProgram": {
      "updated": {
        "title": "Programme mis à jour",
        "body": "{{itemName}} a été modifié par son auteur."
      },
      "removed": {
        "title": "Programme plus partagé",
        "body": "Tu n'as plus accès à {{itemName}}."
      },
      "gone": {
        "title": "Programme supprimé",
        "body": "{{itemName}} a été supprimé par son auteur."
      }
    },
    "followedPlan": {
      "updated": {
        "title": "Plan mis à jour",
        "body": "{{itemName}} a été modifié par son auteur."
      },
      "removed": {
        "title": "Plan plus partagé",
        "body": "Tu n'as plus accès à {{itemName}}."
      },
      "gone": {
        "title": "Plan supprimé",
        "body": "{{itemName}} a été supprimé par son auteur."
      }
    },
    "actionError": "Ça n'a pas fonctionné. Réessaie.",
    "actionErrorItemGone": "Cette proposition n'est plus disponible. Utilise Refuser pour retirer la carte.",
    "bell": {
      "label": "Alertes",
      "title": "Notifications",
      "close": "Fermer les notifications",
      "a11y_one": "{{count}} notification",
      "a11y_other": "{{count}} notifications"
    },
    "actionErrorNoLongerAssigned": "L'expéditeur l'a retirée. Utilise Refuser pour retirer la carte.",
    "actionErrorWrongParty": "Seule la personne invitée peut répondre.",
    "actionErrorFanout": "Impossible de l'ajouter à ta bibliothèque. Réessaie.",
    "loadError": "Impossible de charger tes notifications.",
    "retry": "Réessayer",
    "local": {
      "eyebrow": "Ce téléphone",
      "action": {
        "open": "Ouvrir",
        "hide": "Masquer",
        "retry": "Réessayer",
        "details": "Détails",
        "retrying": "Nouvel essai…",
        "resume": "Reprendre",
        "discard": "Supprimer",
        "merge": "Fusionner",
        "sendSupport": "Envoyer au support",
        "sending": "Envoi…"
      },
      "hcNoConsent": {
        "title": "Health Connect déconnecté",
        "body": "Votre compte n'a aucun consentement pour Health Connect, donc ce téléphone a arrêté d'importer. Ce qu'il a déjà lu attend ici jusqu'à ce que vous vous reconnectiez."
      },
      "hcRefusalTitle": {
        "granted": "Consentement non enregistré",
        "revoked": "Retrait non enregistré",
        "revokedElsewhere": "Health Connect déconnecté"
      },
      "hcDriftTitle": {
        "deviceOff": "Health Connect non autorisé sur ce téléphone",
        "undated": "Confirmez votre consentement à Health Connect",
        "noRecord": "Confirmez votre consentement à Health Connect"
      },
      "hcUpdate": {
        "title": "Mettez à jour Health Connect",
        "body": "$t(brand.product) ne peut pas lire Health Connect tant que vous n'avez pas mis à jour son application."
      },
      "stuckWrites": {
        "title_one": "{{count}} enregistrement n'est pas passé",
        "title_other": "{{count}} enregistrements ne sont pas passés",
        "body": "Ce téléphone a déjà réessayé de lui-même. Réessayez maintenant, ou ouvrez les détails pour voir ce qui n'est pas passé.",
        "bodyStill": "Nouvel essai à l'instant, sans succès. Ouvrez les détails pour voir ce que le serveur a répondu pour chacun."
      },
      "draftResume": {
        "title": "Entraînement non enregistré",
        "body": "L'app s'est fermée pendant votre entraînement du {{date}}, qui est toujours sur ce téléphone. Pour le supprimer, utilisez Supprimer dans Notifications. Touchez pour le reprendre.",
        "discardTitle": "Supprimer cet entraînement ?",
        "discardBody": "Les séries que vous avez notées le {{date}} n'ont jamais été enregistrées. Le supprimer les efface de ce téléphone pour de bon."
      },
      "workoutRecovery": {
        "title": "Entraînement du {{date}} à enregistrer",
        "titleCorrection": "Correction du {{date}} non enregistrée",
        "body": "L'app s'est fermée avant que cet entraînement soit enregistré, et ce téléphone l'a gardé. Séries faites : {{done}} sur {{total}}. Enregistrez-le comme nouvel entraînement, fusionnez-le avec un autre du même jour, ou supprimez-le.",
        "bodySent": "Envoyé au support. L'entraînement reste sur ce téléphone jusqu'à ce que vous l'enregistriez, le fusionniez ou le supprimiez."
      }
    },
    "actionErrorOffline": "Il faut une connexion. Reconnecte-toi et réessaie."
  },
  "editorV3": {
    "addExerciseToRound": "Ajouter {{name}} en W{{n}}",
    "addToRound": "Ajouter en W{{n}}",
    "alignTrimHint": "Retire les séries en trop à la fin. Annuler dans le message les rétablit.",
    "backToDay": "Retour à {{day}}",
    "clear": "Vider le jour",
    "clearBody_one": "{{count}} exercice sera retiré.",
    "clearBody_other": "{{count}} exercices seront retirés.",
    "clearTitle": "Vider {{day}} ?",
    "copyName": "{{name}} (copie)",
    "copyOnto": "Copier sur…",
    "copyOntoBody_one": "{{day}} a {{count}} exercice. Une copie de {{from}} le remplace.",
    "copyOntoBody_other": "{{day}} a {{count}} exercices. Une copie de {{from}} les remplace.",
    "copyOntoFootnote": "Le jour choisi perd ce qu'il contient.",
    "copyOntoQuestion": "Copier {{day}} sur quel jour ?",
    "copyOntoTitle": "Remplacer {{day}} ?",
    "copyRoundBody_one": "{{round}} a {{count}} exercice sur l'ensemble des jours. Une copie de {{from}} le remplace.",
    "copyRoundBody_other": "{{round}} a {{count}} exercices sur l'ensemble des jours. Une copie de {{from}} les remplace.",
    "copyRoundFootnote": "Le cycle choisi perd ce qu'il contient, dans chaque jour.",
    "copyRoundQuestion": "Copier {{round}} sur quel cycle ?",
    "copyRoundTitle": "Remplacer {{round}} ?",
    "dayChipA11y": "Jour {{n}} {{name}}",
    "dayCleared": "{{day}} vidé",
    "dayCopied": "Copié sur {{day}}",
    "dayDuplicated": "Jour dupliqué",
    "dayEmpty": "Pas encore d'exercice dans {{day}}.",
    "dayMenuA11y": "{{day}}, menu du jour",
    "dayName": "Nom du jour",
    "dayRemoved": "{{day}} retiré",
    "daysA11y": "Jours",
    "dissolveSuperset": "Dissoudre le superset",
    "duplicateDay": "Dupliquer le jour",
    "duplicateRound": "Dupliquer le cycle",
    "exerciseMenuA11y": "{{name}}, menu",
    "exerciseRemoved": "{{name}} retiré",
    "exerciseTipA11y": "À propos de {{name}}",
    "historyLoad": "comme la dernière fois",
    "lensA11y": "Lire le jour par",
    "lensExercises": "Exercices",
    "lensRound": "Par cycle",
    "moveDayEarlier": "Déplacer avant",
    "moveDayLater": "Déplacer après",
    "moveRoundEarlier": "Déplacer avant",
    "moveRoundLater": "Déplacer après",
    "notInRound": "Pas dans ce tour",
    "offRoundOnlyInDay": "Le seul exercice de ce jour en W{{n}}",
    "offRoundOnlyRound": "Il ne figure dans aucun autre cycle",
    "remove": "Retirer",
    "removeDay": "Retirer le jour",
    "removeDayBody_one": "Le jour part avec son exercice.",
    "removeDayBody_other": "Le jour part avec ses {{count}} exercices.",
    "removeDayEmptyBody": "Le jour est vide.",
    "removeDayTitle": "Retirer {{day}} ?",
    "removeExerciseBody": "Il quitte ce jour dans tous les tours.",
    "removeExerciseTitle": "Retirer {{name}} ?",
    "removeFromRound": "Retirer de W{{n}}",
    "removeRound": "Retirer W{{n}}",
    "removeRoundBody": "Ses séries quittent chaque jour. Les cycles suivants avancent d'une place.",
    "removeRoundTitle": "Retirer W{{n}} ?",
    "removedFromRound": "{{name}} retiré de W{{n}}",
    "renameDay": "Renommer",
    "renameSuperset": "Renommer le superset",
    "renameTitle": "Renommer {{day}}",
    "replace": "Remplacer",
    "replaceExercise": "Remplacer l'exercice",
    "roundA11y": "Tour {{n}} : {{line}}",
    "roundChipA11y": "Cycle {{n}}",
    "roundCopied": "Copié sur {{round}}",
    "roundDuplicated": "W{{n}} dupliqué",
    "roundLastInDay": "{{name}} est le seul exercice de ce jour en W{{n}}. Retirez plutôt l'exercice ou le cycle.",
    "roundLastOfExercise": "W{{n}} est le seul cycle où figure {{name}}. Retirez plutôt l'exercice.",
    "roundScope": "Répétitions, charge et secondes changent dans ce tour seulement. Axe, limite de temps et séries changent dans tous les tours.",
    "roundScopeLens": "Répétitions, charge, secondes et séries changent dans ce tour seulement. Axe et limite de temps changent dans tous les tours.",
    "alignPadEachRound": "+ Aligner sur la plus longue à chaque tour",
    "alignTrimEachRound": "− Réduire à la plus courte à chaque tour",
    "setsTrimmedEachRound": "Superset créé, séries réduites à la plus courte à chaque tour",
    "roundSetAdded": "W{{n}} : une série de plus",
    "roundSetRemoved": "W{{n}} : une série de moins",
    "roundSetCount_one": "W{{n}} : {{count}} série",
    "roundSetCount_other": "W{{n}} : {{count}} séries",
    "roundOnlySet": "W{{n}} n'a plus qu'une série. Retirez plutôt l'exercice du tour.",
    "roundMixedBound": "W{{n}} inchangé : une série chronométrée et une série en répétitions changeraient de place.",
    "setRangeA11y": "de {{lo}} à {{hi}} séries de",
    "roundsA11y": "Cycles",
    "secondsUnit": "s",
    "setsTrimmed": "Superset créé, séries réduites à {{n}}",
    "supersetN": "Superset {{n}}",
    "supersetName": "Nom du superset",
    "supersetNameHint": "Laissez-le vide pour revenir au numéro.",
    "supersetWithNext": "Superset avec l'exercice suivant",
    "variants": "Alterne avec {{names}}. Pas encore modifiable ici.",
    "problems_one": "{{count}} problème",
    "problems_other": "{{count}} problèmes",
    "problemPrev": "Problème précédent, {{n}} sur {{total}}",
    "problemNext": "Problème suivant, {{n}} sur {{total}}",
    "problemGoA11y": "Problème {{n}} sur {{total}}, {{where}} : {{message}}. Y aller",
    "select": "Sélectionner",
    "selectDone": "Terminé",
    "selectA11y": "Sélectionner des exercices dans {{day}}",
    "selectDoneA11y": "Fin de la sélection dans {{day}}",
    "copyToOtherDays": "Copier dans d'autres jours",
    "copyTo": "Copier dans…",
    "copyToDaysQuestion": "Copier {{what}} dans quels jours ?",
    "copyToDaysFootnote": "Chaque jour reçoit sa propre copie, à la fin. Un superset arrive entier.",
    "copyToDaysNone": "Copier",
    "copyToDaysConfirm_one": "Copier dans {{count}} jour",
    "copyToDaysConfirm_other": "Copier dans {{count}} jours",
    "copiedToDays": "Copié dans {{days}}.",
    "addedOneToDays": "{{name}} ajouté dans {{days}}.",
    "addedManyToDays_one": "{{count}} exercice ajouté dans {{days}}.",
    "addedManyToDays_other": "{{count}} exercices ajoutés dans {{days}}.",
    "addedAgain_one": "{{days}} l'avait déjà : il y est maintenant deux fois.",
    "addedAgain_other": "{{days}} en avait déjà certains : ils y sont maintenant deux fois.",
    "valuesFromRole": "Valeurs selon le rôle du jour.",
    "removeSelectedTitle_one": "Retirer {{count}} exercice ?",
    "removeSelectedTitle_other": "Retirer {{count}} exercices ?",
    "removeSelectedBody_one": "Il quitte ce jour dans tous les tours.",
    "removeSelectedBody_other": "Ils quittent ce jour dans tous les tours.",
    "selectedRemoved_one": "{{count}} exercice retiré",
    "selectedRemoved_other": "{{count}} exercices retirés",
    "nExercises_one": "{{count}} exercice",
    "nExercises_other": "{{count}} exercices",
    "selectedCount_one": "{{count}} sélectionné",
    "selectedCount_other": "{{count}} sélectionnés",
    "programDayImported": "{{day}} de {{program}} ajouté.",
    "roundsDropped_one": "{{rounds}} laissé de côté : ce programme a moins de tours.",
    "roundsDropped_other": "{{rounds}} laissés de côté : ce programme a moins de tours.",
    "daysFull_one": "{{days}} dépasserait {{max}} exercices : rien n'y est ajouté.",
    "daysFull_other": "{{days}} dépasseraient {{max}} exercices : rien n'y est ajouté.",
    "importNothing": "Rien n'a été ajouté : {{day}} n'a pas d'exercice dans les tours de ce programme.",
    "roundTypeMenu": "Type de tour…",
    "roundTypeQuestion": "Quel genre de tour est {{round}} ?",
    "roundTypeNormal": "Normal",
    "roundTypeDeload": "Décharge",
    "roundTypeTest": "Test",
    "roundTypedA11y": "Tour {{n}}, {{type}} : {{line}}",
    "roundChipTypedA11y": "Cycle {{n}}, {{type}}",
    "roundTypeSet": "W{{n}} {{type}}. Appliqué à : tout le programme.",
    "roundRemovedByRules": "W{{n}} retiré. Les cellules à la main après lui suivent leur tour.",
    "roundTypeFootnoteRules": "Le type vaut pour tout le programme. Chaque exercice en reçoit l'effet par sa règle.",
    "rule": {
      "name": {
        "constant": "Constant",
        "effortRamp": "Rampe d'effort",
        "tetrad": "Tétrade, test et décharge",
        "perSet": "Par série",
        "linear": "Linéaire",
        "repsThenLoad": "Répétitions puis charge",
        "triple": "Triple progression",
        "timed": "Au temps",
        "history": "Dernière fois",
        "waves": "Vagues",
        "blocks": "Par blocs",
        "pyramid": "Pyramide",
        "repsUp": "Répétitions croissantes",
        "topBackoff": "Série de tête et dégressives"
      },
      "preset": {
        "linearKg": "Linéaire en kg"
      },
      "manual": "Valeurs à la main",
      "manualBody": "Aucune règle reconnue. Chaque cellule se modifie à la main.",
      "title": "Règle · {{name}}",
      "perRound": "{{step}} par tour",
      "upTo": "{{what}} jusqu'à {{cap}}",
      "ramp_one": "de {{from}} à {{to}} en {{count}} tour",
      "ramp_other": "de {{from}} à {{to}} en {{count}} tours",
      "cycle": "à tour de rôle {{values}}",
      "blocks_one": "{{count}} bloc, qui repart",
      "blocks_other": "{{count}} blocs, chacun repart",
      "threshold": "répétitions de {{min}} à {{max}} par {{step}}",
      "thenSets": "puis séries jusqu'à {{n}}",
      "thenLoad": "puis {{step}}",
      "repsStep": "{{step}} répétitions",
      "amrapInTest": "dernière série AMRAP au tour de test",
      "testLast": "test {{step}} sur la dernière série",
      "testTop": "test {{step}} sur les séries de tête",
      "test": "test {{step}}",
      "deloadPct": "décharge à {{pct}} %",
      "deload": "décharge {{step}}",
      "deloadSets_one": "{{count}} série de moins en décharge",
      "deloadSets_other": "{{count}} séries de moins en décharge",
      "same": "pareil à chaque tour",
      "applied": "Règle changée. Appliqué à : les tours qui la suivent.",
      "appliedMany_one": "Règle appliquée à {{count}} exercice. Appliqué à : les tours qui la suivent.",
      "appliedMany_other": "Règle appliquée à {{count}} exercices. Appliqué à : les tours qui la suivent.",
      "rowRealigned": "Ligne réalignée sur la règle.",
      "roundRealigned": "{{round}} réaligné sur la règle.",
      "blockAdded": "{{from}} à {{to}} ajoutés.",
      "byHand": "{{round}} série {{set}} : écrit à la main. Appliqué à : ici seulement.",
      "followsAgain": "Suit de nouveau la règle.",
      "handCount_one": "{{count}} cellule à la main",
      "handCount_other": "{{count}} cellules à la main",
      "handDone_one": "{{count}} à la main dans les tours faits",
      "handDone_other": "{{count}} à la main dans les tours faits",
      "realign": "Réaligner",
      "realignHint": "Chaque cellule revient à la règle",
      "change": "Changer la règle",
      "byHandMark": "à la main",
      "realignRound": "Réaligner {{round}} sur la règle",
      "typedStays": "La valeur écrite ici reste la tienne : la règle ne la réécrit pas.",
      "addBlock_one": "{{count}} tour",
      "addBlock_other": "{{count}} tours",
      "blockAdd_one": "Ajouter {{count}} tour",
      "blockAdd_other": "Ajouter {{count}} tours",
      "blockTitle": "Ajouter {{from}}-{{to}}",
      "blockShape": "Une tétrade de plus : deux tours normaux, un tour de test, un tour de décharge.",
      "blockCarry": "Les lignes en kilos et en répétitions continuent d'où elles étaient.",
      "blockEffort": "Les lignes à l'effort répètent leur forme. La charge monte avec le MAX mesuré au tour de test.",
      "sheetTitle": "Règle",
      "sheetTitleMany_one": "Règle pour {{count}} exercice",
      "sheetTitleMany_other": "Règle pour {{count}} exercices",
      "apply": "Appliquer",
      "presets": "Modèles",
      "changes": "change",
      "roundsChange_one": "{{count}} tour change.",
      "roundsChange_other": "{{count}} tours changent.",
      "alsoTitle": "Appliquer aussi à :",
      "alsoSame": "Même exercice, autres jours",
      "alsoOthers": "Autres exercices",
      "alsoShowAll": "Tout afficher",
      "alsoShowLess": "Afficher moins",
      "alsoEach": "Chaque exercice garde ses propres valeurs de départ.",
      "lostTest": "Pas d'AMRAP au tour de test.",
      "lostTestMany": "Pas d'AMRAP au tour de test pour : {{names}}.",
      "lostDeload": "Pas de décharge.",
      "lostDeloadMany": "Pas de décharge pour : {{names}}.",
      "stallNever": "La charge ne monte jamais sur ces tours.",
      "stallAt": "La charge ne monte pas sur ces tours. Première hausse : {{round}}.",
      "noRoundChanges": "Aucun tour ne change.",
      "handStays_one": "La {{count}} cellule à la main reste.",
      "handStays_other": "Les {{count}} cellules à la main restent.",
      "supersetFollows": "Le superset prend le même nombre de séries.",
      "undoable": "Annuler le rétablit.",
      "waveLess": "Une valeur de moins dans le cycle",
      "waveMore": "Une valeur de plus dans le cycle",
      "selectionAction": "Règle",
      "field": {
        "sets": "Séries",
        "reps": "Répétitions",
        "effort": "Effort",
        "step": "Pas par tour",
        "cap": "Plafond",
        "load": "Depuis",
        "deloadPct": "Décharge",
        "repsMin": "Rép. min",
        "repsMax": "Rép. max",
        "repsStep": "Pas rép.",
        "loadStep": "Puis",
        "seconds": "Secondes",
        "efforts": "Efforts du cycle",
        "setsMax": "Séries jusqu'à",
        "repsSetStep": "Rép. par série",
        "loadSetStep": "Charge par série",
        "backoffSets": "Séries dégressives",
        "topEffort": "Effort de tête",
        "backoffEffort": "Effort dégressif",
        "off": "Aucun"
      },
      "backoff": "séries dégressives {{step}}",
      "eachSet": "chaque série {{steps}}",
      "handAxisResets_one": "{{count}} valeur saisie à la main est remplacée : la nouvelle règle utilise une autre unité.",
      "handAxisResets_other": "{{count}} valeurs saisies à la main sont remplacées : la nouvelle règle utilise une autre unité.",
      "lockedStay": "Fait jusqu'à {{round}} : ces tours restent tels quels.",
      "reference": "réf. ≈ {{load}}",
      "pickPreset": "Aucun modèle n'écrit cette règle. Choisissez-en un pour la remplacer.",
      "pickPresetManual": "Aucune règle reconnue. Choisissez un modèle pour remplacer les valeurs saisies à la main.",
      "blockFull": "Un programme compte au plus {{max}} tours : il n'y a pas de place pour une autre tétrade."
    },
    "tetrad": {
      "scratchTitle": "De zéro",
      "scratchBody": "Un jour vide et quatre tours.",
      "rounds": "Tours",
      "roundsA11y_one": "{{count}} tour",
      "roundsA11y_other": "{{count}} tours",
      "perWeek": "Séances par semaine",
      "perWeekA11y_one": "{{count}} séance par semaine",
      "perWeekA11y_other": "{{count}} séances par semaine",
      "dayEmpty": "Aucun exercice : le jour en demande au moins un.",
      "removeExercise": "Retirer {{name}}",
      "back": "Retour",
      "needName": "Donnez d'abord un nom au programme.",
      "needDay": "Chaque jour demande au moins un exercice : remettez-en un.",
      "putBack": "Remettre {{name}}",
      "takenOut": "retiré"
    },
    "model": {
      "fromModel": "À partir d'un modèle",
      "fromModelBody": "Le modèle écrit les jours et les tours. Vous choisissez le niveau, le temps par séance et les exercices.",
      "fromTemplate": "À partir d'un template",
      "fromTemplateBody": "Une copie d'un programme public, à modifier à votre guise.",
      "noModel": "Pas encore de modèle.",
      "noTemplate": "Pas encore de template.",
      "loading": "Chargement…",
      "loadError": "Chargement impossible. Touchez pour réessayer.",
      "level": "Niveau",
      "minutes": "Minutes par séance",
      "minutesA11y_one": "{{count}} minute",
      "minutesA11y_other": "{{count}} minutes",
      "minutes45": "Pas d'exercices facultatifs, et une série de moins sur les accessoires.",
      "minutes60": "Pas d'exercices facultatifs.",
      "minutes75": "Tous les exercices du modèle.",
      "rotateHint_one": "Le jour se répète : un tour dure {{length}} jours.",
      "rotateHint_other": "Les {{count}} jours alternent : un tour dure {{length}} jours.",
      "blocksHint_one": "Le modèle tourne une fois.",
      "blocksHint_other": "Le modèle tourne {{count}} fois : chaque fois repart une marche plus haut.",
      "swapA11y_one": "{{name}}. Le remplacer par l'alternative",
      "swapA11y_other": "{{name}}. Le remplacer par l'une des {{count}} alternatives",
      "alternatives": "Alternatives",
      "alternativesCount_one": "{{count}} alternative",
      "alternativesCount_other": "{{count}} alternatives"
    },
    "roundLocked": "W{{n}} est déjà fait : il reste tel quel.",
    "lock": {
      "unlock": "Déverrouiller",
      "unlockA11y": "Déverrouiller les tours déjà faits",
      "title": "Déverrouiller les tours faits ?",
      "body": "Les séances déjà faites relisent leur prescription dans le programme : modifier {{rounds}} change ce que l'historique dit avoir été prescrit. Ils restent déverrouillés jusqu'à la fermeture de l'éditeur.",
      "done": "fait",
      "doneA11y": "fait, lecture seule",
      "offDone": "Pas dans ce tour, et il est déjà fait : déverrouillez en haut pour ajouter l'exercice.",
      "readOnly": "{{round}} est fait : lecture seule. Déverrouillez-le en haut de l'éditeur.",
      "range": "{{from}}-{{to}}"
    },
    "grid": {
      "structure": "Structure",
      "exercise": "Exercice",
      "lensEffort": "Effort",
      "lensReps": "Répétitions",
      "lensLoad": "Charge",
      "lensSets": "Séries",
      "dayPeak": "Pic",
      "dayPeakA11y": "Pic : {{band}}",
      "setsFieldA11y": "{{name}}, {{round}} : séries de ce tour",
      "setsNote": "Saisissez les séries d'un tour : le changement vaut pour ce tour seulement, sur tout le superset.",
      "lensA11y": "Afficher dans la grille",
      "roundHeadA11y": "{{round}}, menu du tour",
      "cellA11y": "{{name}}, {{round}} : {{line}}",
      "note": "Une lentille à la fois. « Charge » montre le poids écrit, ou ≈ la charge tirée de votre MAX pour une ligne à l'effort. Touchez une case pour l'ouvrir à droite.",
      "pickExercise": "Choisissez un exercice dans la grille pour le voir ici."
    }
  }
}
